<template>
  <div id="planning" :class="{'planning-off': isPlanningOff}">

    <!-- プランニング用header -->
    <dd-header
     :showUpside="false"
     :isDispMenu="isDispMenu"
     :isDispContent="isDispContent"
     @onClickMenuToggle="onClickMenuToggle"
     @onClickContentToggle="onClickContentToggle"
     @onShowModal="removePlanningEventListener"
     @onCloseModal="addPlanningEventListener"
    />

    <header>
      <!-- ヘッダーメニュー -->
      <dd-header-menu
        ref="dd-header-menu"
        :fileData= "fileData"
        :isDispMenu="isDispMenu"
        :opeMode="opeMode"
        :selectModeList="selectModeList"
        :isSpaceSelected="groupCtrlSpace && Object.keys(groupCtrlSpace).length > 0"
        :isCabinetMultiSelected="isCabinetMultiSelected"
        :editCtrlSpaces="editCtrlSpaces"
        :editChildrenDoor="editChildrenDoor"
        :isPlan="isPlan"
        :isPreviewFile="isPreviewFile"
        :isPlanning="isPlanning"
        :isActiveSetCell="isSelectedOneRelatedToShelfOnCanvas"
        @undo="undo"
        @redo="redo"
        @onNew="onNew"
        @onSave="onSave"
        @onPreview="onPreview"
        @deleteSpace="deleteSpace"
        @showSetCellRatioModal="showSetCellRatioModal"
        @showStyleColorModal="showStyleColorModal"
        @showEditFileModal="showEditFileModal"
        @showProfitSettingModal="showProfitSettingModal"
        @showCostCustomModal="showCostCustomModal"
        @showSetSizeModal="showSetSizeModal"
        @resizeSpacesEven="resizeSpacesEven"
        @addSetPlan="addSetPlan"
        @showSetDoorWrapModal="showSetDoorWrapModal"
        @getEditingFileDataWithLoadingModal="getEditingFileDataWithLoadingModal"
        @changeFaceDistanceMode="changeFaceDistanceMode"
        @onSelectModeChanged="onSelectModeChanged"
        @setOpeMode="setOpeMode"
        @changeAutoUpdateMode="changeAutoUpdateMode"
        @onClickMenuToggle="onClickMenuToggle"
      />

      <!--
        カメラ位置設定
        このModalを導入する以前のoutputCgメソッドに
        "corpIdは別途修正入れる予定"
        とのコメントあり
      -->

      <!-- ツールバー -->
      <div class="tool-bar-item" v-if="isDispContent">
        <ul>
          <li class="container tool">
            <ul>
              <li><p>表示対象&nbsp;&#58;</p></li>
              <li class="checkbox" v-for="(objectType, idx) in dispSpaceObjectTypesList" :key="objectType.code">
                <input
                  type="checkbox"
                  :id="'display_ch_' + idx"
                  :value="objectType.code"
                  v-model="dispSpaceObjectTypes"
                  @change="onDispSpaceObjectTypesChanged" />
                <label :for="'display_ch_' + idx">{{ objectType.label }}</label>
              </li>
              <li class="checkbox">
                <input type="checkbox" id="display_ch_process" v-model="isDispProcess" @change="onDispProcessChanged" />
                <label for="display_ch_process">加工</label>
              </li>
              <li class="checkbox">
                <input type="checkbox" id="display_ch_accessory" v-model="isDispAccessory" @change="onDispAccessoryChanged" />
                <label for="display_ch_accessory">アクセサリー</label>
              </li>
              <li class="checkbox">
                <input type="checkbox" id="display_ch_dummy" v-model="isDispDummy" @change="onDispDummyChanged" />
                <label for="display_ch_dummy">ダミー</label>
              </li>
            </ul>
          </li>
          <li id=menu_toggle>
            <span>
              <i>
                <img :src="getImage('pages/planning/ic_menu_on.svg')" alt="toggle" width="24px" height="auto"  @click="onClickContentToggle(false)">
              </i>
            </span>
          </li>
        </ul>
      </div>
    </header>

    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- カラースタイル設定 -->
    <dd-style-color-modal
      ref="styleColorModalRef"
      :fileData="fileData"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
    />
    <!-- セル比率設定 -->
    <dd-set-cell-ratio-modal
      ref="setCellRatioModalRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      :isSelectedOneRelatedToShelfOnCanvas="isSelectedOneRelatedToShelfOnCanvas"
      :globalSpaceMap="globalSpaceMap"
      @setResponseData="setResponseData"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
      @setEditTargetCellSpaceParent="setEditTargetCellSpaceParent"
    />
    <!-- 被せ設定 -->
    <dd-set-door-wrap-modal
      ref="setDoorWrapModalRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :globalSpaceMap="globalSpaceMap"
      @setResponseData="setResponseData"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- 保存ファイルモード選択 -->
    <dd-select-save-type-modal
      ref="SelectSaveTypeModalRef"
      :fileData="fileData"
      @onSaveAs="onSaveAs"
    />
    <!-- 上書き保存・名前を付けて保存選択 -->
    <dd-select-update-insert-modal
      ref="selectUpdateInsertModalRef"
      :fileData="fileData"
      @saveFileData="saveFileData"
      @onSaveAs="onSaveAs"
    />
    <!-- ファイル新規登録・編集 -->
    <dd-file-modal
      ref="fileModalRef"
      :series="series"
      :forceUpdate=false
      :globalSpaceMap="globalSpaceMap"
      @setResponseData="setResponseData"
      @setSectionPosition="setSectionPosition"
      @clearSpaceTreeFlg="clearSpaceTreeFlg"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeSelectSpaceModal="closeSelectSpaceModal"
      @getAllFileList="getAllFileList"
      @showNewBusinessModal="showNewBusinessModal"
      @showEditBusinessModal="showEditBusinessModal"
      @closeSelectUpdateInsertModal="closeSelectUpdateInsertModal"
      @onSave="onSave"
    />
    <!-- 掛け率設定ダイアログ -->
    <dd-profit-setting-modal
      ref="profitSettingRef"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- 見積価格設定 -->
     <dd-set-cost-custom-modal
      ref="setCostCustomModalRef"
      :fileData="fileData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <dd-face-distance-move-modal
      ref="faceDistanceMoveModalRef"
      :selectedFaces="selectedFaces"
      :isPlanning="isPlanning"
      :globalSpaces="globalSpaceMap.get(viewSet.main.viewType)"
      @setResponseData="setResponseData"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @changeFaceDistanceMode="changeFaceDistanceMode"
    />
    <!-- サイズ設定 -->
     <dd-set-size-modal
      ref="setSizeModalRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :editChildrenDoor="editChildrenDoor"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- 選択パーツ設定 -->
     <dd-set-select-parts-modal
      ref="setSelectPartsRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      :isOneUnitSelected="isOneUnitSelected"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @showLoadingModal="showLoadingModal"
      @closeLoadingModal="closeLoadingModal"
      @closeTreeContextModal="closeTreeContextModal"
     />
      <!-- 移動設定 -->
     <dd-set-moving-modal
      ref="setMovingModalRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :globalSpaceMap="globalSpaceMap"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- カラー設定 -->
     <dd-set-color-modal
      ref="setColorModalRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      :ownColorStyle="ownColorStyle"
      :series="series"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 納入先設定 -->
    <dd-business-modal
      ref="businessModalRef"
      @getBusinessList="getBusinessList"
    />
    <!-- 加工設定 -->
     <dd-face-option-modal
      ref="setFaceOptionRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 加工ルール設定 -->
     <dd-pos-rule-modal
      ref="setPosRuleRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
      @changeFocusProcess="changeFocusProcess"
    />
    <!-- 木目設定 -->
     <dd-el-grain-modal
      ref="setElGrainRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 素材空間設定 -->
     <dd-material-modal
      ref="setMaterialRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- カウンター/サーフェス収まり設定 -->
     <dd-surface-ledge-modal
      ref="setSurfaceLedgeRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 指定パーツ位置設定 -->
    <dd-parts-facerelation-modal
      ref="setPartsFacerelationRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      :globalSpaceMap="globalSpaceMap"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @setFrDistGuideLine="setFrDistGuideLine"
      @clearFrDistGuideLine="clearFrDistGuideLine"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 特注価格設定 -->
     <dd-custom-price-modal
      ref="setCustomPriceRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- 任意コメント設定 -->
     <dd-custom-comment-modal
      ref="setCustomCommentRef"
      :fileData="fileData"
      :editCtrlSpaces="editCtrlSpaces"
      :focusedMenuSpace="focusedMenuSpace"
      @setResponseData="setResponseData"
      @handleErrorMessage="handleErrorMessage"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
      @closeTreeContextModal="closeTreeContextModal"
    />
    <!-- スケッチオーダーカート挿入モーダル -->
    <dd-sketch-add-cart-modal
      ref="sketchAddCartRef"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- スケッチオーダー 情報モーダル -->
    <dd-sketch-view-modal
      ref="sketchViewRef"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- 公開申請モーダル -->
    <dd-mmstyle-request-modal
      ref="mmstyleRequestRef"
      @onShowModal="removePlanningEventListener"
      @onCloseModal="addPlanningEventListener"
    />
    <!-- コンテキストメニュー(右クリックメニュー) -->
    <dd-context-menu
      ref="contextMenuRef"
      :isSpaceSelected="groupCtrlSpace && Object.keys(groupCtrlSpace).length > 0"
      :isSpaceCopied="copiedSpaceIds && copiedSpaceIds.length > 0"
      :isCabinetMultiSelected="isCabinetMultiSelected"
      :isRuledSetTargetSelected="isRuledSetTargetSelected"
      :isOneSkeltonSelected="isOneSkeltonSelected"
      :isOneCombineSelected="isOneCombineSelected"
      :isOneSetPlanSelected="isOneSetPlanSelected"
      :isSelectedOneRelatedToShelfOnCanvas="isSelectedOneRelatedToShelfOnCanvas"
      :isOneUnitSelected="isOneUnitSelected"
      :isDoorSelected="isDoorSelected"
      :isPlanning="isPlanning"
      :isFocusedUnit="isFocusedUnit"
      :isFocusedParts="isFocusedParts"
      :isFocusedPartsParent="isFocusedPartsParent"
      :isFocusedSurface="isFocusedSurface"
      :isFocusedMobileShelfParts="isFocusedMobileShelfParts"
      :isFocusedUmcodeSpace="isFocusedUmcodeSpace"
      :isFocusedOneRelatedToShelf="isFocusedOneRelatedToShelf"
      :opeMode="opeMode"
      :selectModeList="selectModeList"
      :editCtrlSpaces="editCtrlSpaces"
      :editChildrenDoor="editChildrenDoor"
      :activeSectionPoint="activeSectionPoint"
      @copySpace="copySpace"
      @pasteSpace="pasteSpace"
      @deleteSpace="deleteSpace"
      @setSectionPositionSelectingOn="setSectionPositionSelectingOn"
      @addSheetSection="addSheetSection"
      @removeSheetSection="removeSheetSection"
      @resetView="resetView"
      @setOpeMode="setOpeMode"
      @showSetCellRatioModal="showSetCellRatioModal"
      @onSelectModeChanged="onSelectModeChanged"
      @changeFaceDistanceMode="changeFaceDistanceMode"
      @showSetDoorWrapModal="showSetDoorWrapModal"
      @resizeSpacesEven="resizeSpacesEven"
      @showSetSizeModal="showSetSizeModal"
      @showSetSelectPartsModal="showSetSelectPartsModal"
      @showSetMovingModal="showSetMovingModal"
      @showSetColorModal="showSetColorModal"
      @addSetPlan="addSetPlan"
      @addRuledSetPlan="addRuledSetPlan"
      @addCombine="addCombine"
      @decomposeSpace="decomposeSpace"
      @selectAllSpace="selectAllSpace"
      @showFaceOptionModal="showFaceOptionModal"
      @showPosRuleModal="showPosRuleModal"
      @showElGrainModal="showElGrainModal"
      @showMaterialModal="showMaterialModal"
      @showSurfaceLedgeModal="showSurfaceLedgeModal"
      @showCustomPriceModal="showCustomPriceModal"
      @showCustomCommentModal="showCustomCommentModal"
      @showUpdateByUmcodeModal="showUpdateByUmcodeModal"
      @clearFocusedParts="clearFocusedParts"
      @showPartsFacerelationModal="showPartsFacerelationModal"
    />

    <!-- ファイルデータD&D時の四角 -->
    <div id="stalking-rect" />

    <div id="container-main" class="container_main" v-bind:style="{height : 'calc(100% - ' + canvasHeight + 'px)'}">

      <!-- 左部サイドバー -->
      <nav id="side_tab_nav" class="sidebar_left" v-if="isDispSideTab" v-bind:style="{width : canvasWidth + 'px'}"
        v-bind:class="{'sidebar_left2': isOrder}">

        <div id="main_tab_contents_area">
          <!-- ユニット -->
          <div class="main_tab_contents show" v-show="isTabMenuUnit">
            <dd-select-unit
              v-if="!isOrder"
              ref="selectUnit"
              :canSpaceEdit=true
              :targetSpaceJoincd="fileData && Object.keys(fileData).length > 0 ? fileData.spaceJoincd : ''"
              :isTabHide=true
              :isLoading=false
              :isLoadingFileList=false
              :sideWidth=canvasWidth
              @setDraggedFileData="setDraggedFileData"
              @onClickEdit="onClickEdit"
              @onClickDeleteFile="onClickDeleteFile"
              @onClickSketchAddCart="onClickSketchAddCart"
              @onClickSketchView="onClickSketchView"
              @onClickMmstyleRequest="onClickMmstyleRequest"
              @onClickMmstyleCancel="onClickMmstyleCancel"
              @scrollTab="scrollTab"
              @setTabScroll="setTabScroll"
              @setSelectSeries="setSelectSeries"
              @showEditFileModal="showEditFileModal"
              @showContentsDataModal="showContentsDataModal"
              @onClickSideTabToggle="onClickSideTabToggle"
              @onShowModal="removePlanningEventListener"
              @onCloseModal="addPlanningEventListener"
            />
            <dd-select-unit2
              v-else
              ref="selectUnit"
              :canSpaceEdit=true
              :targetSpaceJoincd="fileData && Object.keys(fileData).length > 0 ? fileData.spaceJoincd : ''"
              :isTabHide=true
              :isLoading=false
              :isLoadingFileList=false
              :sideWidth=canvasWidth
              @setDraggedFileData="setDraggedFileData"
              @onClickEdit="onClickEdit"
              @onClickDeleteFile="onClickDeleteFile"
              @onClickSketchAddCart="onClickSketchAddCart"
              @onClickSketchView="onClickSketchView"
              @onClickMmstyleRequest="onClickMmstyleRequest"
              @onClickMmstyleCancel="onClickMmstyleCancel"
              @scrollTab="scrollTab"
              @setTabScroll="setTabScroll"
              @setSelectSeries="setSelectSeries"
              @showEditFileModal="showEditFileModal"
              @showContentsDataModal="showContentsDataModal"
              @onClickSideTabToggle="onClickSideTabToggle"
              @onShowModal="removePlanningEventListener"
              @onCloseModal="addPlanningEventListener"
            />
          </div>
          <!-- 構成 -->
          <div class="main_tab_contents" id="tab_content_tree" v-show="isTabMenuTree">
            <dd-space-tree
              ref="spaceTreeRef"
              :fileDataProp="fileData"
              :focusedMenuSpace="focusedMenuSpace"
              :isFocusedUnit="isFocusedUnit"
              :isFocusedParts="isFocusedParts"
              :isFocusedPartsParent="isFocusedPartsParent"
              :isFocusedSurface="isFocusedSurface"
              :isFocusedMobileShelfParts="isFocusedMobileShelfParts"
              :isFocusedUmcodeSpace="isFocusedUmcodeSpace"
              :isFocusedOneRelatedToShelf="isFocusedOneRelatedToShelf"
              :price="price"
              @setFocusedSpace="setFocusedSpace"
              @setSelectedSpace="setSelectedSpace"
            />
          </div>
          <!-- 情報 -->
          <div class="main_tab_contents" id="tab_content_info" v-show="isTabMenuInfo">
            <div class="plain_text debug">
              操作モード：<br>
              {{ opeMode }}
              <hr>
              フォーカス中空間：
              <ul>
                <li>ID：{{ currentTargetSpace.id }}</li>
                <li>オブジェクト種別：{{ currentTargetSpace.spaceObjectType }}</li>
              </ul>
              追加対象空間ID：{{ addTargetSpace ? addTargetSpace.id : '' }}<br>
              編集対象面(2D)：{{ editFace2D }}<br>
              編集対象面(3D)：{{ editFace }}<br>
              編集種別：{{ editType }}<br>
              セル比率設定対象親空間：{{ editTargetCellSpaceParent.id }}<br>
              <hr>
              グループ操作用空間データ
              <ul>
                <li>
                  座標(x, y, z)：
                  ({{ isNaN(groupCtrlSpace.x) ? '' : groupCtrlSpace.x }},
                  {{ isNaN(groupCtrlSpace.y) ? '' : groupCtrlSpace.y }},
                  {{ isNaN(groupCtrlSpace.z) ? '' : groupCtrlSpace.z }})
                </li>
                <li>
                  サイズ(w, h, d)：
                  ({{ isNaN(groupCtrlSpace.w) ? '' : groupCtrlSpace.w }},
                  {{ isNaN(groupCtrlSpace.h) ? '' : groupCtrlSpace.h }},
                  {{ isNaN(groupCtrlSpace.d) ? '' : groupCtrlSpace.d }})
                </li>
                <li>オブジェクト種別：{{ groupCtrlSpace.spaceObjectType }}</li>
                <li>オブジェクト詳細種別：{{ groupCtrlSpace.spaceObjectDtlType }}</li>
                <li>プランニング種別：{{ groupCtrlSpace.planningType }}</li>
              </ul>
              <hr>
              編集操作用空間ID：<br>
              {{ editCtrlSpaces.map(space => space.id).join(',') }}
              <hr>
              コピー済み空間ID：<br>
              {{ copiedSpaceIds }}
              <hr>
              SVG拡大率：{{ svgZoomRatio }}<br>
              ビューボックス：
              <ul>
                <li>メイン：{{ viewBox.main }}</li>
                <li>左上：{{ viewBox.upside }}</li>
                <li>右下：{{ viewBox.side }}</li>
              </ul>
              <hr>
              ポインタ座標(キャンバス上)：
              <ul>
                <li>ポインタ座標：({{ currentPointOnCanvas.x }}, {{ currentPointOnCanvas.y }})</li>
                <li>旧ポインタ座標：({{ prevPointOnCanvas.x }}, {{ prevPointOnCanvas.y }})</li>
                <li>マウスダウン位置：({{ mouseDownPointOnCanvas.x }}, {{ mouseDownPointOnCanvas.y }})</li>
              </ul>
              <hr>
              ポインタ座標(グローバル)：
              <ul>
                <li>ポインタ座標：({{ currentPoint.x }}, {{ currentPoint.y }})</li>
                <li>旧ポインタ座標：({{ prevPoint.x }}, {{ prevPoint.y }})</li>
                <li>マウスダウン位置：({{ mouseDownPoint.x }}, {{ mouseDownPoint.y }})</li>
              </ul>
              <hr>
              操作ステータス：
              <ul>
                <li>grabbingInner：{{ opeStatus.grabbingInner }}</li>
                <li>grabbingBorder：{{ opeStatus.grabbingBorder }}</li>
                <li>editing：{{ opeStatus.editing }}</li>
                <li>adding：{{ opeStatus.adding }}</li>
                <li>selecting：{{ opeStatus.selecting }}</li>
                <li>dragging：{{ opeStatus.dragging }}</li>
                <li>mouseDown：{{ opeStatus.mouseDown }}</li>
                <li>mouseButton：{{ opeStatus.mouseButton }}</li>
                <li>snapped：
                  <ul>
                    <li>x：{{ opeStatus.snapped.x }}</li>
                    <li>y：{{ opeStatus.snapped.y }}</li>
                  </ul>
                </li>
                <li>settingSectionPosition：{{ opeStatus.settingSectionPosition }}</li>
                <li>movingCanvas：{{ opeStatus.movingCanvas }}</li>
                <li>resizingCanvas：{{ opeStatus.resizingCanvas }}</li>
              </ul>
              <hr>
              <ul>
                カレントビュー：{{ currentView.code }}
                <li>ラベル：{{ currentView.label }}</li>
                <li>基準面：{{ currentView.isBase }}</li>
                <li>回転：{{ currentViewRotate }}</li>
                <li>反転：
                  <ul>
                    <li>x：{{ currentViewInverse.x }}</li>
                    <li>y：{{ currentViewInverse.y }}</li>
                  </ul>
                </li>
              </ul>
              カレントキャンバス：{{ currentCanvas }}
              <hr>
              吸着後累積移動量：({{ totalMoveAmountForSnap.dx }}, {{ totalMoveAmountForSnap.dy }})<br>
              断面位置(x, y, z)：({{ sectionPosition.x }}, {{ sectionPosition.y }}, {{ sectionPosition.z }})
              <hr>
              キャンバス上：{{ isOnCanvas }}<br>
              図形編集エリア内：{{ isOnCanvasArea }}
              <ul>
                キャンバスリサイズ領域：
                <li>中心：{{ currentResizeCanvasArea.center }}</li>
                <li>上下：{{ currentResizeCanvasArea.vertical }}</li>
                <li>左右：{{ currentResizeCanvasArea.horizontal }}</li>
              </ul>
              <hr>
              編集可能領域：<br>
              {{ Object.keys(editCtrlableArea).map(spaceId => {
                let space = editCtrlableArea[spaceId]
                return {
                  self: spaceId,
                  other:space.id,
                  objectType: space.spaceObjectType,
                  planningType: space.planningType,
                  x: space.x,
                  y: space.y,
                  z: space.z,
                  w: space.w,
                  h: space.h,
                  d: space.d
                }
              }) }}
              <hr>
            </div>
          </div>
          <!-- エラー -->
          <div class="main_tab_contents" id="tab_content_error" v-show="isTabMenuErr">
            <dt>Dummy2</dt>
          </div>
          <!-- デバッグ -->
          <div class="main_tab_contents " id="tab_content_debug" v-show="isTabMenuDebug">
            <dd-debug
              @fileUploadCallback="getEditingFileData"
              @onShowModal="removePlanningEventListener"
              @onCloseModal="addPlanningEventListener"
            />
          </div>
          <!-- LIXIL -->
          <div class="main_tab_contents " id="tab_content_lixil" v-show="isTabLixil">
            <dd-lixil
              @fileUploadCallback="getEditingFileData"
              @onShowModal="removePlanningEventListener"
              @onCloseModal="addPlanningEventListener"
            />
          </div>
          <!-- OTANI -->
          <div class="main_tab_contents " id="tab_content_otani" v-show="isTabOtani">
            <dd-otani
              @fileUploadCallback="getEditingFileData"
              @onShowModal="removePlanningEventListener"
              @onCloseModal="addPlanningEventListener"
            />
          </div>
        </div>

        <div id="main_tab_area">
          <ul class="main_tab_row">
            <li v-if="isTabMenuUnit" @click="onClickMainTab(0)">
              <div class="main_tab_img"><img :src="imgPlanning" width="22px" alt="planning"/></div>
              <p>プランニング</p>
            </li>
            <li v-if="isTabMenuTree" @click="onClickMainTab(1)">
              <div class="main_tab_img"><img :src="imgTree" width="22px" alt="tree"/></div>
              <p>構成</p>
            </li>
            <li v-if="isTabMenuInfo" @click="onClickMainTab(2)">
              <div class="main_tab_img"><img :src="imgInfo" width="22px" alt="info"/></div>
              <p>情報</p>
            </li>
            <li v-if="isTabMenuErr" @click="onClickMainTab(3)">
              <div class="main_tab_img"><img :src="noImage" width="27px" alt="info"/></div>
              <p>エラー</p>
            </li>
            <li v-if="isTabMenuDebug" @click="onClickMainTab(4)">
              <div class="main_tab_img"><img :src="noImage" width="27px" alt="info"/></div>
              <p>デバッグ</p>
            </li>
            <li v-if="isTabLixil" @click="onClickMainTab(5)">
              <div class="main_tab_img"><img :src="noImage" width="27px" alt="info"/></div>
              <p>LIXIL</p>
            </li>
            <li v-if="isTabOtani" @click="onClickMainTab(6)">
              <div class="main_tab_img"><img :src="noImage" width="27px" alt="info"/></div>
              <p>OTANI</p>
            </li>
          </ul>
        </div>
      </nav>
      <nav v-else>
        <span>
          <img :src="getImage('pages/planning/ic_plus_on.svg')" alt="toggle" width="24px" height="auto"  @click="onClickSideTabToggle(true)">
        </span>
      </nav>
      <div id="div_side"  v-on:mouseover="setOnSideTab(true)" v-on:mouseleave="setOnSideTab(false)">
      </div>

      <!--  メインコンテンツ  -->
      <main
        id="canvas-area"
        @mouseover="isOnCanvasArea = true"
        @mouseout="isOnCanvasArea = false"
        v-bind:style="{width : 'calc(100% - ' + canvasWidth + 'px)'}"
      >

        <!-- 左上 -->
        <dd-canvas
          id="canvas-upside"
          canvasType="upside"
          :viewSet="viewSet.upside"
          :showViewTypeSelect="false"
          :globalSpaces="globalSpaceMap.get(viewSet.upside.viewType)"
          :fileData="fileData"
          :currentView="currentView"
          :viewBox="viewBox.upside"
          :dispSpaceObjectTypes="dispSpaceObjectTypes"
          :groupCtrlSpace="groupCtrlSpace"
          :globalSpaceMap="globalSpaceMap"
          :editCtrlSpaces="editCtrlSpaces"
          :addCtrlSpace="addCtrlSpace"
          :addTargetSpace="addTargetSpace"
          :editTargetCellSpaceParent="editTargetCellSpaceParent"
          :snapLines="snapLines"
          :positionGuideLines="positionGuideLines"
          :sectionPosition="sectionPosition"
          :activeSectionPosition="activeSectionPosition"
          :sectionPoints="sectionPoints"
          :activeSectionPoint="activeSectionPoint"
          :doorOpenLineList="doorOpenLineList"
          :doorOpenLineMap="doorOpenLineMap"
          :sklUnderSpaceIdsMap="sklUnderSpaceIdsMap"
          :svgZoomRatio="svgZoomRatio"
          :selectArea="selectArea"
          :isDispDummy="isDispDummy"
          :isDispProcess="isDispProcess"
          :isDispAccessory="isDispAccessory"
          :selectTargetFace="selectTargetFace"
          :selectedFaces="selectedFaces"
          :focusedSpaceId="focusedSpaceId"
          :focusedProcessId="focusedProcessId"
          :objectDataModelMap="objectDataModelMap"
          @setCurrentPointerPositionOnCanvas="setCurrentPointerPositionOnCanvas"
          @setCurrentView="setCurrentView"
          @setViewSet="setViewSet"
          @setOnCanvas="setOnCanvas"
          @zoomCanvas="zoomCanvas"
          @setOutOfSectionSpaceId="setOutOfSectionSpaceId"
        />

        <!-- 右上 -->
        <div
          id="canvas-empty"
          class="infobox"
          @mouseover="clearCurrentView"
        >
        </div>

        <!-- 左下 -->
        <dd-canvas
          id="canvas-main"
          canvasType="main"
          :viewSet="viewSet.main"
          :showViewTypeSelect="true"
          :globalSpaces="globalSpaceMap.get(viewSet.main.viewType)"
          :fileData="fileData"
          :currentView="currentView"
          :viewBox="viewBox.main"
          :dispSpaceObjectTypes="dispSpaceObjectTypes"
          :groupCtrlSpace="groupCtrlSpace"
          :globalSpaceMap="globalSpaceMap"
          :editCtrlSpaces="editCtrlSpaces"
          :addCtrlSpace="addCtrlSpace"
          :addTargetSpace="addTargetSpace"
          :editTargetCellSpaceParent="editTargetCellSpaceParent"
          :snapLines="snapLines"
          :positionGuideLines="positionGuideLines"
          :sectionPosition="sectionPosition"
          :activeSectionPosition="activeSectionPosition"
          :sectionPoints="sectionPoints"
          :activeSectionPoint="activeSectionPoint"
          :doorOpenLineList="doorOpenLineList"
          :doorOpenLineMap="doorOpenLineMap"
          :sklUnderSpaceIdsMap="sklUnderSpaceIdsMap"
          :svgZoomRatio="svgZoomRatio"
          :selectArea="selectArea"
          :isDispDummy="isDispDummy"
          :isDispProcess="isDispProcess"
          :isDispAccessory="isDispAccessory"
          :selectTargetFace="selectTargetFace"
          :selectedFaces="selectedFaces"
          :focusedSpaceId="focusedSpaceId"
          :focusedProcessId="focusedProcessId"
          :objectDataModelMap="objectDataModelMap"
          @setCurrentPointerPositionOnCanvas="setCurrentPointerPositionOnCanvas"
          @setCurrentView="setCurrentView"
          @setViewSet="setViewSet"
          @setOnCanvas="setOnCanvas"
          @zoomCanvas="zoomCanvas"
          @setOutOfSectionSpaceId="setOutOfSectionSpaceId"
        />

        <!-- 右下 -->
        <dd-canvas
          id="canvas-side"
          canvasType="side"
          :viewSet="viewSet.side"
          :showViewTypeSelect="false"
          :globalSpaces="globalSpaceMap.get(viewSet.side.viewType)"
          :fileData="fileData"
          :currentView="currentView"
          :viewBox="viewBox.side"
          :dispSpaceObjectTypes="dispSpaceObjectTypes"
          :groupCtrlSpace="groupCtrlSpace"
          :globalSpaceMap="globalSpaceMap"
          :editCtrlSpaces="editCtrlSpaces"
          :addCtrlSpace="addCtrlSpace"
          :addTargetSpace="addTargetSpace"
          :editTargetCellSpaceParent="editTargetCellSpaceParent"
          :snapLines="snapLines"
          :positionGuideLines="positionGuideLines"
          :sectionPosition="sectionPosition"
          :activeSectionPosition="activeSectionPosition"
          :sectionPoints="sectionPoints"
          :activeSectionPoint="activeSectionPoint"
          :doorOpenLineList="doorOpenLineList"
          :doorOpenLineMap="doorOpenLineMap"
          :sklUnderSpaceIdsMap="sklUnderSpaceIdsMap"
          :svgZoomRatio="svgZoomRatio"
          :selectArea="selectArea"
          :isDispDummy="isDispDummy"
          :isDispProcess="isDispProcess"
          :isDispAccessory="isDispAccessory"
          :selectTargetFace="selectTargetFace"
          :selectedFaces="selectedFaces"
          :focusedSpaceId="focusedSpaceId"
          :focusedProcessId="focusedProcessId"
          :objectDataModelMap="objectDataModelMap"
          @setCurrentPointerPositionOnCanvas="setCurrentPointerPositionOnCanvas"
          @setCurrentView="setCurrentView"
          @setViewSet="setViewSet"
          @setOnCanvas="setOnCanvas"
          @zoomCanvas="zoomCanvas"
          @setOutOfSectionSpaceId="setOutOfSectionSpaceId"
        />

        <!-- ビューの枠線のリサイズ時の描画線 -->
        <div id="canvas-upside-mask" class="createbox canvas_mask" />
        <div id="canvas-empty-mask" class="createbox canvas_mask" />
        <div id="canvas-main-mask" class="createbox canvas_mask" />
        <div id="canvas-side-mask" class="createbox canvas_mask" />

      </main>

    </div>

    <div class="foot_info">
      <!-- 状態 -->
      <ul class="container sub_info_label">
        <li>{{ statusLabel1 }}</li>
        <li>{{ statusLabel2 }}</li>
        <li>
          <ul class="container selected_space_size" v-if="isSelectedSpaceSizeList">
            <li class="list_value">W:<span v-if="isSelectedSpaceSize">{{ round(groupCtrlSpace.w) }}</span><span v-else> - </span></li>
            <li class="list_separate">/
            <li class="list_value">H:<span v-if="isSelectedSpaceSize">{{ round(groupCtrlSpace.h) }}</span><span v-else> - </span></li>
            <li class="list_separate">/
            <li class="list_value">D:<span v-if="isSelectedSpaceSize">{{ round(groupCtrlSpace.d) }}</span><span v-else> - </span></li>
            <li><span v-if="isSelectedSpaceSize">{{ groupCtrlSpace.umCode }}</span></li>
            <li><span v-if="isSelectedSpaceSize">{{ groupCtrlSpace.objName }}</span></li>
          </ul>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, KEY_CODE, SVG_ZOOM_RATIO_DEFAULT, SVG_ZOOM_RATIO_MIN, SVG_ZOOM_SPEED, SVG_MIN_DEFAULT, SELECT_RANGE_DEFAULT, MOUSE_BUTTON, STORAGE_KEY, SNAP_DIST, VIEW_SIZE_MIN} from '../constants/App'
import {OBJECT_TYPE, OBJECT_DTL_TYPE, EDIT_TYPE, FACE_TYPE, PLANNING_TYPE, VIEW_TYPE, VIEW_SET, ATTRIBUTE_KEY, AXIS_TYPE, CANVAS_TYPE, USER_TYPE, SELECT_MODE, LICENSE_TYPE} from '../constants/Type'
import * as Api from '../utils/Api'
import * as AppUtil from '../utils/App'
import * as SpaceUtil from '../utils/Space'
import * as FaceUtil from '../utils/Face'
import * as SnapUtil from '../utils/Snap'
import * as CalcUtil from '../utils/Calc'
// common
import Header from '../components/common/Header'
// parts
import Canvas from '../components/planning/parts/Canvas'
import HeaderMenu from '../components/planning/parts/HeaderMenu'
import ContextMenu from '../components/planning/parts/ContextMenu'
// modal
import LoadingModal from '../components/common/LoadingModal'
import SelectSaveTypeModal from '../components/planning/modal/SelectSaveTypeModal'
import SelectUpdateInsertModal from '../components/planning/modal/SelectUpdateInsertModal'
import SetCellRatioModal from '../components/planning/modal/SetCellRatioModal'
import StyleColorModal from '../components/planning/modal/StyleColorModal'
import FileModal from '../components/planning/modal/FileModal'
import SetCostCustomModal from '../components/planning/modal/SetCostCustomModal'
import SetDoorWrapModal from '../components/planning/modal/SetDoorWrapModal'
import FaceDistanceMoveModal from '../components/planning/modal/FaceDistanceMoveModal'
import SetSizeModal from '../components/planning/modal/SetSizeModal'
import SetSelectParts from '../components/planning/modal/SetSelectParts'
import SetMovingDistanceModal from '../components/planning/modal/SetMovingDistanceModal'
import SetColorModal from '../components/planning/modal/SetColorModal'
import BusinessModal from '../components/planning/modal/BusinessModal'
import FaceOptionModal from '../components/planning/modal/FaceOptionModal'
import PosRuleModal from '../components/planning/modal/SetPosRuleModal'
import SetElGrainModal from '../components/planning/modal/SetElGrainModal'
import SetMaterialModal from '../components/planning/modal/SetMaterialModal'
import SetSurfaceLedgeModal from '../components/planning/modal/SetSurfaceLedgeModal'
import PartsFacerelationModal from '../components/planning/modal/SetPartsFacerelationModal'
import SetCustomPriceModal from '../components/planning/modal/SetCustomPriceModal'
import SetCustomCommentModal from '../components/planning/modal/SetCustomCommentModal'
import MmstyleRequestModal from '../components/planning/modal/MmstyleRequestModal'
import SketchAddCartModal from '../components/common/SketchAddCartModal'
import SketchViewModal from '../components/common/SketchViewModal'
import ProfitSettingModal from '../components/planning/modal/ProfitSettingModal'
// tab
import SelectUnit from '../components/common/SelectUnit'
import SelectUnit2 from '../components/common/SelectUnit2'
import SpaceTree from '../components/planning/tab/SpaceTree'
import Debug from '../components/planning/tab/Debug'
import Lixil from '../components/planning/tab/Lixil'
import Otani from '../components/planning/tab/Otani'

export default {
  name: 'Planning',
  components: {
    'dd-header': Header,
    'dd-canvas': Canvas,
    'dd-header-menu': HeaderMenu,
    'dd-context-menu': ContextMenu,
    'dd-select-save-type-modal': SelectSaveTypeModal,
    'dd-select-update-insert-modal': SelectUpdateInsertModal,
    'dd-file-modal': FileModal,
    'dd-profit-setting-modal': ProfitSettingModal,
    'dd-set-cost-custom-modal': SetCostCustomModal,
    'dd-set-cell-ratio-modal': SetCellRatioModal,
    'dd-style-color-modal': StyleColorModal,
    'dd-set-door-wrap-modal': SetDoorWrapModal,
    'dd-face-distance-move-modal': FaceDistanceMoveModal,
    'dd-select-unit': SelectUnit,
    'dd-select-unit2': SelectUnit2,
    'dd-space-tree': SpaceTree,
    'dd-debug': Debug,
    'dd-lixil': Lixil,
    'dd-otani': Otani,
    'dd-set-size-modal': SetSizeModal,
    'dd-set-select-parts-modal': SetSelectParts,
    'dd-set-moving-modal': SetMovingDistanceModal,
    'dd-set-color-modal': SetColorModal,
    'dd-loading-modal': LoadingModal,
    'dd-business-modal': BusinessModal,
    'dd-face-option-modal': FaceOptionModal,
    'dd-pos-rule-modal': PosRuleModal,
    'dd-el-grain-modal': SetElGrainModal,
    'dd-material-modal': SetMaterialModal,
    'dd-surface-ledge-modal': SetSurfaceLedgeModal,
    'dd-parts-facerelation-modal': PartsFacerelationModal,
    'dd-custom-price-modal': SetCustomPriceModal,
    'dd-custom-comment-modal': SetCustomCommentModal,
    'dd-sketch-add-cart-modal': SketchAddCartModal,
    'dd-sketch-view-modal': SketchViewModal,
    'dd-mmstyle-request-modal': MmstyleRequestModal
  },
  data () {
    return {
      // *****************************************************************
      // 空間データ
      // *****************************************************************
      /** ファイルデータ */
      fileData: {},
      /** 一覧からドラッグされているファイルデータ */
      draggedFileData: {},
      /** グローバル座標空間マップ */
      globalSpaceMap: new Map(),
      /** グループ空間(内部データ) */
      groupCtrlSpace: {},
      /** 編集操作用空間データ */
      editCtrlSpaces: [],
      tmpEditCtrlSpaces: [],
      editChildrenDoor: null,
      /** 前回ポスト時の編集操作用空間データ */
      prevEditCtrlSpaces: [],
      /** 編集操作用空間が移動できる領域 {spaceId: {spaceModel}} */
      editCtrlableArea: {},
      /** 追加操作用空間データ */
      addCtrlSpace: {},
      /** マウスオーバー中の空間 */
      currentTargetSpace: {},
      /** 追加対象空間 */
      addTargetSpace: null, // {}で初期化するとcomputedが変更検知してしまうのでnullで初期化
      /** 編集対象セル空間の親空間(セル比率設定モーダル表示中のみ値が入る) */
      editTargetCellSpaceParent: {},
      /** モジュール */
      moduleAtt: {},
      /** 吸着ルール */
      snapRule: {},
      /** 吸着情報 */
      snapPositions: {minDist: {x: null, y: null}, positionList: {x: [], y: []}},
      /** 吸着線 */
      snapLines: [],
      /** 位置ガイド線 */
      positionGuideLines: [], // 開始点xyz+長さl
      /** サーフェス吸着面 */
      snapSurfaceFaceType: FACE_TYPE.UNDEFINED,
      /** サーフェス吸着空間 */
      snapSurfaceSpace: '',
      /** 断面位置外空間IDリスト */
      outOfSectionSpaceIds: {[VIEW_TYPE.UNDEFINED.code]: new Set()},
      /** コピー空間ID */
      copiedSpaceIds: [],
      /** 選択対象面{space: SpaceModel, faceType: FACE_TYPE} */
      selectTargetFace: {space: {}, faceType: FACE_TYPE.UNDEFINED},
      /** 選択面[{space: SpaceModel, faceType: FACE_TYPE},...] */
      selectedFaces: [],
      /** 面間距離 */
      faceDistance: null,
      /** 強調表示対象空間ID */
      focusedSpaceId: null,
      /** フォーカス中対象パーツ空間ID */
      focusedMenuSpace: null,
      /** 強調表示加工ID */
      focusedProcessId: null,

      // *****************************************************************
      // 画面操作・状態
      // *****************************************************************
      /** 現在の各キャンバス上のポインタ座標 */
      currentPointOnCanvas: { x: null, y: null },
      /** 直前の各キャンバス上のポインタ座標 */
      prevPointOnCanvas: { x: null, y: null },
      /** 累積移動量 */
      totalMoveAmountForSnap: { dx: 0, dy: 0 },
      /** 各キャンバス上のマウスダウン座標 */
      mouseDownPointOnCanvas: { x: null, y: null },
      /** グローバルなポインタ座標 */
      currentPoint: { x: null, y: null },
      /** 直前のグローバルなポインタ座標 */
      prevPoint: { x: null, y: null },
      /** グローバルなマウスダウン座標 */
      mouseDownPoint: { x: null, y: null },
      /** 現在編集対象のビュー */
      currentView: VIEW_TYPE.UNDEFINED,
      /** 現在編集対象のビュー回転 */
      currentViewRotate: 0,
      /** 現在編集対象のビュー反転 */
      currentViewInverse: { x: false, y: false },
      /** ビューセット */
      viewSet: VIEW_SET[0],
      /** 現在編集対象のキャンバス */
      currentCanvas: CANVAS_TYPE.UNDEFINED,
      /** グラフ領域の座標表示範囲 */
      viewBox: {
        main: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 },
        upside: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 },
        side: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 }
      },
      /** 操作ステータス */
      opeStatus: {
        grabbingInner: false,
        grabbingBorder: false,
        editing: false,
        adding: false,
        selecting: false,
        dragging: false,
        mouseDown: false,
        mouseButton: MOUSE_BUTTON.UNDEFINED,
        snapped: { x: false, y: false },
        settingSectionPosition: false,
        settingSectionPoint: false,
        movingCanvas: false,
        resizingCanvas: false,
        moveXOnly: false,
        moveYOnly: false
      },
      /** 操作モード */
      opeMode: {
        selectMode: SELECT_MODE.CABINET.code, // キャビネット/扉・引出し・インフィル選択モード
        selectObject: OBJECT_TYPE.UNIT.code, // ユニット/セル選択モード
        rectSelect: true, // 矩形選択モード
        faceDistanceDisp: false, // 面間距離表示モード
        faceDistanceMove: false, // 面間距離設定モード
        outsideRoom: true, // 部屋の外には配置しない
        autoUpdate: true // 価格/加工自動更新モード
      },
      /** キャビネット・インフィル/扉・引出し・インフィル選択モードリスト */
      selectModeList: [ SELECT_MODE.CABINET, SELECT_MODE.DOOR_DRAWER_INFILL ],
      /** ビューのリサイズ方向 */
      currentResizeCanvasArea: {
        center: false,
        vertical: false,
        horizontal: false
      },
      /** 編集種別 */
      editType: EDIT_TYPE.UNDEFINED,
      /** 編集面種別 */
      editFace: FACE_TYPE.UNDEFINED,
      /** グラフ表示領域のズーム率初期値 */
      svgZoomRatio: SVG_ZOOM_RATIO_DEFAULT,
      /** キャンバス領域内 */
      isOnCanvasArea: false,
      /** 各キャンバス上 */
      isOnCanvas: false,
      /** 表示対象空間オブジェクトタイプ */
      dispSpaceObjectTypes: [ OBJECT_TYPE.PARTS.code ],
      dispSpaceObjectTypesList: [
        OBJECT_TYPE.PARTS,
        OBJECT_TYPE.SETPLAN,
        OBJECT_TYPE.COMBINE,
        OBJECT_TYPE.UNIT,
        OBJECT_TYPE.ELEMENT,
        OBJECT_TYPE.UNITCOMPONENT,
        OBJECT_TYPE.CELL,
        OBJECT_TYPE.FITTING
      ],
      /** ダミー空間表示 */
      isDispDummy: false,
      /** 加工線表示 */
      isDispProcess: false,
      /** アクセサリー表示 */
      isDispAccessory: false,
      /** 断面位置 */
      sectionPosition: { x: null, y: null, z: null },
      activeSectionPosition: AXIS_TYPE.UNDEFINED,
      /** 図面断面線リスト */
      sectionPoints: [],
      activeSectionPoint: null,
      /** 選択範囲 */
      selectArea: {},
      /** 面間距離表示対象[{space: SpaceModel, faceType: FACE_TYPE},...] */
      faceDistanceTargets: [],
      /** シリーズ */
      series: {},
      /** サイドタブ表示フラグ */
      isDispSideTab: true,
      isDispMenu: true,
      isDispContent: true,
      isFocusedUnit: false,
      isFocusedParts: false,
      isFocusedPartsParent: false,
      isFocusedSurface: false,
      isFocusedMobileShelfParts: false,
      isFocusedUmcodeSpace: false,
      isFocusedOneRelatedToShelf: false,
      isShowTreeContextMenu: false,
      /** 構成ツリー表示フラグ */
      spaceTreeFlg: false,
      /** 価格 */
      price: 0,
      /** 画像ファイル */
      imgNew: this.getImage('pages/planning/ic_new_off.svg'),
      imgSave: this.getImage('pages/planning/ic_save_off.svg'),
      imgSheet: this.getImage('pages/planning/ic_sheet_off.svg'),
      imgEstimate: this.getImage('print/ic_estimate.svg'),
      imgBom: this.getImage('print/ic_output.svg'),
      imgCG: this.getImage('print/ic_output.svg'),
      /** キャンバス可変高さ(px) */
      canvasHeight: 163,
      canvasWidth: 473,
      menuHeight: 0,
      contentHeight: 0,
      sideTabHeight: 0,
      sideTabWidth: 0,
      /** サイドタブの可変サイズ */
      isOnSIdeTab: false,
      sideTabFlag: false,
      /** 自身のカラースタイル */
      ownColorStyle: {},
      /** ファイル一覧ロード中フラグ */
      isLoadingFileList: false,
      /** 編集中ファイルロード中フラグ */
      isLoadingEditFile: false,
      /** Ctrlキー押下フラグ(D&Dのコピぺで使用) */
      isCtrlKey: false,
      /** 画面操作無効フラグ */
      isPlanningOff: false,

      // *****************************************************************
      // メインタブ
      // *****************************************************************
      imgPlanning: this.getImage('component/unit/planning.svg'),
      imgTree: this.getImage('component/unit/tree.svg'),
      imgInfo: this.getImage('component/unit/info.svg'),
      noImage: this.getImage('noimage.svg')
    }
  },
  computed: {
    /** ローディング中判定 */
    isLoading: function () {
      return this.isLoadingFileList || this.isLoadingEditFile
    },
    /** プランニング中判定 */
    isPlanning: function () {
      return this.fileData && this.fileData.topSpaceModel &&
        OBJECT_TYPE.PLAN.code === this.fileData.topSpaceModel.spaceObjectType
    },
    /** セットプラン編集中判定 */
    isSetPlanning: function () {
      return this.fileData && this.fileData.topSpaceModel &&
        [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(this.fileData.topSpaceModel.spaceObjectType)
    },
    /** コンバイン編集中判定 */
    isCombineEdit: function () {
      return this.fileData && this.fileData.topSpaceModel &&
        OBJECT_TYPE.COMBINE.code === this.fileData.topSpaceModel.spaceObjectType
    },
    /** 編集面(2D) */
    editFace2D: function () {
      return FaceUtil.convertFaceTypeForDisp(this.editFace, this.currentView, this.currentViewRotate)
    },
    /** 画面ステータス表示 */
    statusLabel1: function () {
      if (!this.fileData || !this.fileData.topSpaceModel || !this.fileData.topSpaceModel.spaceObjectType) {
        return 'ファイルを新規作成してください。'
      }
      let objectType = Object.keys(OBJECT_TYPE).map(e => OBJECT_TYPE[e]).find(e => e.code === this.fileData.topSpaceModel.spaceObjectType).label
      let data = this.fileData.forCopy ? '' : objectType + 'データ'
      let dataStatus = this.fileData.forCopy ? '新規作成中' : '編集中'
      return data + dataStatus
    },
    statusLabel2: function () {
      if (!this.fileData || !this.fileData.topSpaceModel) return ''
      if (this.opeMode.faceDistanceDisp) {
        let label = '面間距離表示モード'
        if (!this.dispSpaceObjectTypes.includes(OBJECT_TYPE.PARTS.code)) {
          label += '(パーツ空間を表示対象にしてください。)'
        } else if (!this.selectedFaces.length) {
          label += '(距離を調べたい1つ目の面を選択してください。)'
        } else if (this.selectedFaces.length === 1) {
          label += '(距離を調べたい2つ目の面を選択してください。)'
        } else if (this.faceDistance === null) {
          label += '(平行な2つの面を選択してください。)'
        } else {
          label += '(2面間の距離は ' + Math.abs(this.faceDistance) + 'mm)'
        }
        return label
      }
      if (this.opeMode.faceDistanceMove) {
        let label = '面間距離を指定して移動'
        if (!this.dispSpaceObjectTypes.includes(OBJECT_TYPE.UNIT.code)) {
          label += '(ユニット空間を表示対象にしてください。)'
        } else if (!this.selectedFaces.length) {
          label += '(基準面を選択してください。)'
        } else if (this.selectedFaces.length === 1) {
          label += '(移動させる空間の面を選択してください。)'
        } else if (this.faceDistance === null) {
          label += '(平行な2つの面を選択してください。)'
        }
        return label
      }
      if (this.opeStatus.settingSectionPosition && !this.opeStatus.mouseDown) return '断面線を設定する位置をクリックしてください。'
      return ''
    },
    /** 選択中の空間サイズのリストの表示 */
    isSelectedSpaceSizeList: function () {
      return this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && !this.opeMode.faceDistanceDisp && !this.opeMode.faceDistanceMove && !this.opeStatus.settingSectionPosition
    },
    /** 選択中の空間サイズの値の表示 */
    isSelectedSpaceSize: function () {
      return this.groupCtrlSpace && Object.keys(this.groupCtrlSpace).length > 0
    },
    /** 開発用ツール表示 */
    dispDevTools: function () {
      let user = AppUtil.getUserInfo()
      return user && [USER_TYPE.DOMANS_ADMIN.code, USER_TYPE.SYSTEM_ADMIN.code].includes(user.userType)
    },
    /** ユニットタブ表示 */
    isTabMenuUnit: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuUnit
    },
    /** 構成タブ表示 */
    isTabMenuTree: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuTree
    },
    /** 情報タブ表示 */
    isTabMenuInfo: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuInfo
    },
    /** エラータブ表示 */
    isTabMenuErr: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuErr
    },
    /** カスタマイズタブ表示 */
    isTabMenuCustom: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuCustom
    },
    /** デバッグタブ表示 */
    isTabMenuDebug: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuDebug
    },
    /** LIXIL専用タブ表示 */
    isTabLixil: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuLixil
    },
    /** OTANI専用タブ表示 */
    isTabOtani: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.tabMenuOtani
    },
    isOrder: function () {
      let user = AppUtil.getUserInfo()
      return user && user.corpId === 170
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = AppUtil.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    /** 扉開閉線 */
    doorOpenLineList: function () {
      if (!this.fileData || !Object.keys(this.fileData).length || !this.fileData.attributeModelList) return []
      return this.fileData.attributeModelList.filter(att => att.attKeycd === ATTRIBUTE_KEY.PT_DOOR_OPEN_TYPE)
    },
    /** 扉開閉線 */
    doorOpenLineMap: function () {
      if (!this.fileData || !Object.keys(this.fileData).length || !this.fileData.attributeModelList) return {}
      let lineMap = {}
      this.fileData.attributeModelList
        .filter(att => att.attKeycd === ATTRIBUTE_KEY.PT_DOOR_OPEN_TYPE)
        .forEach(att => {
          let space = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === att.spaceId)
          if (!space) return
          let parentUnitId = space.parentSpaceId
          if (!parentUnitId) return
          if (!lineMap.hasOwnProperty(parentUnitId)) lineMap[parentUnitId] = []
          lineMap[parentUnitId].push({att, space})
        })
      return lineMap
    },
    /* スケルトンの空間IDとスケルトン配下の空間IDの配列のマップ */
    sklUnderSpaceIdsMap: function () {
      const sklUnderSpaceIdsMap = {}

      if (!this.fileData || !Object.keys(this.fileData).length) return sklUnderSpaceIdsMap
      const { topSpaceModel } = this.fileData
      if (!topSpaceModel || !Object.keys(topSpaceModel).length) return sklUnderSpaceIdsMap

      const globalSpaces = this.globalSpaceMap.get(VIEW_TYPE.FRONT)
      const skls = globalSpaces.filter(s => s.planningType === PLANNING_TYPE.UNIT_SKELTON)
      if (skls.length <= 0) return sklUnderSpaceIdsMap

      skls.forEach(skl => {
        const sklUnderSpaceIds = []
        SpaceUtil.createSklUnderSpaceIds(skl, sklUnderSpaceIds, globalSpaces, this.fileData.attributeModelList)
        sklUnderSpaceIdsMap[skl.id] = sklUnderSpaceIds
      })

      // {スケルトンID：スケルトン配下の空間IDの配列, スケルトンID：スケルトン配下の空間IDの配列,,,,,}
      return sklUnderSpaceIdsMap
    },
    /** 選択モードから選択可能なプランニングタイプのリストを取得 */
    selectablePlanningTypes: function () {
      let planningTypes = []
      if (this.opeMode.selectMode === SELECT_MODE.CABINET.code) {
        planningTypes = [
          PLANNING_TYPE.UNIT,
          PLANNING_TYPE.UNIT_SKELTON,
          PLANNING_TYPE.UNIT_SHELF,
          PLANNING_TYPE.UNIT_SURFACE,
          PLANNING_TYPE.UNIT_FACE_OPTION,
          PLANNING_TYPE.COMBINE,
          PLANNING_TYPE.ACCESSORY,
          PLANNING_TYPE.SETPLAN
        ]
      } else if (this.opeMode.selectMode === SELECT_MODE.DOOR_DRAWER_INFILL.code) {
        planningTypes = [PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_INFILL]
      }
      return planningTypes
    },
    /** 選択範囲 */
    selectRange: function () {
      return (this.svgZoomRatio > 3 ? 1 : (this.svgZoomRatio / 3)) * SELECT_RANGE_DEFAULT
    },
    /** セットプラン(固定)の対象か */
    isCabinetMultiSelected: function () {
      return this.opeMode.selectMode === SELECT_MODE.CABINET.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
        this.editCtrlSpaces.filter(space => [PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.COMBINE, PLANNING_TYPE.SETPLAN].includes(space.planningType)).length > 1
    },
    /** セットプラン(ルール付き)の対象か */
    isRuledSetTargetSelected: function () {
      // 対象空間のみフィルタ
      let targetSpaceList = this.editCtrlSpaces
        .filter(space => [PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.COMBINE, PLANNING_TYPE.SETPLAN].includes(space.planningType))
      // 各方向でルールドセットプランの条件を満たすかチェック
      let isDirX = targetSpaceList.length > 0 ? SpaceUtil.isRuledSetByWidth(targetSpaceList) : false
      let isDirY = targetSpaceList.length > 0 ? SpaceUtil.isRuledSetByHeight(targetSpaceList) : false
      let isDirZ = targetSpaceList.length > 0 ? SpaceUtil.isRuledSetByDepth(targetSpaceList) : false
      return this.opeMode.selectMode === SELECT_MODE.CABINET.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
        targetSpaceList.length > 1 && (isDirX || isDirY || isDirZ)
    },
    isOneSkeltonSelected: function () {
      return this.opeMode.selectMode === SELECT_MODE.CABINET.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
              this.editCtrlSpaces.length === 1 && this.editCtrlSpaces.filter(space => space.planningType === PLANNING_TYPE.UNIT_SKELTON).length === 1
    },
    isOneCombineSelected: function () {
      return this.opeMode.selectMode === SELECT_MODE.CABINET.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
              this.editCtrlSpaces.length === 1 && this.editCtrlSpaces.filter(space => space.planningType === PLANNING_TYPE.COMBINE).length === 1
    },
    isOneSetPlanSelected: function () {
      return this.opeMode.selectMode === SELECT_MODE.CABINET.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
              this.editCtrlSpaces.length === 1 && this.editCtrlSpaces.filter(space => space.planningType === PLANNING_TYPE.SETPLAN).length === 1
    },
    isOneUnitSelected: function () {
      return this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces.length === 1 &&
              this.editCtrlSpaces.filter(space => space.spaceObjectType === OBJECT_TYPE.UNIT.code).length === 1
    },
    isDoorSelected: function () {
      return this.opeMode.selectMode === SELECT_MODE.DOOR_DRAWER_INFILL.code && this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
        this.editCtrlSpaces.length > 0 &&
        this.editCtrlSpaces.filter(space => ![PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_DRAWER].includes(space.planningType)).length < 1
    },
    isPreviewFile: function () {
      return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.PLAN.code
    },
    isUnit: function () {
      return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.UNIT.code
    },
    isPlan: function () {
      return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.PLAN.code
    },
    isSelectedOneRelatedToShelfOnCanvas () {
      const { selectMode, selectObject } = this.opeMode
      return selectMode === SELECT_MODE.CABINET.code && selectObject === OBJECT_TYPE.UNIT.code &&
        this.editCtrlSpaces.length === 1 && this.isShelfOrHasChildShelf(this.editCtrlSpaces[0])
    },
    /** オブジェクトデータモデルのオブジェクト */
    objectDataModelMap () {
      const objectDataModelList = this.fileData.objectDataModelList || []
      return Object.assign({}, ...objectDataModelList.map(model => ({
        [model.spaceId]: model
      })))
    }
  },
  watch: {
    editCtrlSpaces: function () {
      this.openTreeBySpaceId()
    }
  },
  methods: {
    // *****************************************************************
    // イベントハンドラ系
    // *****************************************************************
    onClick: function (event) {
      if (this.isOnCanvas) {
        // **********************************************************************
        // コンテキストメニュー表示
        // **********************************************************************
        if (this.opeStatus.mouseButton === MOUSE_BUTTON.RIGHT) {
          this.$refs.contextMenuRef.show({ x: event.pageX, y: event.pageY }, true)
        } else if (!this.opeStatus.settingSectionPosition) {
          // **********************************************************************
          // 面間距離表示/設定
          // **********************************************************************
          if (this.opeMode.faceDistanceDisp || this.opeMode.faceDistanceMove) {
            if (this.selectedFaces.length > 1) this.selectedFaces = []
            if (!Object.keys(this.selectTargetFace.space).length ||
              !this.selectTargetFace.faceType ||
              this.selectTargetFace.faceType === FACE_TYPE.UNDEFINED) {
              return
            }
            let sameFace = this.selectedFaces.find(fc => {
              return fc.space.id === this.selectTargetFace.space.id &&
                fc.faceType === this.selectTargetFace.faceType
            })
            if (sameFace) return

            // 面間距離設定の場合のみ
            if (this.opeMode.faceDistanceMove && this.selectedFaces.length === 1) {
              if (this.selectedFaces[0].space.id === this.selectTargetFace.space.id) return
            }

            this.selectedFaces.push(Object.assign({}, this.selectTargetFace)) // コピーして追加
            if (this.selectedFaces.length === 2) {
              this.faceDistance = FaceUtil.getFaceDistance(
                this.selectedFaces[0].space,
                this.selectedFaces[0].faceType,
                this.selectedFaces[1].space,
                this.selectedFaces[1].faceType
              )
            }
            // 面間距離設定の場合のみ
            if (this.opeMode.faceDistanceMove && this.selectedFaces.length === 2 && this.faceDistance !== null) {
              // 設定モーダル表示
              this.$refs.faceDistanceMoveModalRef.showModal()
              // 距離ガイド線表示
              this.positionGuideLines = []
              let baseSpace = this.selectedFaces[0].space
              let baseFacePos = FaceUtil.getFacePosition(baseSpace, this.selectedFaces[0].faceType)
              if (FaceUtil.isFaceOfAxis(this.selectedFaces[0].faceType, AXIS_TYPE.X)) {
                this.positionGuideLines.push({ x: baseFacePos, y: baseSpace.y + baseSpace.h / 2, z: baseSpace.z + baseSpace.d / 2, l: this.faceDistance, axis: AXIS_TYPE.X })
              } else if (FaceUtil.isFaceOfAxis(this.selectedFaces[0].faceType, AXIS_TYPE.Y)) {
                this.positionGuideLines.push({ x: baseSpace.x + baseSpace.w / 2, y: baseFacePos, z: baseSpace.z + baseSpace.d / 2, l: this.faceDistance, axis: AXIS_TYPE.Y })
              } else if (FaceUtil.isFaceOfAxis(this.selectedFaces[0].faceType, AXIS_TYPE.Z)) {
                this.positionGuideLines.push({ x: baseSpace.x + baseSpace.w / 2, y: baseSpace.y + baseSpace.h / 2, z: baseFacePos, l: this.faceDistance, axis: AXIS_TYPE.Z })
              }
            }
          // **********************************************************************
          // 空間選択
          // **********************************************************************
          } else {
            let nextEditTargetSpace = SpaceUtil.getEditTargetSpace(
              this.globalSpaceMap,
              this.currentView,
              this.svgZoomRatio,
              this.currentPointOnCanvas,
              this.currentViewRotate,
              this.outOfSectionSpaceIds,
              [OBJECT_TYPE.UNIT.code, OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code],
              this.selectablePlanningTypes
            )

            // 選択対象：ユニットの場合
            if (this.opeMode.selectObject === OBJECT_TYPE.UNIT.code) {
              // プランニング、セットプランニング時にコンバイン内の空間選択
              if (this.isPlanning || this.isSetPlanning) {
                // 一番上にあるセットプラン
                let parentSetPlan = SpaceUtil.getTopParentByCond(
                  nextEditTargetSpace,
                  this.globalSpaceMap.get(this.currentView),
                  space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(space.spaceObjectType)
                )
                if (Object.keys(parentSetPlan).length) {
                  // スケルトン選択モードの時のみ上書き
                  if (this.opeMode.selectMode === SELECT_MODE.CABINET.code) {
                    nextEditTargetSpace = parentSetPlan
                  } else {
                    nextEditTargetSpace = {}
                  }
                } else {
                  // 親コンバイン
                  let parentCombine = SpaceUtil.getParentByCond(
                    nextEditTargetSpace,
                    this.globalSpaceMap.get(this.currentView),
                    space => space.spaceObjectType === OBJECT_TYPE.COMBINE.code
                  )
                  if (Object.keys(parentCombine).length) {
                    // スケルトン選択モードの時のみ上書き
                    if (this.opeMode.selectMode === SELECT_MODE.CABINET.code) {
                      nextEditTargetSpace = parentCombine
                    } else {
                      nextEditTargetSpace = {}
                    }
                  }
                }
              }
              if (Object.keys(nextEditTargetSpace).length) {
                this.addEditCtrlSpace(nextEditTargetSpace.id, event.shiftKey)
              } else if (this.editCtrlSpaces.length > 0) {
                this.clearEditCtrlSpace()
              }
            }
          }
        }
      } else if (this.focusedSpaceId !== null) {
        // **********************************************************************
        // コンテキストメニュー表示
        // **********************************************************************
        if (this.opeStatus.mouseButton === MOUSE_BUTTON.RIGHT) {
          // 対象空間
          this.focusedMenuSpace = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === this.focusedSpaceId)
          const object = this.objectDataModelMap[this.focusedSpaceId]
          // フォーカス空間の判定
          const { spaceObjectType: focusedSpaceObjectType, spaceObjectDtlType: focusedSpaceObjectDtlType, planningType: focusedSpacePlanningType } = this.focusedMenuSpace
          this.isFocusedUnit = focusedSpaceObjectType === OBJECT_TYPE.UNIT.code
          this.isFocusedParts = focusedSpaceObjectType === OBJECT_TYPE.PARTS.code
          this.isFocusedPartsParent = [OBJECT_TYPE.UNIT.code, OBJECT_TYPE.COMBINE.code, OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code, OBJECT_TYPE.ROOM.code].includes(focusedSpaceObjectType)
          this.isFocusedSurface = [OBJECT_DTL_TYPE.UNIT_COUNTER.code, OBJECT_DTL_TYPE.UNIT_ENDPANEL.code].includes(focusedSpaceObjectDtlType)
          this.isFocusedMobileShelfParts = this.isShelfParts(this.focusedMenuSpace)
          // Swapper実装済みのユニットはアップデート対象に追加
          let isUpdateUnit = [PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_SURFACE,
            PLANNING_TYPE.UNIT_INFILL, PLANNING_TYPE.UNIT_DRAWER].includes(focusedSpacePlanningType)
          this.isFocusedUmcodeSpace = ([OBJECT_TYPE.COMBINE.code, OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(focusedSpaceObjectType) || isUpdateUnit) &&
            object && object.umCode !== null && object.umCode !== ''
          this.isFocusedOneRelatedToShelf = this.isShelfOrHasChildShelf(this.focusedMenuSpace)
          // 対象のメニューを表示
          if (this.isFocusedParts || this.isFocusedPartsParent || this.isFocusedUnit || this.isFocusedOneRelatedToShelf) {
            this.$refs.contextMenuRef.show({ x: event.pageX, y: event.pageY }, false)
          }
        }
      } else if (this.isOnCanvasArea) {
        this.clearEditCtrlSpace()
      }
    },
    /**
     * マウス押下時処理
     * 操作ステータス(opeStatus)の設定を行う。
     */
    onMousedown: function (event) {
      // **********************************************************************
      // 全体共通処理
      // **********************************************************************
      this.opeStatus.mouseDown = true
      this.opeStatus.mouseButton = event.button
      this.setCurrentPointerPosition(event)
      this.mouseDownPoint = { x: event.pageX, y: event.pageY }
      if (this.currentResizeCanvasArea.center || this.currentResizeCanvasArea.vertical || this.currentResizeCanvasArea.horizontal) {
        this.opeStatus.resizingCanvas = true
        this.showResizeCanvasMask(event)
      }
      // **********************************************************************
      // ファイルデータ追加
      // **********************************************************************
      if (this.draggedFileData && Object.keys(this.draggedFileData).length && this.opeStatus.mouseButton === MOUSE_BUTTON.LEFT &&
        OBJECT_TYPE.PLAN.code !== this.draggedFileData.topSpaceModel.spaceObjectType) {
        this.opeStatus.adding = true
        this.showStalkingRect(event)
      }
      // サイドタブ内
      if (this.isOnSIdeTab) {
        this.sideTabFlag = true
      }
      // キャンバス内
      if (this.isOnCanvas) {
        this.mouseDownPointOnCanvas = {
          x: this.currentPointOnCanvas.x,
          y: this.currentPointOnCanvas.y
        }
        // **********************************************************************
        // 断面位置指定
        // **********************************************************************
        if (this.activeSectionPosition !== AXIS_TYPE.UNDEFINED && this.opeStatus.mouseButton === MOUSE_BUTTON.LEFT) {
          this.opeStatus.settingSectionPosition = true
        } else if (this.activeSectionPoint != null && this.opeStatus.mouseButton === MOUSE_BUTTON.LEFT) {
          this.opeStatus.settingSectionPoint = true
        }
        // **********************************************************************
        // 空間編集
        // **********************************************************************
        if (!this.opeStatus.settingSectionPosition && !this.opeStatus.settingSectionPoint && this.opeStatus.mouseButton === MOUSE_BUTTON.LEFT) {
          let editFace2D = SpaceUtil.isOnBorder(
            this.groupCtrlSpace,
            this.currentView,
            this.currentPointOnCanvas,
            this.currentViewRotate,
            this.currentViewInverse,
            this.selectRange
          )
          let editFace3D = FaceUtil.convertFaceTypeFromDisp(editFace2D, this.currentView, this.currentViewRotate)
          this.editFace = this.editCtrlSpaces.find(space => SpaceUtil.isFix(space, editFace3D)) ? FACE_TYPE.UNDEFINED : editFace3D
          if (this.editFace && this.editFace !== FACE_TYPE.UNDEFINED) {
            this.opeStatus.grabbingBorder = true
          } else if (SpaceUtil.isOnSpace(this.groupCtrlSpace, this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange)) {
            this.opeStatus.grabbingInner = true
          }
          if (this.opeStatus.grabbingBorder || this.opeStatus.grabbingInner) {
            this.opeStatus.editing = true
          }
        }

        // **********************************************************************
        // その他
        // **********************************************************************
        if (!this.opeStatus.adding && !this.opeStatus.editing && !this.opeStatus.settingSectionPosition && !this.opeStatus.settingSectionPoint) {
          if (this.opeStatus.mouseButton === MOUSE_BUTTON.LEFT && this.opeMode.rectSelect &&
            this.opeMode.selectObject !== OBJECT_TYPE.CELL.code && !this.opeMode.faceDistanceDisp && !this.opeMode.faceDistanceMove) {
            // 空間選択
            this.opeStatus.selecting = true
          } else if (this.opeStatus.mouseButton === MOUSE_BUTTON.RIGHT) {
            // キャンバス移動
            this.opeStatus.movingCanvas = true
          }
        }
      }
      this.changeCursor(event)
    },
    /**
     * マウスアップ時処理
     * 操作ステータス(opeStatus)のリセットを行う。
     * 各操作後のサーバーリクエストを行う。
     */
    onMouseup: function (event) {
      // **********************************************************************
      // 全体共通処理
      // **********************************************************************
      this.opeStatus.mouseDown = false
      this.setCurrentPointerPosition(event)
      this.resizeCanvas()
      this.sideTabFlag = false
      // マウスダウンとマウスアップの位置が同じ場合はクリックとみなす
      if (this.mouseDownPoint.x === this.currentPoint.x &&
        this.mouseDownPoint.y === this.currentPoint.y) {
        this.onClick(event)
      }
      // **********************************************************************
      // ファイルデータ追加
      // **********************************************************************
      if (this.opeStatus.adding) {
        // 離したのが、右の描画エリアだったら追加
        if (this.isOnCanvasArea) {
          // ph1:コンバインは1スケルトンのみ対応
          if (this.isCombineEdit &&
              PLANNING_TYPE.UNIT_SKELTON === this.draggedFileData.topSpaceModel.planningType &&
              this.fileData.topSpaceModel.childrenSpaceModel.find(child => PLANNING_TYPE.UNIT_SKELTON === child.planningType)) {
            AppUtil.showModal({
              messages: ['既にスケルトンが配置されているため、追加できません。'],
              messageType: 'error'
            })
          } else {
            this.onDropFileData()
          }
        }
        this.hideStalkingRect()
        this.draggedFileData = {}
        this.addCtrlSpace = {}
      }
      if (this.opeStatus.editing) {
        if (event.ctrlKey && this.editType === EDIT_TYPE.MOVE) {
          // **********************************************************************
          // 空間コピー&ペースト
          // **********************************************************************
          let addTargetSpace = this.addTargetSpace
          this.copyAndPasteSpace(addTargetSpace)
        } else {
          // **********************************************************************
          // 空間編集
          // **********************************************************************
          this.editSpace()
        }
      }
      // **********************************************************************
      // 範囲選択
      // **********************************************************************
      if (this.opeStatus.selecting && this.opeStatus.dragging) {
        // 選択対象：ユニットの場合のみ
        if (this.opeMode.selectObject === OBJECT_TYPE.UNIT.code) {
          if (!event.shiftKey) this.editCtrlSpaces = []
          let selectedUnitSpaces = SpaceUtil.selectUnitSpaces(
            this.selectArea,
            this.globalSpaceMap,
            this.currentView,
            this.currentViewRotate,
            this.selectablePlanningTypes.length ? space => this.selectablePlanningTypes.includes(space.planningType) : space => true
          )
          selectedUnitSpaces
            .map(space => {
              // プランニング時
              if (this.isPlanning) {
                // 一番上にあるセットプラン
                let parentSetPlan = SpaceUtil.getTopParentByCond(
                  space,
                  this.globalSpaceMap.get(this.currentView),
                  space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(space.spaceObjectType)
                )
                if (Object.keys(parentSetPlan).length) return parentSetPlan
                // 親コンバイン
                let parentCombine = SpaceUtil.getParentByCond(
                  space,
                  this.globalSpaceMap.get(this.currentView),
                  space => space.spaceObjectType === OBJECT_TYPE.COMBINE.code
                )
                if (Object.keys(parentCombine).length) return parentCombine
              }
              // セットプラン編集中
              if (this.isSetPlanning) {
                // 親空間を除いて、一番上にあるセットプラン
                let parentSetPlan = SpaceUtil.getTopParentByCond(
                  space,
                  this.globalSpaceMap.get(this.currentView),
                  space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(space.spaceObjectType) && space.parentSpaceId !== 0
                )
                if (Object.keys(parentSetPlan).length) return parentSetPlan
                // 親コンバイン
                let parentCombine = SpaceUtil.getParentByCond(
                  space,
                  this.globalSpaceMap.get(this.currentView),
                  space => space.spaceObjectType === OBJECT_TYPE.COMBINE.code
                )
                if (Object.keys(parentCombine).length) return parentCombine
              }
              return space
            })
            .filter(space => space && Object.keys(space).length)
            .forEach(space => this.addEditCtrlSpace(space.id, true, true))
          if (!this.editCtrlSpaces.length) this.groupCtrlSpace = {}
        }
      }
      // **********************************************************************
      // 断面位置指定
      // **********************************************************************
      if (this.opeStatus.settingSectionPosition) {
        AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {sectionPosition: this.sectionPosition})
      }
      if (this.opeStatus.settingSectionPoint) {
        let sec = this.sectionPoints.filter(s => s.lineNo === this.activeSectionPoint)[0]
        this.updateSectionPoint(sec.lineNo, sec.pos)
      }
      // **********************************************************************
      // 全体共通処理
      // **********************************************************************
      // 操作ステータスの初期化
      this.opeStatus = Object.assign(this.opeStatus, {
        grabbingInner: false,
        grabbingBorder: false,
        editing: false,
        adding: false,
        selecting: false,
        dragging: false,
        mouseButton: MOUSE_BUTTON.UNDEFINED,
        snapped: { x: false, y: false },
        settingSectionPosition: false,
        settingSectionPoint: false,
        movingCanvas: false,
        resizingCanvas: false,
        moveXOnly: false,
        moveYOnly: false
      })
      this.editFace = FACE_TYPE.UNDEFINED
      this.editType = EDIT_TYPE.UNDEFINED
      this.addTargetSpace = null
      this.snapLines = []
      this.selectArea = {}
      // 面間距離設定中でない場合
      if (!this.opeMode.faceDistanceMove || this.selectedFaces.length !== 2 || this.faceDistance === null) {
        this.positionGuideLines = []
      }
      this.changeCursor(event)
    },
    onMousemove: function (event) {
      if (event.ctrlKey) {
        this.isCtrlKey = true
      } else {
        this.isCtrlKey = false
      }
      // mousedown時にもmousemoveが発火するため移動量なしの場合はリターン
      if (event.movementX === 0 && event.movementY === 0) return
      // **********************************************************************
      // 全体共通処理
      // **********************************************************************
      this.setCurrentPointerPosition(event)
      if (this.opeStatus.mouseDown) {
        this.opeStatus.dragging = true
      }
      // キャンバスを外れた時のステータス解除
      if (!this.isOnCanvasArea) {
        this.currentPointOnCanvas = {}
        this.prevPointOnCanvas = {}
        this.currentTargetSpace = {}
        this.addTargetSpace = null
        this.clearCurrentView()
        this.opeStatus.settingSectionPosition = false
      }
      if (!this.isOnCanvas) {
        this.opeStatus.movingCanvas = false
      }
      // **********************************************************************
      // サイドタブ指定
      // **********************************************************************
      if (this.sideTabFlag) {
        // ドラッグしている間、サイドタブのサイズを変更する
        let varWidth = Number(this.canvasWidth) + Number(event.movementX)
        // 最小・最大の判定
        let element = document.getElementById('side_tab_nav')
        if (element !== undefined) {
          let style = window.getComputedStyle(element)
          if (style !== null && style !== undefined) {
            let min = style.getPropertyValue('min-width').replace('px', '')
            let max = style.getPropertyValue('max-width').replace('px', '')
            if (min !== '' && varWidth < min) {
              varWidth = min
            } else if (max !== '' && varWidth > max) {
              varWidth = max
            }
          }
        }

        // 横幅の更新
        this.canvasWidth = varWidth
        // キャンバスサイズ変更にともなうクリア
        this.adjustViewBox()
      }

      // キャンバス移動・リサイズ関連
      this.setResizeCanvasAreaStatus()
      this.moveCanvas()
      this.resizeCanvasMask(event)
      // カーソル変更
      this.changeCursor(event)
      if (!this.opeStatus.adding && !this.opeStatus.editing) {
        // **********************************************************************
        // 断面位置指定
        // **********************************************************************
        if (this.isOnCanvasArea) {
          let convertedSectionPosition = SpaceUtil.convertSpaceDataForDisp(this.sectionPosition, this.currentView, this.currentViewRotate)
          // セッティング中
          if (this.opeStatus.settingSectionPosition) {
            if (AXIS_TYPE.X === this.activeSectionPosition) convertedSectionPosition.x = Math.round(this.currentPointOnCanvas.x)
            if (AXIS_TYPE.Y === this.activeSectionPosition) convertedSectionPosition.y = Math.round(this.currentPointOnCanvas.y)
            let tmp = SpaceUtil.convertSpaceDataFromDisp(convertedSectionPosition, this.currentView, this.currentViewRotate)
            this.sectionPosition = {
              x: isNaN(tmp.x) ? 0 : tmp.x,
              y: isNaN(tmp.y) ? 0 : tmp.y,
              z: isNaN(tmp.z) ? 0 : tmp.z
            }
          } else {
            // マウスオーバー時に太線表示
            if (!this.opeStatus.selecting) {
              if (Math.abs(this.currentPointOnCanvas.x - convertedSectionPosition.x) < this.selectRange && this.currentPointOnCanvas.y < 0) {
                this.activeSectionPosition = AXIS_TYPE.X
              } else if (Math.abs(this.currentPointOnCanvas.y - convertedSectionPosition.y) < this.selectRange && this.currentPointOnCanvas.x < 0) {
                this.activeSectionPosition = AXIS_TYPE.Y
              } else {
                this.activeSectionPosition = AXIS_TYPE.UNDEFINED
              }
            }
          }

          if (this.opeStatus.settingSectionPoint) {
            let sec = this.sectionPoints.filter(s => s.lineNo === this.activeSectionPoint)[0]
            let point = {
              x: Math.round(this.currentPointOnCanvas.x),
              y: Math.round(this.currentPointOnCanvas.y)
            }
            let tmp = SpaceUtil.convertSpaceDataFromDisp(point, this.currentView, this.currentViewRotate)
            switch (sec.axis) {
              case 'X':
                sec.pos = tmp.x
                break
              case 'Y':
                sec.pos = tmp.y
                break
              case 'Z':
                sec.pos = tmp.z
                break
            }
          } else {
            let lineNo = null
            this.sectionPoints.forEach(sec => {
              let point
              let axis
              switch (this.currentView.code) {
                case 'LEFT':
                case 'RIGHT':
                  if (sec.axis === 'X') return
                  if (sec.axis === 'Y') axis = 'Y'
                  if (sec.axis === 'Z') axis = 'X'
                  break
                case 'BOTTOM':
                case 'TOP':
                  if (sec.axis === 'Y') return
                  if (sec.axis === 'X') axis = 'X'
                  if (sec.axis === 'Z') axis = 'Y'
                  break
                case 'BACK':
                case 'FRONT':
                  if (sec.axis === 'Z') return
                  if (sec.axis === 'X') axis = 'X'
                  if (sec.axis === 'Y') axis = 'Y'
                  break
              }
              switch (sec.axis) {
                case 'X':
                  point = {x: sec.pos, y: 0, z: 0}
                  break
                case 'Y':
                  point = {x: 0, y: sec.pos, z: 0}
                  break
                case 'Z':
                  point = {x: 0, y: 0, z: sec.pos}
                  break
              }
              let cnvdPoint = SpaceUtil.convertSpaceDataForDisp(point, this.currentView, this.currentViewRotate)
              if (axis === 'X' && Math.abs(this.currentPointOnCanvas.x - cnvdPoint.x) < this.selectRange && this.currentPointOnCanvas.y < 0) {
                lineNo = sec.lineNo
              } else if (axis === 'Y' && Math.abs(this.currentPointOnCanvas.y - cnvdPoint.y) < this.selectRange && this.currentPointOnCanvas.x < 0) {
                lineNo = sec.lineNo
              }
            })
            this.activeSectionPoint = lineNo
          }
        }

        // **********************************************************************
        // 範囲選択
        // **********************************************************************
        if (this.opeStatus.selecting) {
          this.selectArea = Object.assign({}, {
            x1: this.mouseDownPointOnCanvas.x,
            y1: this.mouseDownPointOnCanvas.y,
            x2: this.currentPointOnCanvas.x,
            y2: this.currentPointOnCanvas.y
          })
        }
      }
      // **********************************************************************
      // ファイルデータ追加
      // **********************************************************************
      if (this.opeStatus.adding) {
        this.showStalkingRect(event)

        if (this.isOnCanvasArea && this.fileData && Object.keys(this.fileData).length) {
          if (
            // プラン時は下記の空間の追加は自由配置
            (this.isPlanning &&
            [PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.COMBINE, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.UNIT_FACE_OPTION,
              PLANNING_TYPE.SETPLAN, PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_SHELF,
              PLANNING_TYPE.UNIT_INFILL, PLANNING_TYPE.ACCESSORY]
              .includes(this.draggedFileData.topSpaceModel.planningType)) ||
            // セットプラン時は下記の空間の追加は自由配置
            (this.isSetPlanning &&
            [PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.COMBINE, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.UNIT_FACE_OPTION,
              PLANNING_TYPE.SETPLAN, PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_SHELF,
              PLANNING_TYPE.UNIT_INFILL, PLANNING_TYPE.ACCESSORY]
              .includes(this.draggedFileData.topSpaceModel.planningType)) ||
            // コンバイン時は下記の空間の追加は自由配置
            (this.isCombineEdit &&
            [PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_INFILL, PLANNING_TYPE.UNIT_FACE_OPTION,
              PLANNING_TYPE.ACCESSORY]
              .includes(this.draggedFileData.topSpaceModel.planningType))
          ) {
            this.hideStalkingRect()
            this.editType = EDIT_TYPE.ADD
            // 追加処理実行
            this.addSpaceMain()
          }

          // コンバイン時のスケルトン追加は固定配置
          if (this.isCombineEdit &&
            PLANNING_TYPE.UNIT_SKELTON === this.draggedFileData.topSpaceModel.planningType) {
            this.hideStalkingRect()
            this.editType = EDIT_TYPE.ADD
            this.addCtrlSpace = Object.assign({}, this.draggedFileData.topSpaceModel)
          }

          // 追加対象空間取得
          let topSpaceModel = this.draggedFileData.topSpaceModel
          let attr = this.draggedFileData.attributeModelList.find(a => a.spaceId === topSpaceModel.id)
          this.addTargetSpace = SpaceUtil.getAddTargetSpace(topSpaceModel, attr, this.globalSpaceMap,
            this.currentView, this.svgZoomRatio, this.currentPointOnCanvas, this.currentViewRotate, this.fileData, this.outOfSectionSpaceIds)
          // 位置ガイド線表示
          this.setPositionGuideLines()
        } else if (!this.isOnCanvasArea) {
          this.addCtrlSpace = {}
          this.positionGuideLines = []
        }
        return
      }
      // **********************************************************************
      // 面間距離表示/設定モード時
      // **********************************************************************
      if (this.opeMode.faceDistanceDisp || this.opeMode.faceDistanceMove) {
        // パーツが表示対象でない場合は処理なし
        if (!this.dispSpaceObjectTypes.includes(OBJECT_TYPE.PARTS.code)) return
        // 断面位置設定中は処理なし
        if (this.opeStatus.settingSectionPosition) return

        this.currentTargetSpace = SpaceUtil.getEditTargetSpace(
          this.globalSpaceMap,
          this.currentView,
          this.svgZoomRatio,
          this.currentPointOnCanvas,
          this.currentViewRotate,
          this.outOfSectionSpaceIds,
          this.opeMode.faceDistanceDisp ? [OBJECT_TYPE.PARTS.code, OBJECT_TYPE.PLAN.code]
            : this.opeMode.faceDistanceMove && this.selectedFaces.length === 0 ? [OBJECT_TYPE.UNIT.code, OBJECT_TYPE.PLAN.code]
              : [OBJECT_TYPE.UNIT.code],
          []
        )
        if (this.currentTargetSpace && Object.keys(this.currentTargetSpace).length) {
          let currentTargetSpaceGlobal = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === this.currentTargetSpace.id)
          let tmpTargetFace = SpaceUtil.isOnBorder(
            currentTargetSpaceGlobal,
            this.currentView,
            this.currentPointOnCanvas,
            this.currentViewRotate,
            this.currentViewInverse,
            this.selectRange
          )
          if (tmpTargetFace !== FACE_TYPE.UNDEFINED) {
            this.selectTargetFace.faceType = FaceUtil.convertFaceTypeFromDisp(tmpTargetFace, this.currentView, this.currentViewRotate, this.currentViewInverse)
            this.selectTargetFace.space = currentTargetSpaceGlobal
            return
          }
        }
        this.selectTargetFace = {space: {}, faceType: FACE_TYPE.UNDEFINED}
        return
      }
      // **********************************************************************
      // 空間編集
      // **********************************************************************
      if (this.isOnCanvasArea) {
        if (!this.prevPointOnCanvas.x || !this.prevPointOnCanvas.y) return
        // 空間ドラッグ中
        if (this.opeStatus.editing) {
          this.editType = this.opeStatus.grabbingInner ? EDIT_TYPE.MOVE : EDIT_TYPE.RESIZE

          // shift押しながらの移動はxかyのみの垂直、水平移動のみとする
          if (event.shiftKey) {
            // クリックした位置からx方向に大きくドラッグしていれば水平移動、yが多きければ垂直移動
            let x = Math.abs(this.mouseDownPointOnCanvas.x - this.currentPointOnCanvas.x)
            let y = Math.abs(this.mouseDownPointOnCanvas.y - this.currentPointOnCanvas.y)
            this.opeStatus.moveXOnly = y <= x
            this.opeStatus.moveYOnly = x < y
          } else {
            this.opeStatus.moveXOnly = false
            this.opeStatus.moveYOnly = false
          }
          // 編集処理実行
          this.editSpaceMain()

          // 位置ガイド線表示
          this.setPositionGuideLines()

        // 空間ドラッグ中以外
        } else {
          // 編集対象空間がある場合優先
          let isOnGroupCtrlSpace = SpaceUtil.isOnSpace(this.groupCtrlSpace, this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange)
          if (isOnGroupCtrlSpace) {
            this.currentTargetSpace = this.groupCtrlSpace
          } else {
            // 現在のカーソル位置から操作対象空間を判定
            this.currentTargetSpace = SpaceUtil.getEditTargetSpace(
              this.globalSpaceMap,
              this.currentView,
              this.svgZoomRatio,
              this.currentPointOnCanvas,
              this.currentViewRotate,
              this.outOfSectionSpaceIds,
              [OBJECT_TYPE.UNIT.code, OBJECT_TYPE.COMBINE.code],
              this.selectablePlanningTypes
            )
            let topParentSpace = SpaceUtil.getTopParentByCond(
              this.currentTargetSpace,
              this.globalSpaceMap.get(this.currentView),
              space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code, OBJECT_TYPE.COMBINE.code].includes(space.spaceObjectType)
            )
            // 扉選択モードのとき、セットプラン・コンバインは操作不可
            if (this.opeMode.selectMode === SELECT_MODE.DOOR_DRAWER_INFILL.code && Object.keys(topParentSpace).length) {
              this.currentTargetSpace = {}
            }
          }
        }
      }
    },
    /** ウィンドウリサイズ時 */
    onResize: function () {
      this.adjustViewBox()
    },
    /** キー押下時 */
    onKeydown: function (event) {
      if (event.ctrlKey && event.altKey && event.keyCode === KEY_CODE.N) {
        event.preventDefault()
        this.onNew()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.S) {
        event.preventDefault()
        this.onSave()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.Z) {
        event.preventDefault()
        this.undo()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.Y) {
        event.preventDefault()
        this.redo()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.A) {
        event.preventDefault()
        this.selectAllSpace()
      } else if (event.keyCode === KEY_CODE.DELETE) {
        event.preventDefault()
        this.deleteSpace()
      } else if (event.ctrlKey && event.shiftKey && event.keyCode === KEY_CODE.P) {
        event.preventDefault()
        this.onPreview()
      } else if (event.ctrlKey && event.shiftKey && event.keyCode === KEY_CODE.C) {
        event.preventDefault()
        this.showSetCellRatioModal()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.C) {
        event.preventDefault()
        this.copySpace()
      } else if (event.ctrlKey && event.keyCode === KEY_CODE.V) {
        event.preventDefault()
        this.pasteSpace()
      } else if (event.keyCode === KEY_CODE.ESC) {
        event.preventDefault()
        this.clearEditCtrlSpace()
        this.selectedFaces = []
        this.changeCursor()
      }
    },
    /** キー解放時 */
    onKeyup: function (event) {
    },
    /** ファイルデータリスト-編集ボタンクリック時 */
    onClickEdit: function (spaceJoincd) {
      if (this.fileData.topSpaceModel && Object.keys(this.fileData.topSpaceModel).length) {
        let modalData = {
          messages: ['編集を開始しますか？',
            '※現在、編集中のデータがあります。',
            '新たに編集を開始すると編集中の内容はクリアされます。'],
          modalType: 'confirm',
          textAlign: 'left',
          onOk: this.loadFile,
          callbackParams: { spaceJoincd: spaceJoincd }
        }
        AppUtil.showModal(modalData)
      } else {
        this.loadFile({ spaceJoincd: spaceJoincd })
      }
      this.clearSpaceTreeFlg()
    },
    /** ダブルクリック */
    dblclick: function () {
      // 断面線のアイコンをダブルクリックした場合、図面断面線を追加する
      if (this.activeSectionPosition !== AXIS_TYPE.UNDEFINED) {
        this.addSheetSection(this.activeSectionPosition)
      }
    },
    /** ファイルデータリスト-削除ボタンクリック時 */
    onClickDeleteFile: function (spaceJoincd) {
      let modalData = {
        messages: ['ファイルデータを削除しますか？'],
        modalType: 'confirm',
        onOk: this.deleteFile,
        callbackParams: { spaceJoincd: spaceJoincd }
      }
      AppUtil.showModal(modalData)
    },
    /** ファイルデータリスト-カート挿入ボタンクリック時 */
    onClickSketchAddCart: function (fileData) {
      let modalData = {
        spaceJoincd: fileData.spaceJoincd,
        fdId: fileData.fdId,
        planId: fileData.fileCode,
        corpName: fileData.planEcModel.ecSnapCorpName,
        userName: fileData.planEcModel.ecSnapUserLastName + fileData.planEcModel.ecSnapUserFirstName + ' 様',
        sketchComment: ''
      }
      this.$refs.sketchAddCartRef.showModal(modalData)
    },
    /** ファイルデータリスト-スケッチ情報ボタンクリック時 */
    onClickSketchView: function (fileData) {
      let modalData = {
        fdId: fileData.fdId,
        corpId: fileData.corpId,
        planId: fileData.fileCode,
        corpName: fileData.planEcModel.ecSnapCorpName,
        userName: fileData.planEcModel.ecSnapUserLastName + fileData.planEcModel.ecSnapUserFirstName + ' 様',
        sketchComment: fileData.skupModel.skupComment,
        sketchImg1: fileData.skupModel.skupImgOrgName1,
        sketchImg2: fileData.skupModel.skupImgOrgName2,
        sketchImg3: fileData.skupModel.skupImgOrgName3,
        sketchImg4: fileData.skupModel.skupImgOrgName4,
        sketchImg5: fileData.skupModel.skupImgOrgName5,
        imgMime1: fileData.skupModel.imgMime1,
        imgMime2: fileData.skupModel.imgMime2,
        imgMime3: fileData.skupModel.imgMime3,
        imgMime4: fileData.skupModel.imgMime4,
        imgMime5: fileData.skupModel.imgMime5
      }
      this.$refs.sketchViewRef.showModal(modalData)
    },
    /** ファイルデータリスト-公開申請ボタンクリック時 */
    onClickMmstyleRequest: function (fileData) {
      this.$refs.mmstyleRequestRef.showModal(fileData)
    },
    /** ファイルデータリスト-公開取消ボタンクリック時 */
    onClickMmstyleCancel: function (fileData) {
      let modalData = {
        messages: ['公開を取り消しますか？'],
        modalType: 'confirm',
        onOk: () => {
          this.$refs.mmstyleRequestRef.requestCancel(fileData)
        }
      }
      AppUtil.showModal(modalData)
    },
    // 他コンポーネントへの連携用
    /** イベントリスナ有効化 */
    addPlanningEventListener: function () {
      document.addEventListener('mousedown', this.onMousedown)
      document.addEventListener('mouseup', this.onMouseup)
      document.addEventListener('mousemove', this.onMousemove)
      document.addEventListener('keydown', this.onKeydown)
      document.addEventListener('keyup', this.onKeyup)
      document.addEventListener('dblclick', this.dblclick)
      this.isPlanningOff = false
    },
    /** イベントリスナ無効化 */
    removePlanningEventListener: function () {
      document.removeEventListener('mousedown', this.onMousedown)
      document.removeEventListener('mouseup', this.onMouseup)
      document.removeEventListener('mousemove', this.onMousemove)
      document.removeEventListener('keydown', this.onKeydown)
      document.removeEventListener('keyup', this.onKeyup)
      this.isPlanningOff = true
    },
    // *****************************************************************
    // キャンバス・ビュー制御
    // *****************************************************************
    /** SVGのviewBox設定 */
    adjustViewBox: function () {
      let upside = document.getElementById('canvas-upside')
      let side = document.getElementById('canvas-side')
      let leftWidth = Math.round(upside.clientWidth * this.svgZoomRatio)
      let topHeight = Math.round(upside.clientHeight * this.svgZoomRatio)
      let rightWidth = Math.round(side.clientWidth * this.svgZoomRatio)
      let bottomHeight = Math.round(side.clientHeight * this.svgZoomRatio)
      this.viewBox.main = Object.assign(this.viewBox.main, { width: leftWidth, height: bottomHeight })
      this.viewBox.upside = Object.assign(this.viewBox.upside, { width: leftWidth, height: topHeight })
      this.viewBox.side = Object.assign(this.viewBox.side, { width: rightWidth, height: bottomHeight })
    },
    /** キャンバスエリアのリサイズ可能領域か監視 */
    setResizeCanvasAreaStatus: function () {
      // ドラッグ中は無視
      if (this.opeStatus.dragging && this.opeStatus.resizingCanvas) return
      // モーダル表示中は無視
      if (this.$refs.setCellRatioModalRef && this.$refs.setCellRatioModalRef.modalShown) return
      if (this.$refs.newModalRef && this.$refs.newModalRef.modalShown) return
      if (this.$refs.faceDistanceMoveModalRef && this.$refs.faceDistanceMoveModalRef.modalShown) return
      let commonModal = document.getElementById('modal')
      if (commonModal.style.display && commonModal.style.display !== 'none') return

      let lt = document.getElementById('canvas-upside').getBoundingClientRect()
      let rb = document.getElementById('canvas-side').getBoundingClientRect()
      let resizeCanvasAreaC = { xMin: lt.right, xMax: rb.left, yMin: lt.bottom, yMax: rb.top }
      let resizeCanvasAreaV = { xMin: lt.left, xMax: rb.right, yMin: lt.bottom, yMax: rb.top }
      let resizeCanvasAreaH = { xMin: lt.right, xMax: rb.left, yMin: lt.top, yMax: rb.bottom }
      if (resizeCanvasAreaC.xMin <= this.currentPoint.x && this.currentPoint.x <= resizeCanvasAreaC.xMax &&
        resizeCanvasAreaC.yMin <= this.currentPoint.y && this.currentPoint.y <= resizeCanvasAreaC.yMax) {
        this.currentResizeCanvasArea = {center: true, vertical: false, horizontal: false}
      } else if (resizeCanvasAreaV.xMin < this.currentPoint.x && this.currentPoint.x < resizeCanvasAreaV.xMax &&
        resizeCanvasAreaV.yMin < this.currentPoint.y && this.currentPoint.y < resizeCanvasAreaV.yMax) {
        this.currentResizeCanvasArea = {center: false, vertical: true, horizontal: false}
      } else if (resizeCanvasAreaH.xMin < this.currentPoint.x && this.currentPoint.x < resizeCanvasAreaH.xMax &&
        resizeCanvasAreaH.yMin < this.currentPoint.y && this.currentPoint.y < resizeCanvasAreaH.yMax) {
        this.currentResizeCanvasArea = {center: false, vertical: false, horizontal: true}
      } else {
        this.currentResizeCanvasArea = {center: false, vertical: false, horizontal: false}
      }
    },
    /** キャンバスリサイズマスク表示 */
    showResizeCanvasMask: function (event) {
      let main = document.getElementById('canvas-area')
      let idList = ['canvas-upside', 'canvas-main', 'canvas-empty', 'canvas-side']
      idList.forEach(id => {
        let original = document.getElementById(id).getBoundingClientRect()
        let mask = document.getElementById(id + '-mask')
        mask.style.left = original.left - 1 + 'px'
        mask.style.top = original.top - 1 + 'px'
        mask.style.width = original.width + 'px'
        mask.style.height = original.height + 'px'
        mask.style.display = 'block'
        mask.style.cursor = main.style.cursor
      })
    },
    /** キャンバスエリアマスクサイズ変更 */
    resizeCanvasMask: function (event) {
      // ドラッグしている場合は、サイズ変更
      if (!this.opeStatus.dragging || !this.opeStatus.resizingCanvas) {
        return
      }
      event.stopPropagation()
      let main = document.getElementById('canvas-area')
      let lt = document.getElementById('canvas-upside-mask')
      let lb = document.getElementById('canvas-main-mask')
      let rt = document.getElementById('canvas-empty-mask')
      let rb = document.getElementById('canvas-side-mask')
      let ltStyle = lt.getBoundingClientRect()
      if (this.currentResizeCanvasArea.center || this.currentResizeCanvasArea.vertical) {
        let mainHeight = main.clientHeight
        let topHeight = this.currentPoint.y - ltStyle.top - 3.5
        let bottomTop = this.currentPoint.y + 2.5
        let bottomHeight = mainHeight - topHeight - 17.5
        if (topHeight > VIEW_SIZE_MIN && bottomHeight > VIEW_SIZE_MIN) {
          lt.style.height = topHeight + 'px'
          rt.style.height = topHeight + 'px'
          lb.style.top = bottomTop + 'px'
          lb.style.height = bottomHeight + 'px'
          rb.style.top = bottomTop + 'px'
          rb.style.height = bottomHeight + 'px'
        }
      }
      if (this.currentResizeCanvasArea.center || this.currentResizeCanvasArea.horizontal) {
        let mainWidth = main.clientWidth
        let leftWidth = this.currentPoint.x - ltStyle.left - 3.5
        let rightLeft = this.currentPoint.x + 2.5
        let rightWidth = mainWidth - leftWidth
        if (leftWidth > VIEW_SIZE_MIN && rightWidth > VIEW_SIZE_MIN) {
          lt.style.width = leftWidth + 'px'
          lb.style.width = leftWidth + 'px'
          rt.style.left = rightLeft + 'px'
          rt.style.width = rightWidth + 'px'
          rb.style.left = rightLeft + 'px'
          rb.style.width = rightWidth + 'px'
        }
      }
    },
    /** キャンバスエリアサイズ変更 */
    resizeCanvas: function () {
      if (!this.opeStatus.resizingCanvas) {
        return
      }
      // マスクの非表示
      let maskList = Array.prototype.slice.call(document.getElementsByClassName('canvas_mask'))
      maskList.forEach(e => { e.style.display = 'none' })

      if (!this.opeStatus.dragging) {
        return
      }
      let main = document.getElementById('canvas-area')
      let lt = document.getElementById('canvas-upside')
      let lb = document.getElementById('canvas-main')
      let rt = document.getElementById('canvas-empty')
      let rb = document.getElementById('canvas-side')
      let ltStyle = lt.getBoundingClientRect()
      // 各固定値はCSSによる
      if (this.currentResizeCanvasArea.center || this.currentResizeCanvasArea.vertical) {
        let mainHeight = main.clientHeight
        let topHeight = lt.clientHeight + (this.currentPoint.y - ltStyle.bottom) + 7
        if (topHeight < VIEW_SIZE_MIN) {
          topHeight = VIEW_SIZE_MIN
        }
        let bottomHeight = mainHeight - topHeight
        if (bottomHeight < VIEW_SIZE_MIN) {
          bottomHeight = VIEW_SIZE_MIN
          topHeight = mainHeight - bottomHeight
        }
        let bottomHeightPer = 'calc(' + bottomHeight / mainHeight * 100 + '% - 10px)'
        lt.style.height = 'calc(' + topHeight / mainHeight * 100 + '% - 10px)'
        rt.style.height = 'calc(' + topHeight / mainHeight * 100 + '% - 50px)'
        lb.style.height = bottomHeightPer
        rb.style.height = bottomHeightPer
      }
      if (this.currentResizeCanvasArea.center || this.currentResizeCanvasArea.horizontal) {
        let mainWidth = main.clientWidth
        let leftWidth = lt.clientWidth + (this.currentPoint.x - ltStyle.right) + 5
        if (leftWidth < VIEW_SIZE_MIN) {
          leftWidth = VIEW_SIZE_MIN
        }
        let rightWidth = mainWidth - leftWidth
        if (rightWidth < VIEW_SIZE_MIN) {
          rightWidth = VIEW_SIZE_MIN
          leftWidth = mainWidth - rightWidth
        }
        let leftWidthPer = 'calc(' + leftWidth / mainWidth * 100 + '% - 7px)'
        lt.style.width = leftWidthPer
        lb.style.width = leftWidthPer
        rt.style.width = 'calc(' + rightWidth / mainWidth * 100 + '% - 47px)'
        rb.style.width = 'calc(' + rightWidth / mainWidth * 100 + '% - 7px)'
      }
      // SVG viewBoxの再調整
      this.adjustViewBox()
    },
    /** グラフ領域のズーム */
    zoomCanvas: function (wheelAmount) {
      let prevSvgZoomRatio = this.svgZoomRatio
      for (let {threshold, speed} of SVG_ZOOM_SPEED) {
        // ズームインの場合は閾値含まず、ズームアウトの場合は閾値含む
        if ((Math.sign(wheelAmount) > 0 && this.svgZoomRatio > threshold) ||
          (Math.sign(wheelAmount) < 0 && this.svgZoomRatio >= threshold)) {
          this.svgZoomRatio -= Math.sign(wheelAmount) * speed
          break
        }
      }
      // 小数点以下2桁で丸める
      this.svgZoomRatio = Math.round(this.svgZoomRatio * 100) / 100
      if (this.svgZoomRatio < SVG_ZOOM_RATIO_MIN) {
        this.svgZoomRatio = SVG_ZOOM_RATIO_MIN
        return
      }
      // マウスカーソルの位置を基準にズームする
      let x = this.currentPointOnCanvas.x
      let y = this.currentPointOnCanvas.y
      let tmpZoomRatio = this.svgZoomRatio / prevSvgZoomRatio
      // 現在編集対象のキャンバスがundefinedの場合は処理終了
      if (this.currentCanvas === CANVAS_TYPE.UNDEFINED || !this.currentCanvas) {
        this.svgZoomRatio = prevSvgZoomRatio
        return
      }
      let newMinX = x - (x - this.viewBox[this.currentCanvas].minX) * tmpZoomRatio
      let newMinY = y - (y - this.viewBox[this.currentCanvas].minY) * tmpZoomRatio
      // 非数の場合は設定しない
      if (isNaN(newMinX) || isNaN(newMinY)) {
        this.svgZoomRatio = prevSvgZoomRatio
        return
      }
      this.viewBox[this.currentCanvas].minX = newMinX
      this.viewBox[this.currentCanvas].minY = newMinY
      if (CANVAS_TYPE.MAIN === this.currentCanvas) {
        this.viewBox.upside.minX = newMinX
        this.viewBox.side.minY = newMinY
      } else if (CANVAS_TYPE.UPSIDE === this.currentCanvas) {
        this.viewBox.main.minX = newMinX
        this.viewBox.side.minX = newMinY
      } else if (CANVAS_TYPE.SIDE === this.currentCanvas) {
        this.viewBox.upside.minY = newMinX
        this.viewBox.main.minY = newMinY
      }
      this.adjustViewBox()

      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {svgZoomRatio: this.svgZoomRatio})
    },
    /** キャンバスエリア座標系移動 */
    moveCanvas: function () {
      if (this.opeStatus.movingCanvas && this.opeStatus.dragging) {
        // キャンバス上の座標を使用するとviewBoxの値とポインタ位置の算出で処理がループしてしまい挙動が狂うため、
        // グローバル座標から算出する。
        let dx = (this.currentPoint.x - this.prevPoint.x) * this.svgZoomRatio
        let dy = (this.currentPoint.y - this.prevPoint.y) * this.svgZoomRatio
        if (!isNaN(dx) && !isNaN(dy)) {
          let currentViewSet = this.viewSet[this.currentCanvas]
          dx = currentViewSet.inverse.x ? -dx : dx
          dy = currentViewSet.inverse.y ? dy : -dy
          // 自ビューの移動
          this.viewBox[this.currentCanvas].minX -= dx
          this.viewBox[this.currentCanvas].minY -= dy
          // 他ビューの移動
          if (CANVAS_TYPE.MAIN === this.currentCanvas) {
            this.viewBox.upside.minX -= dx
            this.viewBox.side.minY -= dy
          } else if (CANVAS_TYPE.UPSIDE === this.currentCanvas) {
            this.viewBox.main.minX -= dx
            this.viewBox.side.minX -= dy
          } else if (CANVAS_TYPE.SIDE === this.currentCanvas) {
            this.viewBox.upside.minY -= dx
            this.viewBox.main.minY -= dy
          }
        }
      }
    },
    addSheetSection: function (axis) {
      let topSpace
      if (this.isPlanning) {
        topSpace = this.fileData.topSpaceModel.childrenSpaceModel[0]
      } else {
        topSpace = this.fileData.topSpaceModel
      }
      let pos
      switch (axis) {
        case 'X':
          pos = topSpace.w / 2
          break
        case 'Y':
          pos = topSpace.h / 2
          break
        case 'Z':
          pos = topSpace.d / 2
          break
      }
      this.addSectionPoint(axis, pos)
    },
    removeSheetSection: function (lineNo) {
      this.removeSectionPoint(lineNo)
    },
    /** ビューを初期化する */
    resetView: function () {
      // ビューの初期化
      this.setViewSet(VIEW_TYPE.FRONT)
      this.viewBox = {
        main: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 },
        upside: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 },
        side: { minX: SVG_MIN_DEFAULT, minY: SVG_MIN_DEFAULT, width: 0, height: 0 }
      }
      this.svgZoomRatio = SVG_ZOOM_RATIO_DEFAULT
      let lt = document.getElementById('canvas-upside')
      lt.style.width = 'calc(70% - 7px)'
      lt.style.height = 'calc(30% - 10px)'
      let rt = document.getElementById('canvas-empty')
      rt.style.width = 'calc(30% - 47px)'
      rt.style.height = 'calc(30% - 50px)'
      let lb = document.getElementById('canvas-main')
      lb.style.width = 'calc(70% - 7px)'
      lb.style.height = 'calc(70% - 10px)'
      let rb = document.getElementById('canvas-side')
      rb.style.width = 'calc(30% - 7px)'
      rb.style.height = 'calc(70% - 10px)'
      this.adjustViewBox()
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {
        svgZoomRatio: this.svgZoomRatio,
        viewSetNo: this.viewSet.no
      })
      // 断面位置の初期化
      this.setSectionPosition(true)
    },
    // セル比率設定対象親空間をセット
    setEditTargetCellSpaceParent (parentSpace) {
      this.editTargetCellSpaceParent = parentSpace
    },
    // *****************************************************************
    // UI制御系
    // *****************************************************************
    /** ユニット一覧からのD&Dで四角を描画する */
    showStalkingRect: function (event) {
      let topSpace = this.draggedFileData.topSpaceModel
      let width = topSpace.w / 5
      let height = topSpace.h / 5
      let left = event.clientX - width > 0 ? event.clientX - width / 2 : width / 2
      let top = event.clientY - height > 0 ? event.clientY - height / 2 : height / 2
      // ファイルデータD&D時の四角表示用DOM
      let stalkingRectDom = document.getElementById('stalking-rect')
      stalkingRectDom.style.width = width + 'px'
      stalkingRectDom.style.height = height + 'px'
      stalkingRectDom.style.left = left + 'px'
      stalkingRectDom.style.top = top + 'px'
      stalkingRectDom.style.display = 'block'
    },
    /** ユニット一覧からのD&Dでの四角を非表示にする */
    hideStalkingRect: function () {
      let stalkingRectDom = document.getElementById('stalking-rect')
      stalkingRectDom.style.display = 'none'
    },
    /* カーソル表示変更 event.targetだと他の要素に移動した際にスタイルが変わってしまうため、container-mainに設定 */
    changeCursor: function (event) {
      let target = document.getElementById('container-main')
      // **********************************************************************
      // 共通
      // **********************************************************************
      // ドラッグ中は変更しない
      if (this.opeStatus.dragging) {
        return
      }
      // ファイルデータ追加時
      if (this.opeStatus.adding) {
        target.style.cursor = 'grab'
        return
      }
      // キャンバスリサイズ
      if (this.currentResizeCanvasArea.center) {
        target.style.cursor = 'all-scroll'
        return
      }
      if (this.currentResizeCanvasArea.vertical) {
        target.style.cursor = 'row-resize'
        return
      }
      if (this.currentResizeCanvasArea.horizontal) {
        target.style.cursor = 'col-resize'
        return
      }
      // **********************************************************************
      // キャンバスエリア内
      // **********************************************************************
      if (this.isOnCanvasArea) {
        // キャンバス移動
        if (this.isOnCanvas && this.opeStatus.movingCanvas) {
          target.style.cursor = 'grab'
          return
        }
        // 断面位置指定
        if (this.activeSectionPosition !== AXIS_TYPE.UNDEFINED) {
          target.style.cursor = 'pointer'
          return
        }
        // 面間距離表示モード時
        if (this.opeMode.faceDistanceDisp || this.opeMode.faceDistanceMove) {
          target.style.cursor = Object.keys(this.selectTargetFace.space).length ? 'pointer' : 'default'
          return
        }
        // 範囲選択
        if (this.opeStatus.selecting) {
          target.style.cursor = 'default'
          return
        }
        // フォーカス中空間が編集操作用空間と異なる場合
        if (Object.keys(this.currentTargetSpace).length && !this.editCtrlSpaces.find(e => e.id === this.currentTargetSpace.id)) {
          target.style.cursor = 'pointer'
          return
        }

        let editFaceBeforeConvert = SpaceUtil.isOnBorder(
          this.groupCtrlSpace,
          this.currentView,
          this.currentPointOnCanvas,
          this.currentViewRotate,
          this.currentViewInverse,
          this.selectRange
        )
        this.editFace = FaceUtil.convertFaceTypeFromDisp(editFaceBeforeConvert, this.currentView, this.currentViewRotate, this.currentViewInverse)
        // 操作対象空間が一つで固定方向の面の場合は移動のみ許容
        if (this.editCtrlSpaces.length === 1 &&
          SpaceUtil.isFix(this.editCtrlSpaces[0], this.editFace, this.currentView, this.currentViewRotate)) {
          editFaceBeforeConvert = FACE_TYPE.UNDEFINED
        }
        // 操作対象空間が複数で棚板の場合は移動のみ許容
        let shelfs = this.editCtrlSpaces.filter(e => PLANNING_TYPE.UNIT_SHELF === e.planningType)
        if (shelfs.length > 1) {
          editFaceBeforeConvert = FACE_TYPE.UNDEFINED
        }
        if (FaceUtil.isFaceOfAxis(editFaceBeforeConvert, AXIS_TYPE.X)) {
          target.style.cursor = 'e-resize'
        } else if (FaceUtil.isFaceOfAxis(editFaceBeforeConvert, AXIS_TYPE.Y)) {
          target.style.cursor = 'n-resize'
        } else if (editFaceBeforeConvert === FACE_TYPE.UNDEFINED &&
          SpaceUtil.isOnSpace(this.groupCtrlSpace, this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange)) {
          target.style.cursor = 'move'
        } else {
          target.style.cursor = 'default'
        }
      }
    },
    /** 吸着時の累積移動距離設定 */
    updateTotalMoveAmountForSnap: function (moveAmount) {
      let moveAmountResult = Object.assign({}, moveAmount)
      if (this.opeStatus.snapped.x) {
        this.totalMoveAmountForSnap.dx += moveAmount.dx
      } else {
        this.totalMoveAmountForSnap.dx = 0
      }
      if (this.opeStatus.snapped.y) {
        this.totalMoveAmountForSnap.dy += moveAmount.dy
      } else {
        this.totalMoveAmountForSnap.dy = 0
      }
      // 累積移動量が閾値を超えたら吸着解除
      if (this.opeStatus.snapped.x && Math.abs(this.totalMoveAmountForSnap.dx) > SnapUtil.getSnapDist(SNAP_DIST, this.svgZoomRatio)) {
        moveAmountResult.dx = this.totalMoveAmountForSnap.dx
        this.totalMoveAmountForSnap.dx = 0
        this.opeStatus.snapped.x = false
      }
      if (this.opeStatus.snapped.y && Math.abs(this.totalMoveAmountForSnap.dy) > SnapUtil.getSnapDist(SNAP_DIST, this.svgZoomRatio)) {
        moveAmountResult.dy = this.totalMoveAmountForSnap.dy
        this.totalMoveAmountForSnap.dy = 0
        this.opeStatus.snapped.y = false
      }
      return moveAmountResult
    },
    /* 位置ガイド線表示 */
    setPositionGuideLines: function (f) {
      if (!this.fileData || !Object.keys(this.fileData).length) return

      // ガイド線を表示する対象空間
      let targetSpaces = []
      if (this.opeStatus.adding) {
        targetSpaces.push(this.addCtrlSpace)
      } else if (this.opeStatus.editing) {
        // プランニングの移動時は全ての空間を包括する空間サイズ
        if (this.isPlanning && EDIT_TYPE.MOVE === this.editType) {
          let targetSpace = SpaceUtil.getWrapSpace(this.editCtrlSpaces)
          targetSpace.id = this.editCtrlSpaces[0].id
          targetSpace.parentSpaceId = this.editCtrlSpaces[0].parentSpaceId
          targetSpace.planningType = this.editCtrlSpaces[0].planningType
          targetSpaces.push(targetSpace)
        } else {
          targetSpaces.push(...this.editCtrlSpaces)
        }
      }
      // 選択中の空間のid
      let targetSpaceIds = this.editCtrlSpaces.map(space => space.id)
      let globalSpaces = this.globalSpaceMap.get(VIEW_TYPE.FRONT)
      // 空間配下のidも対象に追加
      this.editCtrlSpaces.forEach(space => {
        targetSpaceIds.push(space.id)
        SpaceUtil.createSklUnderSpaceIds(space, targetSpaceIds, globalSpaces, this.fileData.attributeModelList)
      })
      this.positionGuideLines = []

      for (let space of targetSpaces) {
        let convTargetSpace = EDIT_TYPE.ADD === this.editType ? SpaceUtil.convertSpaceDataFromDisp(this.addTargetSpace, this.currentView, this.currentViewRotate) : {}
        // リサイズ時、空間自体のサイズを表示
        if (EDIT_TYPE.RESIZE === this.editType) {
          if ([PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.COMBINE, PLANNING_TYPE.SETPLAN].includes(space.planningType)) {
            switch (FaceUtil.getVerticalAxis(this.editFace)) {
              case AXIS_TYPE.X:
                this.positionGuideLines.push({x: space.x, y: space.y + space.h + 50, z: space.z + space.d + 50, l: space.w, axis: AXIS_TYPE.X})
                break
              case AXIS_TYPE.Y:
                this.positionGuideLines.push({x: space.x + space.w + 50, y: space.y, z: space.z + space.d + 50, l: space.h, axis: AXIS_TYPE.Y})
                break
              case AXIS_TYPE.Z:
                this.positionGuideLines.push({x: space.x + space.w + 50, y: space.y + space.h + 50, z: space.z, l: space.d, axis: AXIS_TYPE.Z})
                break
            }
          }
        }
        // スケルトン個別処理
        if ([PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.COMBINE, PLANNING_TYPE.SETPLAN].includes(space.planningType)) {
          // プランニング時
          if (this.isPlanning) {
            // 各軸方向に重なるスケルトンがあればそのスケルトンまでの距離
            // 操作対象空間を除いたスケルトン
            let otherSkeltons = this.globalSpaceMap.get(VIEW_TYPE.FRONT)
              .filter(other => PLANNING_TYPE.UNIT_SKELTON === other.planningType || PLANNING_TYPE.UNIT_SURFACE === other.planningType ||
              PLANNING_TYPE.UNIT_DOOR === other.planningType || PLANNING_TYPE.UNIT_DRAWER === other.planningType)
              .filter(other => !targetSpaceIds.includes(other.id))
            // 各面方向で最も近いスケルトン
            let nextSkeltons = {}
            let checkFaces = [FACE_TYPE.LEFT, FACE_TYPE.RIGHT, FACE_TYPE.BOTTOM, FACE_TYPE.TOP, FACE_TYPE.FRONT, FACE_TYPE.BACK]
            checkFaces.forEach(selfFace => {
              let otherFace = FaceUtil.getOtherFace(selfFace)
              // 対象綿に垂直な2方向をチェック
              let otherAxis1 = FaceUtil.getVerticalAxis(selfFace) === AXIS_TYPE.X ? AXIS_TYPE.Y : FaceUtil.getVerticalAxis(selfFace) === AXIS_TYPE.Y ? AXIS_TYPE.Z : AXIS_TYPE.X
              let verticalBaseFace1 = FaceUtil.getBaseFace(otherAxis1)
              let verticalOtherFace1 = FaceUtil.getOtherFace(verticalBaseFace1)
              let verticalCenter1 = (FaceUtil.getFacePosition(space, verticalBaseFace1) + FaceUtil.getFacePosition(space, verticalOtherFace1)) / 2
              let otherAxis2 = FaceUtil.getVerticalAxis(selfFace) === AXIS_TYPE.X ? AXIS_TYPE.Z : FaceUtil.getVerticalAxis(selfFace) === AXIS_TYPE.Y ? AXIS_TYPE.X : AXIS_TYPE.Y
              let verticalBaseFace2 = FaceUtil.getBaseFace(otherAxis2)
              let verticalOtherFace2 = FaceUtil.getOtherFace(verticalBaseFace2)
              let verticalCenter2 = (FaceUtil.getFacePosition(space, verticalBaseFace2) + FaceUtil.getFacePosition(space, verticalOtherFace2)) / 2
              let nextSkelton = otherSkeltons
                .filter(other => {
                  // 距離の表示軸方向については外側のもの
                  let isOuterForAxis = FaceUtil.isBaseFace(selfFace)
                    ? FaceUtil.getFacePosition(space, selfFace) > FaceUtil.getFacePosition(other, otherFace)
                    : FaceUtil.getFacePosition(space, selfFace) < FaceUtil.getFacePosition(other, otherFace)
                  // 距離の表示軸に垂直な軸方向については自空間の中心が相手空間の範囲に収まっているもの
                  let isBetweenForVerticalAxis =
                    (FaceUtil.getFacePosition(other, verticalBaseFace1) < verticalCenter1 &&
                    verticalCenter1 < FaceUtil.getFacePosition(other, verticalOtherFace1)) &&
                    (FaceUtil.getFacePosition(other, verticalBaseFace2) < verticalCenter2 &&
                    verticalCenter2 < FaceUtil.getFacePosition(other, verticalOtherFace2))
                  return isOuterForAxis && isBetweenForVerticalAxis
                }).reduce((a, b) => {
                  if (!Object.keys(a).length) return b
                  let distA = FaceUtil.getFaceDistance(space, selfFace, a, otherFace)
                  let distB = FaceUtil.getFaceDistance(space, selfFace, b, otherFace)
                  return (Math.abs(distA) < Math.abs(distB)) ? a : b
                }, {})
              if (nextSkelton && Object.keys(nextSkelton).length) {
                nextSkeltons[selfFace] = Object.assign({}, nextSkelton)
              }
            })
            // スケルトンの配置・移動、または左右面操作のリサイズの場合、X軸方向を表示
            let centerX = space.x + space.w / 2
            let centerY = space.y + space.h / 2
            let centerZ = space.z + space.d / 2
            if (EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.X) && FaceUtil.isBaseFace(this.editFace))) {
              if (Object.keys(nextSkeltons).includes(FACE_TYPE.LEFT)) {
                let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.LEFT], FACE_TYPE.RIGHT)
                this.positionGuideLines.push({ x: otherFacePos, y: centerY, z: centerZ, l: space.x - otherFacePos, axis: AXIS_TYPE.X })
              } else {
                this.positionGuideLines.push({ x: 0, y: centerY, z: centerZ, l: space.x, axis: AXIS_TYPE.X })
              }
            }
            if ((EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.X) && !FaceUtil.isBaseFace(this.editFace))) &&
              Object.keys(nextSkeltons).includes(FACE_TYPE.RIGHT)) {
              let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.RIGHT], FACE_TYPE.LEFT)
              this.positionGuideLines.push({ x: space.x + space.w, y: centerY, z: centerZ, l: otherFacePos - (space.x + space.w), axis: AXIS_TYPE.X })
            }
            // スケルトンの配置・移動、または上下面操作のリサイズの場合、Y方向を表示
            if (EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Y) && FaceUtil.isBaseFace(this.editFace))) {
              if (Object.keys(nextSkeltons).includes(FACE_TYPE.BOTTOM)) {
                let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.BOTTOM], FACE_TYPE.TOP)
                this.positionGuideLines.push({ x: centerX, y: otherFacePos, z: centerZ, l: space.y - otherFacePos, axis: AXIS_TYPE.Y })
              } else {
                this.positionGuideLines.push({ x: centerX, y: 0, z: centerZ, l: space.y, axis: AXIS_TYPE.Y })
              }
            }
            if ((EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Y) && !FaceUtil.isBaseFace(this.editFace))) &&
                Object.keys(nextSkeltons).includes(FACE_TYPE.TOP)) {
              let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.TOP], FACE_TYPE.BOTTOM)
              this.positionGuideLines.push({ x: centerX, y: space.y + space.h, z: centerZ, l: otherFacePos - (space.y + space.h), axis: AXIS_TYPE.Y })
            }
            // スケルトンの配置・移動、または前後面操作のリサイズの場合、Z方向を表示
            if (EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Z) && FaceUtil.isBaseFace(this.editFace))) {
              if (Object.keys(nextSkeltons).includes(FACE_TYPE.BACK)) {
                let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.BACK], FACE_TYPE.FRONT)
                this.positionGuideLines.push({ x: centerX, y: centerY, z: otherFacePos, l: space.z - otherFacePos, axis: AXIS_TYPE.Z })
              } else {
                this.positionGuideLines.push({ x: centerX, y: centerY, z: 0, l: space.z, axis: AXIS_TYPE.Z })
              }
            }
            if ((EDIT_TYPE.RESIZE !== this.editType ||
              (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Z) && !FaceUtil.isBaseFace(this.editFace))) &&
                Object.keys(nextSkeltons).includes(FACE_TYPE.FRONT)) {
              let otherFacePos = FaceUtil.getFacePosition(nextSkeltons[FACE_TYPE.FRONT], FACE_TYPE.BACK)
              this.positionGuideLines.push({ x: centerX, y: centerY, z: space.z + space.d, l: otherFacePos - (space.z + space.d), axis: AXIS_TYPE.Z })
            }
          }
        }
        // 棚個別処理
        if (PLANNING_TYPE.UNIT_SHELF === space.planningType) {
          // 移動 ※単数選択のみ
          if (EDIT_TYPE.MOVE === this.editType && this.editCtrlSpaces.length === 1) {
            // 棚板の兄弟空間取得
            let nextCells = SpaceUtil.getNextCellsOfShelf(this.fileData, space, this.globalSpaceMap)
            if (nextCells.left) {
              this.positionGuideLines.push({ x: nextCells.left.x, y: space.y + space.h / 2, z: space.z + space.d / 2, l: space.x - nextCells.left.x, axis: AXIS_TYPE.X })
            }
            if (nextCells.right) {
              this.positionGuideLines.push({ x: space.x + space.w, y: space.y + space.h / 2, z: space.z + space.d / 2, l: (nextCells.right.x + nextCells.right.w) - (space.x + space.w), axis: AXIS_TYPE.X })
            }
            if (nextCells.bottom) {
              this.positionGuideLines.push({ x: space.x + space.w / 2, y: nextCells.bottom.y, z: space.z + space.d / 2, l: space.y - nextCells.bottom.y, axis: AXIS_TYPE.Y })
            }
            if (nextCells.top) {
              this.positionGuideLines.push({ x: space.x + space.w / 2, y: space.y + space.h, z: space.z + space.d / 2, l: (nextCells.top.y + nextCells.top.h) - (space.y + space.h), axis: AXIS_TYPE.Y })
            }
          }
          // 追加
          if (EDIT_TYPE.ADD === this.editType && this.addTargetSpace.spaceObjectType === OBJECT_TYPE.CELL.code) {
            if (OBJECT_DTL_TYPE.UNIT_INNER_SEPARATOR.code === space.spaceObjectDtlType) {
              this.positionGuideLines.push({ x: convTargetSpace.x, y: convTargetSpace.y + convTargetSpace.h / 2, z: convTargetSpace.z + convTargetSpace.d / 2, l: space.x - this.addTargetSpace.x, axis: AXIS_TYPE.X })
              this.positionGuideLines.push({ x: space.x + space.w, y: convTargetSpace.y + convTargetSpace.h / 2, z: convTargetSpace.z + convTargetSpace.d / 2, l: (this.addTargetSpace.x + this.addTargetSpace.w) - (space.x + space.w), axis: AXIS_TYPE.X })
            } else {
              this.positionGuideLines.push({ x: convTargetSpace.x + convTargetSpace.w / 2, y: convTargetSpace.y, z: convTargetSpace.z + convTargetSpace.d / 2, l: space.y - this.addTargetSpace.y, axis: AXIS_TYPE.Y })
              this.positionGuideLines.push({ x: convTargetSpace.x + convTargetSpace.w / 2, y: space.y + space.h, z: convTargetSpace.z + convTargetSpace.d / 2, l: (this.addTargetSpace.y + this.addTargetSpace.h) - (space.y + space.h), axis: AXIS_TYPE.Y })
            }
          }
        }
        // 引き出し個別処理
        if (PLANNING_TYPE.UNIT_DRAWER === space.planningType) {
          let checkPointX = EDIT_TYPE.ADD === this.editType ? convTargetSpace.x + convTargetSpace.w / 2 : space.x + space.w / 2
          let targetSpaceList = []
          let topDistanceList = []
          let bottomDistanceList = []
          this.globalSpaceMap.get(VIEW_TYPE.FRONT).forEach(target => {
            // 天板・地板・棚・引き出しを探す
            if (target.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_TOP_BOARD.code ||
            target.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_BOTTOM_BOARD.code ||
            target.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_FIX_SHELF.code ||
            target.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_DRAWER.code) {
              if (target.id !== space.id && checkPointX > target.x && checkPointX < target.x + target.w) {
                targetSpaceList.push(target)
              }
            }
          })
          targetSpaceList.map(target => {
            // 対象面からの距離が正ならリストに
            let topDistance = target.y - (space.y + space.h)
            if (!isNaN(topDistance) && topDistance >= 0) {
              topDistanceList.push(topDistance)
            }
            let bottomDistance = space.y - (target.y + target.h)
            if (!isNaN(bottomDistance) && bottomDistance >= 0) {
              bottomDistanceList.push(bottomDistance)
            }
          })
          // 最小値を計算
          let top = topDistanceList.length ? topDistanceList.reduce((a, b) => a < b ? a : b) : 0
          let bottom = bottomDistanceList.length ? bottomDistanceList.reduce((a, b) => a < b ? a : b) : 0
          let posZ = EDIT_TYPE.ADD === this.editType ? convTargetSpace.z + convTargetSpace.d / 2 : space.z + space.d / 2
          if (top > 0) {
            this.positionGuideLines.push({ x: checkPointX, y: space.y + space.h, z: posZ, l: top, axis: AXIS_TYPE.Y })
          }
          if (bottom > 0) {
            this.positionGuideLines.push({ x: checkPointX, y: space.y - bottom, z: posZ, l: bottom, axis: AXIS_TYPE.Y })
          }
        }
      }
    },
    /** 選択パーツ位置のガイド線を設定 */
    setFrDistGuideLine: function (lineDataList) {
      this.positionGuideLines = []
      lineDataList.forEach(fr => {
        this.addTargetSpace = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => OBJECT_TYPE.ROOM.code === space.spaceObjectType)
        let space1 = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => fr.id1 === space.id)
        let space2 = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => fr.id2 === space.id)
        let posX = (space1.x + space1.w / 2 + space2.x + space2.w / 2) / 2
        let posY = (space1.y + space1.h / 2 + space2.y + space2.h / 2) / 2
        let posZ = (space1.z + space1.d / 2 + space2.z + space2.d / 2) / 2
        let base = FaceUtil.getFacePosition(space1, fr.faceType1) < FaceUtil.getFacePosition(space2, fr.faceType2) ? FaceUtil.getFacePosition(space1, fr.faceType1) : FaceUtil.getFacePosition(space2, fr.faceType2)
        switch (fr.faceType1) {
          case FACE_TYPE.TOP:
          case FACE_TYPE.BOTTOM:
          case FACE_TYPE.BTC:
            // 上下
            this.positionGuideLines.push({ x: posX, y: base, z: posZ, l: fr.dist, axis: AXIS_TYPE.Y })
            break
          case FACE_TYPE.LEFT:
          case FACE_TYPE.RIGHT:
          case FACE_TYPE.LRC:
            // 左右
            this.positionGuideLines.push({ x: base, y: posY, z: posZ, l: fr.dist, axis: AXIS_TYPE.X })
            break
          case FACE_TYPE.FRONT:
          case FACE_TYPE.BACK:
          case FACE_TYPE.BFC:
            // 前後
            this.positionGuideLines.push({ x: posX, y: posY, z: base, l: fr.dist, axis: AXIS_TYPE.Z })
            break
          default:
        }
      })
    },
    /** 位置ガイド線の初期化 */
    clearFrDistGuideLine: function () {
      this.positionGuideLines = []
    },
    // *****************************************************************
    // データ処理・状態管理系
    // *****************************************************************
    /** 現在のマウスポインタ位置設定(ローカル) */
    setCurrentPointerPositionOnCanvas: function (event, viewBox) {
      this.prevPointOnCanvas = {
        x: this.currentPointOnCanvas.x,
        y: this.currentPointOnCanvas.y
      }
      this.currentPointOnCanvas = {
        x: CalcUtil.round(event.offsetX * this.svgZoomRatio + viewBox.minX, 1),
        y: CalcUtil.round(event.offsetY * this.svgZoomRatio + viewBox.minY, 1)
      }
    },
    /** 現在のマウスポインタ位置設定(グローバル) */
    setCurrentPointerPosition: function (event) {
      this.prevPoint = {
        x: this.currentPoint.x,
        y: this.currentPoint.y
      }
      this.currentPoint = {
        x: event.pageX,
        y: event.pageY
      }
    },
    /** 現在のマウスポインタのビュー設定 */
    setCurrentView: function (viewType, canvasType) {
      this.currentView = viewType
      this.currentCanvas = canvasType
      // ビューの回転と反転も設定
      if (viewType !== VIEW_TYPE.UNDEFINED) {
        let currentViewSet = this.viewSet[canvasType]
        if (currentViewSet) {
          this.currentViewRotate = currentViewSet.rotate
          this.currentViewInverse = currentViewSet.inverse
        }
      } else {
        this.currentViewRotate = null
        this.currentViewInverse = {}
      }
    },
    clearCurrentView: function () {
      this.setCurrentView(VIEW_TYPE.UNDEFINED, CANVAS_TYPE.UNDEFINED)
    },
    /** マウスポインタがキャンバス上にあるか */
    setOnCanvas: function (isOnCanvas) {
      this.isOnCanvas = isOnCanvas
    },
    /** ビューセット設定 */
    setViewSet: function (mainViewType) {
      this.viewSet = VIEW_SET.find(viewSet => viewSet.main.viewType === mainViewType)
      // グローバル座標空間マップ再生成
      this.createGlobalSpaceMap()
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {viewSetNo: this.viewSet.no})
    },
    /** セル比率設定モーダル表示 */
    showSetCellRatioModal: function () {
      this.$refs.setCellRatioModalRef.showModal()
    },
    /** スタイルカラー設定モーダル表示 */
    showStyleColorModal: function () {
      this.$refs.styleColorModalRef.showModal()
    },
    /** ファイルデータD&D時 */
    onDropFileData: function () {
      if (!this.fileData.topSpaceModel || !Object.keys(this.fileData.topSpaceModel).length) {
        AppUtil.showModal({
          messages: ['ファイルを新規作成してください。'],
          onOk: this.onNew
        })
        return
      }
      // サーフェス配置時個別処理
      this.setSurface(this.addCtrlSpace)
      // 追加対象空間が指定されていなくても、プランニング時のスケルトン、サーフェス、コンバイン配置はルーム空間
      if (!this.addTargetSpace || !Object.keys(this.addTargetSpace).length) {
        if ([PLANNING_TYPE.UNIT_SKELTON, PLANNING_TYPE.UNIT_SURFACE, PLANNING_TYPE.COMBINE, PLANNING_TYPE.ACCESSORY, PLANNING_TYPE.SETPLAN].includes(this.draggedFileData.topSpaceModel.planningType)) {
          if (this.isPlanning) {
            this.addTargetSpace = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => OBJECT_TYPE.ROOM.code === space.spaceObjectType)
          } else if (this.isSetPlanning) {
            this.addTargetSpace = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(space.spaceObjectType))
          }
        }
      }
      // API呼び出し
      if (this.addTargetSpace && Object.keys(this.addTargetSpace).length) {
        if (this.addTargetSpace.planningType === this.draggedFileData.topSpaceModel.planningType) {
          // 空間の上書き
          this.swapSpace()
        } else {
          // 空間の追加
          this.addSpace()
        }
        this.addTargetSpace = null
      }
    },
    /** 空間追加時の主処理 */
    addSpaceMain: function () {
      // 追加操作用空間設定
      this.addCtrlSpace = Object.assign({}, this.draggedFileData.topSpaceModel)
      // カーソル位置を空間の中心として配置
      let roundedPoint = {x: Math.round(this.currentPointOnCanvas.x), y: Math.round(this.currentPointOnCanvas.y)}
      SpaceUtil.setSpaceByCenter(this.addCtrlSpace, roundedPoint, this.currentView, this.currentViewRotate)
      // 配置範囲制御
      this.addCtrlSpace.x = this.addCtrlSpace.x < 0 ? 0 : this.addCtrlSpace.x
      this.addCtrlSpace.y = this.addCtrlSpace.y < 0 ? 0 : this.addCtrlSpace.y
      this.addCtrlSpace.z = this.addCtrlSpace.z < 0 ? 0 : this.addCtrlSpace.z
      // 吸着
      // 吸着可能位置取得
      let snappablePositions = SnapUtil.getSnapPositions(
        this.addCtrlSpace,
        this.fileData.topSpaceModel,
        this.globalSpaceMap,
        this.currentView,
        this.editType,
        this.editFace,
        this.currentViewRotate,
        this.currentViewInverse,
        this.snapRule,
        this.svgZoomRatio
      )
      if (snappablePositions && snappablePositions.length) {
        // 実際に採用する吸着情報 {minDist(最小吸着距離), positionList(実際に採用する吸着情報)}
        this.snapPositions = SnapUtil.getValidSnapPositions(snappablePositions)
        // 吸着線描画
        this.snapLines = [...this.snapPositions.positionList.x, ...this.snapPositions.positionList.y]
          .map(e => {
            if (e.ownFaceType) return SnapUtil.getFaceLine(e.tagSpace, e.tagFaceType, this.currentViewInverse)
            else if (e.ownAxisType) return SnapUtil.getAxisLine(e.tagSpace, e.tagAxisType)
          })
        // 吸着分を加算
        let minSnapDistConverted = SpaceUtil.convertSpaceDataForDisp(this.snapPositions.minDist, this.currentView, this.currentViewRotate)
        this.addCtrlSpace.x += (minSnapDistConverted.x || 0)
        this.addCtrlSpace.y += (minSnapDistConverted.y || 0)
        this.addCtrlSpace.z += (minSnapDistConverted.z || 0)
      } else {
        this.snapPositions = {}
        this.snapLines = []
      }
      // サーフェスの配置制御
      if (this.snapPositions && this.snapPositions.positionList && PLANNING_TYPE.UNIT_SURFACE === this.addCtrlSpace.planningType) {
        let snapSurfaceIds = []
        if (this.snapPositions.positionList.y.length) {
          this.snapPositions.positionList.y.forEach(obj => {
            if (snapSurfaceIds.indexOf(obj.tagSpace.id) < 0) {
              snapSurfaceIds.push(obj.tagSpace.id)
            }
          })
        }
        if (this.snapPositions.positionList.x.length) {
          this.snapPositions.positionList.x.forEach(obj => {
            if (snapSurfaceIds.indexOf(obj.tagSpace.id) < 0) {
              snapSurfaceIds.push(obj.tagSpace.id)
            }
          })
        }
        // 吸着対象空間
        let snapTargetSpaces = []
        snapSurfaceIds.forEach(id => {
          let targetSpace = this.globalSpaceMap.get(this.currentView).find(e => e.id === id)
          snapTargetSpaces.push(SpaceUtil.convertSpaceDataFromDisp(targetSpace, this.currentView, this.currentViewRotate))
        })
        let isOnSnapTarget = false
        snapTargetSpaces.forEach(space => {
          isOnSnapTarget = SpaceUtil.isOnSpace(space, this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange) ? true : isOnSnapTarget
        })
        // 吸着対象空間をカーソルから近い順にソート
        snapTargetSpaces.sort((a, b) => {
          let aMinX = Math.min(Math.abs(a.x - this.currentPointOnCanvas.x), Math.abs(a.x + a.w - this.currentPointOnCanvas.x))
          let aMinY = Math.min(Math.abs(a.y - this.currentPointOnCanvas.y), Math.abs(a.y + a.h - this.currentPointOnCanvas.y))
          let bMinX = Math.min(Math.abs(b.x - this.currentPointOnCanvas.x), Math.abs(b.x + b.w - this.currentPointOnCanvas.x))
          let bMinY = Math.min(Math.abs(b.y - this.currentPointOnCanvas.y), Math.abs(b.y + b.h - this.currentPointOnCanvas.y))
          return (aMinX + aMinY) - (bMinX + bMinY)
        })
        this.snapSurfaceSpace = snapTargetSpaces[0]
        // カーソルが吸着先空間上の場合
        if (this.addCtrlSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code && isOnSnapTarget) {
          this.snapPositions = this.snapPositions
          this.addCtrlSpace.y = snapTargetSpaces[0].y + snapTargetSpaces[0].h
          this.snapSurfaceFaceType = FACE_TYPE.BOTTOM
        } else if (this.addCtrlSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_ENDPANEL.code && isOnSnapTarget) {
          this.snapPositions = this.snapPositions
          let leftSide = snapTargetSpaces[0].x
          let rightSide = snapTargetSpaces[0].x + snapTargetSpaces[0].w
          // 左右のカーソルの近い方に吸着
          if (rightSide - this.currentPointOnCanvas.x < this.currentPointOnCanvas.x - leftSide) {
            this.addCtrlSpace.x = rightSide
            this.snapSurfaceFaceType = FACE_TYPE.LEFT
          } else {
            this.addCtrlSpace.x = leftSide - this.addCtrlSpace.w
            this.snapSurfaceFaceType = FACE_TYPE.RIGHT
          }
        }
      }
      if (!snappablePositions && !snappablePositions.length) {
        this.snapLines = []
        this.snapPositions = {}
      }
    },
    /** 空間編集時の実処理 */
    editSpaceMain: function () {
      // リサイズ可否判定
      if (this.editType === EDIT_TYPE.RESIZE &&
        !SpaceUtil.isResizable(this.editCtrlSpaces, this.fileData.topSpaceModel, this.editFace)) {
        return
      }
      // 移動可否判定
      if (this.editType === EDIT_TYPE.MOVE &&
        !SpaceUtil.isMovable(this.editCtrlSpaces, this.fileData.topSpaceModel)) {
        return
      }

      // カーソルの位置から移動距離を算出
      let moveAmount = {
        dx: Math.round(this.currentPointOnCanvas.x) - Math.round(this.prevPointOnCanvas.x),
        dy: Math.round(this.currentPointOnCanvas.y) - Math.round(this.prevPointOnCanvas.y)
      }

      // *****************************************************************
      // 水平、垂直移動時の移動距離の算出
      // *****************************************************************
      if (this.opeStatus.moveXOnly || this.opeStatus.moveYOnly) {
        // 元の空間から既に移動している距離算出
        let convertEditCtrlSpace = SpaceUtil.convertSpaceDataForDisp(this.editCtrlSpaces[0], this.currentView, this.currentViewRotate)
        let prevEditCtrlSpace = this.prevEditCtrlSpaces.find(e => e.id === this.editCtrlSpaces[0].id)
        let convertPrevEditCtrlSpace = SpaceUtil.convertSpaceDataForDisp(prevEditCtrlSpace, this.currentView, this.currentViewRotate)
        let totalMoveAmount = {
          dx: Math.round(convertEditCtrlSpace.x) - Math.round(convertPrevEditCtrlSpace.x),
          dy: Math.round(convertEditCtrlSpace.y) - Math.round(convertPrevEditCtrlSpace.y)
        }

        if (this.opeStatus.moveXOnly) {
          if (totalMoveAmount.dy !== 0) {
            // 水平移動ですでにy軸に動いている（ドラッグ途中でShift押した）場合はx軸をカーソルの位置に移動する
            moveAmount.dx = -totalMoveAmount.dx + Math.round(this.currentPointOnCanvas.x) - Math.round(this.mouseDownPointOnCanvas.x)
          }
          // 水平移動なのでyは元の空間のままで固定
          moveAmount.dy = -totalMoveAmount.dy
        } else if (this.opeStatus.moveYOnly) {
          if (totalMoveAmount.dx !== 0) {
            // 垂直移動ですでにX軸に動いている（ドラッグ途中でShift押した）場合はy軸をカーソルの位置に移動する
            moveAmount.dy = -totalMoveAmount.dy + Math.round(this.currentPointOnCanvas.y) - Math.round(this.mouseDownPointOnCanvas.y)
          }
          // 垂直移動なのでxは元の空間のままで固定
          moveAmount.dx = -totalMoveAmount.dx
        }
      }
      // サーフェスの移動制御
      if (this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code ||
          this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_ENDPANEL.code) {
        let snapSurfaceIds = []
        let isSameFaceType = false
        let ownFaceType = FACE_TYPE.UNDEFINED
        if (this.opeStatus.snapped.y && this.snapPositions.positionList.y.length &&
            this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code) {
          this.snapPositions.positionList.y.forEach(y => {
            isSameFaceType = y.ownFaceType === y.tagFaceType
            ownFaceType = y.ownFaceType
          })
          snapSurfaceIds = this.snapPositions.positionList.y.map(obj => obj.tagSpace.id)
        } else if (this.opeStatus.snapped.x && this.snapPositions.positionList.x.length &&
        this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_ENDPANEL.code) {
          this.snapPositions.positionList.x.forEach(x => {
            isSameFaceType = x.ownFaceType === x.tagFaceType
            ownFaceType = x.ownFaceType
          })
          snapSurfaceIds = this.snapPositions.positionList.x.map(obj => obj.tagSpace.id)
        }
        // 吸着対象空間
        let snapTargetSpaces = []
        snapSurfaceIds.forEach(id => {
          let targetSpace = this.globalSpaceMap.get(this.currentView).find(e => e.id === id)
          snapTargetSpaces.push(SpaceUtil.convertSpaceDataFromDisp(targetSpace, this.currentView, this.currentViewRotate))
        })
        // 吸着対象空間をカーソルから近い順にソート
        snapTargetSpaces.sort((a, b) => {
          let aMinX = Math.min(Math.abs(a.x - this.currentPointOnCanvas.x), Math.abs(a.x + a.w - this.currentPointOnCanvas.x))
          let aMinY = Math.min(Math.abs(a.y - this.currentPointOnCanvas.y), Math.abs(a.y + a.h - this.currentPointOnCanvas.y))
          let bMinX = Math.min(Math.abs(b.x - this.currentPointOnCanvas.x), Math.abs(b.x + b.w - this.currentPointOnCanvas.x))
          let bMinY = Math.min(Math.abs(b.y - this.currentPointOnCanvas.y), Math.abs(b.y + b.h - this.currentPointOnCanvas.y))
          return Math.min(aMinX, aMinY) - Math.min(bMinX, bMinY)
        })
        let isOnSnapTarget = false
        snapTargetSpaces.forEach(space => {
          isOnSnapTarget = SpaceUtil.isOnSpace(space, this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange) ? true : isOnSnapTarget
        })
        let isOnCurrentTarget = SpaceUtil.isOnSpace(this.editCtrlSpaces[0], this.currentView, this.currentPointOnCanvas, this.currentViewRotate, this.selectRange)

        // 同方向の吸着で、空間同士が重なっている場合は補正
        if ((isOnSnapTarget || isOnCurrentTarget) && isSameFaceType && this.editType === EDIT_TYPE.MOVE) {
          if (this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code) {
            if (ownFaceType === FACE_TYPE.TOP) {
              this.editCtrlSpaces[0].y = snapTargetSpaces[0].y + snapTargetSpaces[0].h
            } else if (ownFaceType === FACE_TYPE.BOTTOM) {
              this.editCtrlSpaces[0].y = snapTargetSpaces[0].y - this.editCtrlSpaces[0].h
            }
          } else {
            if (ownFaceType === FACE_TYPE.RIGHT) {
              this.editCtrlSpaces[0].x = snapTargetSpaces[0].x + snapTargetSpaces[0].w
            } else if (ownFaceType === FACE_TYPE.LEFT) {
              this.editCtrlSpaces[0].x = snapTargetSpaces[0].x - this.editCtrlSpaces[0].w
            }
          }
        }
        // 吸着先空間にカーソルが重なっていない場合
        if (!isOnSnapTarget && !isOnCurrentTarget) {
          moveAmount = this.updateTotalMoveAmountForSnap(moveAmount)
        }
      } else {
        moveAmount = this.updateTotalMoveAmountForSnap(moveAmount)
      }

      // 累積移動量算出

      // モジュール吸着※操作空間一つの場合のみ
      if (this.editCtrlSpaces.length === 1 && this.editType === EDIT_TYPE.RESIZE && this.moduleAtt && Object.keys(this.moduleAtt).length) {
        if ((FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.X) && this.moduleAtt.attValue1 !== 0) ||
          (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Y) && this.moduleAtt.attValue3 !== 0) ||
          (FaceUtil.isFaceOfAxis(this.editFace, AXIS_TYPE.Z) && this.moduleAtt.attValue5 !== 0)) {
          // リサイズ
          this.$set(
            this.tmpEditCtrlSpaces,
            0,
            SpaceUtil.resizeSpace(this.tmpEditCtrlSpaces[0], moveAmount, this.currentView, this.editFace, this.currentViewRotate)
          )
          let snapResult = SnapUtil.snapSpaceByModule(
            this.tmpEditCtrlSpaces[0],
            this.prevEditCtrlSpaces[0],
            this.editType,
            this.editFace,
            this.moduleAtt,
            this.svgZoomRatio
          )
          // 吸着しているときはチェックして反映
          if (snapResult.snapped) {
            let checkResult = SpaceUtil.checkEditable(
              snapResult.spaceData,
              this.fileData,
              this.editType,
              this.editFace,
              this.editCtrlableArea,
              this.globalSpaceMap
            )
            if (!checkResult.modified) {
              this.$set(this.editCtrlSpaces, 0, snapResult.spaceData)
            }
          }
          return
        }
      }

      // 吸着情報
      let snappablePositionsList = []

      // *****************************************************************
      // 各空間に移動・リサイズを行いながら吸着可否を算出
      // *****************************************************************
      for (let spaceIdx = 0; spaceIdx < this.editCtrlSpaces.length; spaceIdx++) {
        // 移動・リサイズ
        this.$set(
          this.tmpEditCtrlSpaces,
          spaceIdx,
          this.editType === EDIT_TYPE.MOVE
            ? SpaceUtil.moveSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.currentViewRotate)
            : SpaceUtil.resizeSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.editFace, this.currentViewRotate)
        )

        // 空間吸着
        // 各空間の吸着位置を取得
        let snappablePositions = SnapUtil.getSnapPositions(
          this.tmpEditCtrlSpaces[spaceIdx],
          this.fileData.topSpaceModel,
          this.globalSpaceMap,
          this.currentView,
          this.editType,
          this.editFace,
          this.currentViewRotate,
          this.currentViewInverse,
          this.snapRule,
          this.svgZoomRatio
        )
        snappablePositionsList.push(...snappablePositions)
      }
      // 扉空間の移動・リサイズ時、追加対象セル空間表示※複数選択時、移動・リサイズ不可
      if (this.tmpEditCtrlSpaces.length === 1) {
        // 引き出し
        if ([PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_INFILL].includes(this.tmpEditCtrlSpaces[0].planningType)) {
          this.addTargetSpace = SpaceUtil.getAddTargetSpace(
            this.tmpEditCtrlSpaces[0],
            null,
            this.globalSpaceMap,
            this.currentView,
            this.svgZoomRatio,
            this.currentPointOnCanvas,
            this.currentViewRotate,
            this.fileData,
            this.outOfSectionSpaceIds
          )
        }
        // 扉
        if ([PLANNING_TYPE.UNIT_DOOR].includes(this.tmpEditCtrlSpaces[0].planningType)) {
          this.addTargetSpace = SpaceUtil.getAddTargetSpace(
            this.tmpEditCtrlSpaces[0],
            null,
            this.globalSpaceMap,
            this.currentView,
            this.svgZoomRatio,
            this.currentPointOnCanvas,
            this.currentViewRotate,
            this.fileData,
            this.outOfSectionSpaceIds
          )
        }
      }

      // 実際に採用する吸着情報
      if (snappablePositionsList && snappablePositionsList.length) {
        // 実際に採用する吸着情報 {minDist(最小吸着距離), positionList(実際に採用する吸着情報)}
        this.snapPositions = SnapUtil.getValidSnapPositions(snappablePositionsList)
        // 吸着補正後の移動距離 ※吸着中は無視
        moveAmount = {
          dx: this.opeStatus.snapped.x ? 0 : moveAmount.dx + (this.snapPositions.minDist.x || 0),
          dy: this.opeStatus.snapped.y ? 0 : moveAmount.dy + (this.snapPositions.minDist.y || 0)
        }
      } else {
        this.snapPositions = {minDist: {x: null, y: null}, positionList: {x: [], y: []}}
      }
      // *****************************************************************
      // 吸着を考慮した操作距離を反映しながら制約チェック
      // *****************************************************************
      let maxInvalidDist = {x: 0, y: 0}
      for (let spaceIdx = 0; spaceIdx < this.editCtrlSpaces.length; spaceIdx++) {
        // 移動・リサイズ
        this.$set(
          this.tmpEditCtrlSpaces,
          spaceIdx,
          this.editType === EDIT_TYPE.MOVE
            ? SpaceUtil.moveSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.currentViewRotate)
            : SpaceUtil.resizeSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.editFace, this.currentViewRotate)
        )
        // 制約チェック
        let checkResult = SpaceUtil.checkEditable(
          this.tmpEditCtrlSpaces[spaceIdx],
          this.fileData,
          this.editType,
          this.editFace,
          this.editCtrlableArea,
          this.globalSpaceMap
        )
        let checkedSpace = checkResult.spaceData
        // 要修正距離
        let invalidDist = { x: null, y: null, z: null, w: null, h: null, d: null }
        Object.keys(invalidDist).forEach(key => {
          invalidDist[key] = (checkedSpace[key] - this.tmpEditCtrlSpaces[spaceIdx][key])
        })
        let convertedInvalidDist = SpaceUtil.convertSpaceDataForDisp(invalidDist, this.currentView, this.currentViewRotate)
        let sign = (EDIT_TYPE.RESIZE === this.editType && FaceUtil.isBaseFace(this.editFace)) ? -1 : 1
        let activeDist = EDIT_TYPE.MOVE === this.editType
          ? { x: convertedInvalidDist.x, y: convertedInvalidDist.y }
          : { x: sign * convertedInvalidDist.w, y: sign * convertedInvalidDist.h }
        // 最大値
        if (Math.abs(maxInvalidDist.x) < Math.abs(activeDist.x)) maxInvalidDist.x = activeDist.x
        if (Math.abs(maxInvalidDist.y) < Math.abs(activeDist.y)) maxInvalidDist.y = activeDist.y
      }

      // 制約補正後の移動距離
      moveAmount = {
        dx: moveAmount.dx + (maxInvalidDist.x || 0),
        dy: moveAmount.dy + (maxInvalidDist.y || 0)
      }

      // *****************************************************************
      // 最終的な操作距離を反映
      // *****************************************************************
      for (let spaceIdx = 0; spaceIdx < this.editCtrlSpaces.length; spaceIdx++) {
        // 移動・リサイズ
        this.$set(
          this.tmpEditCtrlSpaces,
          spaceIdx,
          this.editType === EDIT_TYPE.MOVE
            ? SpaceUtil.moveSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.currentViewRotate)
            : SpaceUtil.resizeSpace(this.editCtrlSpaces[spaceIdx], moveAmount, this.currentView, this.editFace, this.currentViewRotate)
        )
        // 正規のデータ(表示データ)にも反映
        this.$set(
          this.editCtrlSpaces,
          spaceIdx,
          Object.assign({}, this.tmpEditCtrlSpaces[spaceIdx])
        )
      }

      // 吸着線表示
      this.snapLines = [...this.snapPositions.positionList.x, ...this.snapPositions.positionList.y]
        .map(e => {
          if (e.ownFaceType) {
            return SnapUtil.getFaceLine(e.tagSpace, e.tagFaceType, this.currentViewInverse)
          } else if (e.ownAxisType) {
            return SnapUtil.getAxisLine(e.tagSpace, e.tagAxisType)
          }
        })

      // 吸着状態の更新
      if (!this.opeStatus.snapped.x && this.snapPositions.positionList.x.length) this.opeStatus.snapped.x = true
      if (!this.opeStatus.snapped.y && this.snapPositions.positionList.y.length) this.opeStatus.snapped.y = true
    },
    /** サーフェス配置時個別処理 */
    setSurface: function (draggedSpace) {
      // 吸着情報の再取得
      let snappablePositions = SnapUtil.getSnapPositions(
        this.addCtrlSpace,
        this.fileData.topSpaceModel,
        this.globalSpaceMap,
        this.currentView,
        this.editType,
        this.editFace,
        this.currentViewRotate,
        this.currentViewInverse,
        this.snapRule,
        this.svgZoomRatio
      )
      if (snappablePositions && snappablePositions.length) {
        // 実際に採用する吸着情報 {minDist(最小吸着距離), positionList(実際に採用する吸着情報)}
        this.snapPositions = SnapUtil.getValidSnapPositions(snappablePositions)
        // 吸着線描画
        this.snapLines = [...this.snapPositions.positionList.x, ...this.snapPositions.positionList.y]
          .map(e => {
            if (e.ownFaceType) return SnapUtil.getFaceLine(e.tagSpace, e.tagFaceType, this.currentViewInverse)
            else if (e.ownAxisType) return SnapUtil.getAxisLine(e.tagSpace, e.tagAxisType)
          })
      }
      if (!snappablePositions && !snappablePositions.length) {
        this.snapLines = []
        this.snapPositions = {}
      }
      // カウンター追加時は吸着している空間から最も近いものを選択
      if (PLANNING_TYPE.UNIT_SURFACE !== draggedSpace.planningType ||
        !this.snapPositions || !Object.keys(this.snapPositions).length ||
        !this.snapPositions.positionList) {
        return
      }
      let targetSpace = {}
      let snapFaceType = FACE_TYPE.UNDEFINED
      let faceSnappedSpaces = {}
      let snapPositionsList = [...this.snapPositions.positionList.x, ...this.snapPositions.positionList.y]
      if (EDIT_TYPE.RESIZE === this.editType) {
        // リサイズの場合、ビューに合わせて対象面を変換する
        snapPositionsList.forEach(snapPosition => {
          snapPosition.ownFaceType = SpaceUtil.convertFaceTypeFromViewType(snapPosition.ownFaceType, this.currentView)
        })
      }
      snapPositionsList
        .forEach(snapPosition => {
          if (!faceSnappedSpaces.hasOwnProperty(snapPosition.ownFaceType)) {
            faceSnappedSpaces[snapPosition.ownFaceType] = []
          }
          faceSnappedSpaces[snapPosition.ownFaceType].push(snapPosition.tagSpace)
        })
      Object.keys(faceSnappedSpaces)
        .forEach(ownFaceType => {
          // 一番近い吸着空間と接地面を設定
          targetSpace = this.snapSurfaceSpace
          faceSnappedSpaces[ownFaceType].forEach(space => {
            if (space.id === targetSpace.id) {
              snapFaceType = ownFaceType
            }
          })
        })
      this.editFace = this.snapSurfaceFaceType !== FACE_TYPE.UNDEFINED && this.editType !== EDIT_TYPE.RESIZE ? this.snapSurfaceFaceType
        : targetSpace.id && snapFaceType !== FACE_TYPE.UNDEFINED ? snapFaceType
          : this.editFace
      // 垂直方向への吸着は、対象先空間としない
      if (this.editType !== EDIT_TYPE.RESIZE) {
        if (this.addCtrlSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code && this.snapPositions.positionList.y.length === 0) {
          this.addTargetSpace = {}
          this.editFace = FACE_TYPE.UNDEFINED
        } else if (this.addCtrlSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_ENDPANEL.code && this.snapPositions.positionList.x.length === 0) {
          this.addTargetSpace = {}
          this.editFace = FACE_TYPE.UNDEFINED
        } else {
          this.addTargetSpace = targetSpace
        }
        // 軸に対して対象空間に接しているか
        let axis = this.addCtrlSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code ? AXIS_TYPE.X : AXIS_TYPE.Y
        if (!SpaceUtil.isOverlapSpaceToAxis(this.addCtrlSpace, this.addTargetSpace, axis)) {
          this.addTargetSpace = {}
          this.editFace = FACE_TYPE.UNDEFINED
        }
      } else {
        let targetPosition = snapPositionsList.find(snapPosition => {
          return snapPosition.tagSpace.y + snapPosition.tagSpace.h === snapPosition.ownSpace.y
        })
        if (targetPosition) {
          this.addTargetSpace = targetPosition.tagSpace
        }
      }
    },
    /** ドラッグ中のファイルデータ設定 */
    setDraggedFileData: function (draggedFileData) {
      this.draggedFileData = draggedFileData
    },
    /** 表示対象ラジオボタン変更時 */
    onDispSpaceObjectTypesChanged: function () {
      if (this.dispSpaceObjectTypes.includes(OBJECT_TYPE.SETPLAN)) {
        this.dispSpaceObjectTypes.push(OBJECT_TYPE.SETPLAN_FIX)
      }
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {dispSpaceObjectTypes: this.dispSpaceObjectTypes})
    },
    onDispDummyChanged: function () {
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {isDispDummy: this.isDispDummy})
    },
    /** 表示対象ラジオボタン(加工)変更時 */
    onDispProcessChanged: function () {
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {isDispProcess: this.isDispProcess})
    },
    /** 表示対象ラジオボタン(アクセサリー)変更時 */
    onDispAccessoryChanged: function () {
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {isDispAccessory: this.isDispAccessory})
    },
    /** 選択対象ラジオボタン変更時 */
    onSelectModeChanged: function () {
      this.clearEditCtrlSpace()
      this.setOpeMode()
    },
    /** 操作モード設定 */
    setOpeMode: function () {
      // 面間距離モードであれば解除
      this.changeFaceDistanceMode(true, true)
      // モード設定
      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {opeMode: this.opeMode})
    },
    /** 強調表示空間設定※構成タブからのemit用 */
    setFocusedSpace: function (spaceId) {
      this.focusedSpaceId = spaceId
    },
    /** 選択空間設定※構成タブからのemit用 */
    setSelectedSpace: function (spaceId) {
      let globalSpaces = this.globalSpaceMap.get(VIEW_TYPE.FRONT)
      let space = globalSpaces.find(space => space.id === spaceId)
      let actualSpace = {}

      // プランニング中
      if (this.isPlanning) {
        // 一番上にあるセットプランを優先的に探す
        actualSpace = SpaceUtil.getTopParentByCond(space, globalSpaces, space => [OBJECT_TYPE.SETPLAN.code, OBJECT_TYPE.SETPLAN_FIX.code].includes(space.spaceObjectType))

        if (!actualSpace) {
          // なければコンバイン
          actualSpace = SpaceUtil.getParentByCond(space, globalSpaces, space => OBJECT_TYPE.COMBINE.code === space.spaceObjectType)
        }
      }
      // セットプラン編集中
      if (this.isSetPlanning) {
        // コンバインを優先的に探す
        actualSpace = SpaceUtil.getParentByCond(space, globalSpaces, space => OBJECT_TYPE.COMBINE.code === space.spaceObjectType)
      }
      // なければユニット
      if (!actualSpace || !Object.keys(actualSpace).length) {
        actualSpace = SpaceUtil.getParentByCond(space, globalSpaces, space => OBJECT_TYPE.UNIT.code === space.spaceObjectType)
      }
      // 存在したら編集対象として設定
      if (actualSpace && Object.keys(actualSpace).length) {
        this.addEditCtrlSpace(actualSpace.id, false, true)
      }
    },
    /** 図面画面 */
    onPreview: function () {
      if (!this.isPlanning || !this.fileData || !Object.keys(this.fileData).length || !Object.keys(this.fileData.topSpaceModel).length) {
        return
      }
      let childWindow = ''
      if (this.dispTrialUserTools) {
        childWindow = window.open('/#/preview?spaceJoincd=' + this.fileData.spaceJoincd, 'sheet-page', 'width=1420, height=940')
      } else {
        childWindow = window.open('/#/preview', 'sheet-page', 'width=1420, height=940')
      }
      childWindow.location.reload()
    },
    /** 新規作成確認モーダル表示 */
    onNew: function () {
      // ファイル編集中の場合とそうでない場合でメッセージを変える
      let messages = []
      let textAlign = ''
      if (this.fileData.topSpaceModel && Object.keys(this.fileData.topSpaceModel).length) {
        messages = ['ファイルを新規作成しますか？',
          '※現在、編集中のデータがあります。',
          '新たに編集を開始すると編集中の内容はクリアされます。']
        textAlign = 'left'
      } else {
        messages = ['ファイルを新規作成しますか？']
        textAlign = 'center'
      }
      // モーダル表示
      let modalData = {
        messages: messages,
        modalType: 'confirm',
        textAlign: textAlign,
        onOk: function () {
          this.$refs.fileModalRef.createFile(OBJECT_TYPE.PLAN.code, true)
        }.bind(this),
        onCancel: function () {
          this.$refs.fileModalRef.clearElement()
        }.bind(this)
      }
      AppUtil.showModal(modalData)
    },
    /** ファイル編集モーダル表示 */
    showEditFileModal: function (objType, spaceJoincd) {
      if (objType && spaceJoincd) {
        this.$refs.fileModalRef.showEditModal(objType, spaceJoincd)
      } else {
        AppUtil.showModal({
          messages: ['現在編集中のデータが存在しないため選択できません。']
        })
      }
    },
    showProfitSettingModal: function () {
      this.$refs.profitSettingRef.showModal()
    },
    /** ファイル編集モーダル（コンテンツデータタブのみ）表示 */
    showContentsDataModal: function (fileData) {
      if (this.fileData != null && Object.keys(this.fileData).length && this.fileData.fileCode === fileData.fileCode) {
        let modalData = {
          messages: ['現在編集中のデータのため登録できません。'],
          modalType: 'message',
          messageType: 'error'
        }
        AppUtil.showModal(modalData)
        return
      }
      this.$refs.fileModalRef.showContentsDataModal(fileData)
    },
    /** 登録 */
    onSave: function () {
      if (!this.fileData || !Object.keys(this.fileData).length || !Object.keys(this.fileData.topSpaceModel).length) {
        let modalData = {
          messages: ['現在編集中のデータが存在しないため保存できません。'],
          modalType: 'message',
          messageType: 'error'
        }
        AppUtil.showModal(modalData)
        return
      }
      if (this.fileData.forCopy) {
        // 新規作成
        this.onSaveAs(OBJECT_TYPE.PLAN.code, this.fileData.spaceJoincd)
      } else {
        // 保存
        this.$refs.selectUpdateInsertModalRef.showModal()
      }
    },
    /** 名前を付けて保存ボタンクリック時 */
    onSaveAs: function (spaceObjectType, spaceJoincd) {
      this.$refs.fileModalRef.showSaveAsModal(spaceObjectType, spaceJoincd)
    },
    /** APIのレスポンスデータを内部変数に設定 */
    setResponseData: function (response) {
      if (!response || !response.data || !response.data.data || !response.data.data.topSpaceModel) {
        this.fileData = {}
        this.globalSpaceMap = new Map()
        this.clearEditCtrlSpace()
        this.price = 0
        return
      }
      // 空間データ反映
      this.fileData = response.data.data
      // グローバル座標空間マップ生成
      this.createGlobalSpaceMap()
      if (this.editCtrlSpaces.length && this.groupCtrlSpace.spaceJoincd === response.data.data.spaceJoincd) {
        // 編集中空間を再設定
        this.editCtrlSpaces.forEach(e => this.addEditCtrlSpace(e.id, true, true))
      } else {
        this.clearEditCtrlSpace()
      }
      // 断面線設定
      this.setSectionPosition(false)
      this.sectionPoints = this.fileData.sectionPointList

      // 面間距離
      this.selectedFaces = []
      this.faceDistance = null
      // this.getPrice()
      this.price = this.fileData.curPrice
    },
    /** 見積価格設定モーダル表示 */
    showCostCustomModal: function (objType, spaceJoincd) {
      if (!this.fileData || !Object.keys(this.fileData).length || !Object.keys(this.fileData.topSpaceModel).length) {
        let modalData = {
          messages: ['現在編集中のデータが存在しないため選択できません。'],
          modalType: 'message',
          messageType: 'error'
        }
        AppUtil.showModal(modalData)
        return
      }
      this.$refs.setCostCustomModalRef.showModal(objType, spaceJoincd)
    },
    /** 価格データ取得 */
    getPrice: function () {
      axios.get(API_URL.PLANNING + '/price')
        .then(response => {
          if (response.data.errorMessage) {
            AppUtil.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            this.price = response.data.data.curPrice
            this.fileData.curPrice = this.price
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** グローバル座標空間マップ生成 */
    createGlobalSpaceMap: function () {
      // パフォーマンス改善※FRONT + 表示対象ビュー分のみ生成
      const viewTypes = [this.viewSet.main.viewType, this.viewSet.upside.viewType, this.viewSet.side.viewType]
      if (!viewTypes.includes(VIEW_TYPE.FRONT)) viewTypes.unshift(VIEW_TYPE.FRONT)
      this.globalSpaceMap = SpaceUtil.createGlobalSpaceMap(this.fileData, viewTypes, this.objectDataModelMap)
    },
    /** APIのレスポンスのエラーメッセージを設定 */
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: '空間編集エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left',
        onOk: this.getEditingFileData
      }
      AppUtil.showModal(modalData)
    },
    /** 編集対象空間追加 */
    addEditCtrlSpace: function (spaceId, shiftKey = false, force = false) {
      if (!this.globalSpaceMap) return
      let globalSpace = SpaceUtil.getGlobalSpace(spaceId, this.globalSpaceMap)
      if (!globalSpace || !Object.keys(globalSpace).length) {
        this.clearEditCtrlSpace()
        return
      }
      // 編集操作用空間
      let exists = this.editCtrlSpaces.find(e => e.id === spaceId)
      let onlyOne = this.editCtrlSpaces.length === 1
      this.editCtrlSpaces = shiftKey ? this.editCtrlSpaces.filter(e => e.id !== spaceId) : []
      this.prevEditCtrlSpaces = shiftKey ? this.prevEditCtrlSpaces.filter(e => e.id !== spaceId) : []
      if (!exists || (exists && !shiftKey && !onlyOne) || force) {
        this.editCtrlSpaces.push(Object.assign({}, globalSpace))
        this.prevEditCtrlSpaces.push(Object.assign({}, globalSpace))
      }
      // スケルトンが含まれる場合はインフィル・扉除外
      let editCtrlSpacesFiltered = this.editCtrlSpaces.map(e => Object.assign({}, e))
      let existsSkelton = this.editCtrlSpaces.find(space => PLANNING_TYPE.UNIT_SKELTON === space.planningType)
      if (existsSkelton) {
        editCtrlSpacesFiltered = editCtrlSpacesFiltered.filter(space => {
          return ![PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_INFILL, PLANNING_TYPE.UNIT_DOOR].includes(space.planningType)
        })
      }
      this.editCtrlSpaces = editCtrlSpacesFiltered
      // グループ操作用空間
      this.updateGroupCtrlSpace()
      // 編集内部計算用空間
      this.tmpEditCtrlSpaces = this.editCtrlSpaces.map(e => Object.assign({}, e))

      // コンバイン編集時のサーフェスはマイナス空間以外OK
      if (this.isCombineEdit && PLANNING_TYPE.UNIT_SURFACE === globalSpace.planningType) {
        this.editCtrlableArea[spaceId] = { x: 0, y: 0, z: 0 }
      // 棚板の場合接するセル空間を出ないこと
      } else if (!this.isCtrlKey && PLANNING_TYPE.UNIT_SHELF === globalSpace.planningType) {
        // 隣接するセル
        let nextCells = SpaceUtil.getNextCellsOfShelf(this.fileData, globalSpace, this.globalSpaceMap)
        let nextCellArr = Object.keys(nextCells).map(faceType => nextCells[faceType]).filter(space => space !== null)
        // 包括する空間
        let wrapSpace = SpaceUtil.getWrapSpace(nextCellArr)
        wrapSpace.planningType = OBJECT_TYPE.CELL.code
        this.editCtrlableArea[spaceId] = Object.assign({}, wrapSpace)
      // 可動棚の場合、親のセル空間を出ないこと
      } else if (!this.isCtrlKey && PLANNING_TYPE.UNIT_INFILL === globalSpace.planningType) {
        let parentCell = SpaceUtil.getGlobalSpace(globalSpace.parentSpaceId, this.globalSpaceMap)
        // 包括する空間
        let wrapSpace = SpaceUtil.getWrapSpace([parentCell])
        wrapSpace.planningType = OBJECT_TYPE.CELL.code
        this.editCtrlableArea[spaceId] = Object.assign({}, wrapSpace)
      // 引き出しは隣接するセル空間を出ないこと（制約チェック時にセルに隣接する引き出しが重ねることができる空間を考慮してる）
      } else if (!this.isCtrlKey && PLANNING_TYPE.UNIT_DRAWER === globalSpace.planningType) {
        // 隣接するセル
        let nextCells = SpaceUtil.getNextCellsOfDrawer(this.fileData, globalSpace, this.globalSpaceMap)
        let nextCellArr = Object.keys(nextCells).map(faceType => nextCells[faceType]).filter(space => space !== null)
        // 包括する空間
        let wrapSpace = SpaceUtil.getWrapSpace(nextCellArr)
        wrapSpace.planningType = OBJECT_TYPE.CELL.code
        this.editCtrlableArea[spaceId] = Object.assign({}, wrapSpace)
      // プランニング時は、上記以外は自由配置
      } else if (this.isPlanning) {
        this.editCtrlableArea[spaceId] = { x: 0, y: 0, z: 0, d: Number.MAX_VALUE, w: Number.MAX_VALUE, h: Number.MAX_VALUE }
      // セットプランニング時はサーバー側でセットプラン空間の調整をするので上記以外は自由配置
      } else if (this.isSetPlanning) {
        this.editCtrlableArea[spaceId] = { x: 0, y: 0, z: 0, d: Number.MAX_VALUE, w: Number.MAX_VALUE, h: Number.MAX_VALUE }
      // その他の場合、親空間を出ないこと。
      } else {
        // 編集操作用空間が移動できる領域を設定
        let editCtrlSpaceParent = SpaceUtil.getGlobalSpace(globalSpace.parentSpaceId, this.globalSpaceMap)
        this.editCtrlableArea[spaceId] = Object.assign({}, editCtrlSpaceParent)
      }

      // モジュール取得・設定
      if (this.editCtrlSpaces.length === 1) {
        this.moduleAtt = this.fileData.attributeModelList.find(att => {
          return att.attKeycd === ATTRIBUTE_KEY.SP_MODULE && att.spaceId === spaceId
        })
      } else {
        this.moduleAtt = {}
      }

      let doorD = 0
      let globalSpaces = this.globalSpaceMap.get(VIEW_TYPE.FRONT)
      globalSpace.childrenSpaceModel.forEach(childSpace => {
        if (childSpace.spaceObjectType === OBJECT_TYPE.CELL.code) {
          // 扉
          let cellAttr = this.fileData.attributeModelList.find(att => att.spaceId === childSpace.id &&
            att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_DOOR)
          if (cellAttr != null) {
            let door = globalSpaces.find(globalSpace => globalSpace.id != null && globalSpace.id === cellAttr.attValue1)
            if (door != null) {
              if (doorD < door.d) {
                doorD = door.d
              }
            }
          }
          // 引出し前板
          childSpace.childrenSpaceModel.forEach(subSpace => {
            if (subSpace.spaceObjectType === OBJECT_TYPE.CELL.code) {
              let cellAttr = this.fileData.attributeModelList.find(att => att.spaceId === subSpace.id &&
                att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_DOOR)
              if (cellAttr != null) {
                let door = globalSpaces.find(globalSpace => globalSpace.id != null && globalSpace.id === cellAttr.attValue1)
                if (door != null) {
                  if (doorD < door.d) {
                    doorD = door.d
                  }
                }
              }
            }
          })
        }
      })
      this.editChildrenDoor = doorD
    },
    clearEditCtrlSpace: function () {
      this.groupCtrlSpace = {}
      this.prevGroupCtrlSpace = {}
      this.editCtrlSpaces = []
      this.prevEditCtrlSpaces = []
      this.addCtrlSpace = {}
      this.editCtrlableArea = {}
      this.editType = EDIT_TYPE.UNDEFINED
      this.moduleAtt = {}
    },
    selectAllSpace: function () {
      if (this.isPlanning || this.isSetPlanning) {
        // プランの場合はルームの小空間、セットプランの場合はセットプランの子空間が選択の対象
        let childrenSpaces = this.isPlanning
          ? this.fileData.topSpaceModel.childrenSpaceModel[0].childrenSpaceModel
          : this.fileData.topSpaceModel.childrenSpaceModel
        if (childrenSpaces.length > 0) {
          childrenSpaces.forEach(space => {
            // 現在編集対象空間にない空間を、編集対象空間に追加する
            if (this.editCtrlSpaces.map(sp => sp.id).indexOf(space.id) === -1) {
              this.addEditCtrlSpace(space.id, true)
            }
          })
        }
      } else if (this.isCombineEdit) {
        let combineChildren = this.fileData.topSpaceModel.childrenSpaceModel
        if (combineChildren.length === 1) {
          // コンバインの小空間のスケルトンの空間IDを渡す
          this.addEditCtrlSpace(combineChildren[0].id)
        }
      }
    },
    /** 現在編集中ファイルデータクリア */
    clearCurrentFileData: function () {
      this.fileData = {}
      this.globalSpaceMap = new Map()
      this.sectionPoints = []
      this.clearEditCtrlSpace()
      AppUtil.removeLocalStorage(STORAGE_KEY.SPACE_TREE)
    },
    /** グループ操作空間を設定 */
    updateGroupCtrlSpace: function () {
      if (!this.editCtrlSpaces.length) {
        this.groupCtrlSpace = {}
        return
      }
      const { planningType, parentSpaceId, id } = this.editCtrlSpaces[0]
      this.groupCtrlSpace = {
        // 編集操作用空間を包括する空間
        ...SpaceUtil.getWrapSpace(this.editCtrlSpaces),
        spaceJoincd: this.fileData.spaceJoincd,
        // 以下は最初の空間のものを設定
        planningType,
        parentSpaceId,
        id
      }
      if (this.editCtrlSpaces.length === 1) {
        const { umCode, objName } = this.objectDataModelMap[id]
        this.groupCtrlSpace = {
          ...this.groupCtrlSpace,
          umCode,
          objName
        }
      }
    },
    /** 断面位置設定 */
    setSectionPosition: function (force) {
      // 強制設定でない場合
      if (!force &&
        this.sectionPosition.x != null && this.sectionPosition.x >= 0 &&
        this.sectionPosition.y != null && this.sectionPosition.y >= 0 &&
        this.sectionPosition.z != null && this.sectionPosition.z >= 0) {
        return
      }
      if (this.isPlanning || this.isSetPlanning) {
        let tmp = this.fileData.topSpaceModel.childrenSpaceModel[0]
        if (tmp != null && tmp.childrenSpaceModel.length) {
          this.sectionPosition = { x: tmp.w + 100, y: tmp.h + 100, z: tmp.d + 100 }
        } else {
          this.sectionPosition = { x: null, y: null, z: null }
        }
      } else if (this.isCombineEdit) {
        if (this.fileData.topSpaceModel.childrenSpaceModel.length) {
          let tmp = this.fileData.topSpaceModel
          this.sectionPosition = { x: tmp.w + 100, y: tmp.h + 100, z: tmp.d + 100 }
        } else {
          this.sectionPosition = { x: null, y: null, z: null }
        }
      }
    },
    /** 断面位置設定中に設定 */
    setSectionPositionSelectingOn: function (axis) {
      // 面間距離表示/設定モードはOFFに
      this.opeMode.faceDistanceDisp = false
      this.opeMode.faceDistanceMove = false
      this.opeStatus.settingSectionPosition = true
      this.activeSectionPosition = axis
      this.clearEditCtrlSpace()
    },
    /** ビュー表示対象外空間ID設定 */
    setOutOfSectionSpaceId: function (isAdd, viewType, spaceId) {
      if (!this.outOfSectionSpaceIds.hasOwnProperty(viewType.code)) {
        this.outOfSectionSpaceIds[viewType.code] = new Set()
      }
      let spaceIdSet = this.outOfSectionSpaceIds[viewType.code]
      if (isAdd) {
        spaceIdSet.add(spaceId)
      } else {
        spaceIdSet.delete(spaceId)
      }
    },
    /** 面間距離表示/設定モード切り替え時 */
    changeFaceDistanceMode: function (isForDisp, allOff = false) {
      this.clearEditCtrlSpace()
      this.selectTargetFace = Object.assign({}, {space: {}, faceType: FACE_TYPE.UNDEFINED})
      this.selectedFaces = []
      this.positionGuideLines = []
      if ((isForDisp && this.opeMode.faceDistanceDisp) || allOff) this.opeMode.faceDistanceMove = false
      if ((!isForDisp && this.opeMode.faceDistanceMove) || allOff) this.opeMode.faceDistanceDisp = false
      if (this.opeMode.faceDistanceDisp && !this.dispSpaceObjectTypes.includes(OBJECT_TYPE.PARTS.code)) {
        // パーツ空間を強制表示
        this.dispSpaceObjectTypes.push(OBJECT_TYPE.PARTS.code)
        this.onDispSpaceObjectTypesChanged()
      }
      if (this.opeMode.faceDistanceMove && !this.dispSpaceObjectTypes.includes(OBJECT_TYPE.UNIT.code)) {
        // ユニット空間を強制表示
        this.dispSpaceObjectTypes.push(OBJECT_TYPE.UNIT.code)
        this.onDispSpaceObjectTypesChanged()
      }
    },
    /** 価格/加工自動更新モード切り替え */
    changeAutoUpdateMode () {
      this.opeMode.autoUpdate = !this.opeMode.autoUpdate
      this.setOpeMode()
      this.opeMode.autoUpdate === true && this.getEditingFileDataWithLoadingModal()
    },
    /** ローカルストレージに保存しておいた画面操作状態を反映 */
    loadPageCondition: function () {
      let storage = AppUtil.getLocalStorage(STORAGE_KEY.PLANNING)
      // タブ
      if (storage.mainTabIdx >= 0) {
        // タブ制御
        let mainTabList = document.querySelectorAll('#main_tab_area ul li:not(.arrow)')
        mainTabList.forEach(tab => tab.classList.remove('active'))
        let mainTab = mainTabList[storage.mainTabIdx]
        if (mainTab == null) {
          mainTabList[0].classList.add('active')
        } else {
          mainTab.classList.add('active')
        }
        // コンテンツ制御
        let mainContentsList = document.querySelectorAll('.main_tab_contents')
        mainContentsList.forEach(contents => contents.classList.remove('show'))
        let mainContent = mainContentsList[storage.mainTabIdx]
        if (mainContent == null) {
          mainContentsList[0].classList.add('show')
        } else {
          mainContent.classList.add('show')
        }
      }
      // ビュー
      if (storage.viewSetNo) this.viewSet = VIEW_SET.find(viewSet => viewSet.no === storage.viewSetNo)
      // ズーム
      if (storage.svgZoomRatio) this.svgZoomRatio = storage.svgZoomRatio
      // 操作モード
      if (storage.opeMode) {
        // 面間距離モードは上書きしない
        delete storage.opeMode.faceDistanceDisp
        delete storage.opeMode.faceDistanceMove
        this.opeMode = Object.assign(this.opeMode, storage.opeMode)
      }
      // 表示対象
      if (storage.dispSpaceObjectTypes) this.dispSpaceObjectTypes = Object.assign([], storage.dispSpaceObjectTypes)
      if (storage.isDispProcess) this.isDispProcess = storage.isDispProcess
      if (storage.isDispAccessory) this.isDispAccessory = storage.isDispAccessory
      // 断面位置
      if (storage.sectionPosition) this.sectionPosition = Object.assign({}, storage.sectionPosition)
    },
    /** 自身、もしくは子空間に固定棚を持つか */
    isShelfOrHasChildShelf (space) {
      const { planningType, childrenSpaceModel, parentSpaceId, spaceObjectType } = space
      switch (planningType) {
        // コンバイン内のスケルトンの子空間のセルに棚が一つ以上あるか
        case PLANNING_TYPE.COMBINE:
          return childrenSpaceModel[0].planningType === PLANNING_TYPE.UNIT_SKELTON && this.isShelfOrHasChildShelf(childrenSpaceModel[0])
        // 子空間のセルに棚が一つ以上あるか
        case PLANNING_TYPE.UNIT_SKELTON:
          return childrenSpaceModel.filter(space => space.spaceObjectType === OBJECT_TYPE.CELL.code).length === 1 &&
            childrenSpaceModel.filter(space => space.spaceObjectType === OBJECT_TYPE.CELL.code)[0].childrenSpaceModel
              .filter(space => space.planningType === PLANNING_TYPE.UNIT_SHELF).length > 0
        // 親空間がセルでかつその子空間(固定棚の兄弟関係)にセル空間が一つ以上あるか
        case PLANNING_TYPE.UNIT_SHELF:
          const targetParent = SpaceUtil.searchSpaceTree(parentSpaceId, this.fileData.topSpaceModel)
          const targetCells = targetParent.childrenSpaceModel.filter(e => e.spaceObjectType === OBJECT_TYPE.CELL.code)
          return !!targetCells.length
        default:
          break
      }
      if (spaceObjectType === OBJECT_TYPE.CELL.code) {
        // 子空間に棚が一つ以上あるか
        return childrenSpaceModel.filter(space => space.planningType === PLANNING_TYPE.UNIT_SHELF).length > 0
      }
      return false
    },
    /** 親が可動棚のパーツか */
    isShelfParts (space) {
      const { parentSpaceId } = space
      const targetParent = SpaceUtil.searchSpaceTree(parentSpaceId, this.fileData.topSpaceModel)
      if (targetParent.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_MOBILE_SHELF.code) {
        return true
      }
      return false
    },
    // *****************************************************************
    // API呼出し系
    // *****************************************************************
    /** ファイルデータ取得 */
    loadFile: function (params) {
      this.copiedSpaceIds = []
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.PLANNING + '/' + params.spaceJoincd)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            AppUtil.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            this.setResponseData(response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** ローディングモーダルを表示して編集中ファイルデータ取得 */
    getEditingFileDataWithLoadingModal () {
      this.$refs.loadingModalRef.showModal(true)
      this.getEditingFileData()
    },
    /** 編集中ファイルデータ取得 */
    getEditingFileData: function () {
      this.isLoadingEditFile = true
      axios.get(API_URL.PLANNING + '/edit')
        .then(response => {
          this.isLoadingEditFile = false
          // 表示ファイル一覧も取得済みならローディングを消す
          this.setResponseData(response)
          if (!this.isLoading) {
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          this.isLoadingEditFile = false
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 編集中ファイルデータ登録 */
    saveFileData: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.closeSelectUpdateInsertModal()
      axios.post(API_URL.PLANNING + '/save', {})
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['保存しました。'],
            onOk: () => { // アロー関数でthisを束縛
              // 編集中空間データクリア
              this.clearCurrentFileData()
            }
          }
          AppUtil.showModal(modalData)
          // 一覧リロード
          this.$refs.selectUnit.init()
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** ファイルデータ削除 */
    deleteFile: function (params) {
      // 送信データ
      let payload = {
        spaceJoincd: params.spaceJoincd
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/delete-file', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            AppUtil.showModal({
              messages: ['ファイルデータを削除しました。']
            })
            this.$refs.selectUnit.init()
            if (this.fileData && params.spaceJoincd === this.fileData.spaceJoincd) {
              // 編集中空間データクリア
              this.clearCurrentFileData()
            }
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 編集中空間データ送信 */
    editSpace: function () {
      // 編集中空間データが存在しない場合は処理なし
      if (!this.editCtrlSpaces.length || ![EDIT_TYPE.MOVE, EDIT_TYPE.RESIZE].includes(this.editType) || !Object.keys(this.currentView).length) {
        return
      }

      // サーフェス配置時個別処理
      if (this.editCtrlSpaces.length === 1) {
        this.setSurface(this.editCtrlSpaces[0])
      }

      // 送信データ
      let payload = {
        spaceJoincd: this.fileData.spaceJoincd,
        spaceIds: this.editCtrlSpaces.map(space => space.id),
        editType: this.editType,
        attachFaceType: this.editFace,
        viewType: this.currentView.code,
        destSpaceId: this.addTargetSpace ? this.addTargetSpace.id : null,
        x: this.editCtrlSpaces[0].x,
        y: this.editCtrlSpaces[0].y
      }

      // リサイズ時の扉のリサイズ先セルの処理
      if (this.editType === EDIT_TYPE.RESIZE) {
        let destCell = SpaceUtil.getDestCellOfDoor(this.snapPositions, this.editCtrlSpaces, this.fileData, this.globalSpaceMap)
        if (destCell != null) {
          payload.destSpaceId = destCell.id
        }
      }

      // 移動量算出
      let prevEditCtrlSpace = this.prevEditCtrlSpaces.find(e => e.id === this.editCtrlSpaces[0].id)
      if (EDIT_TYPE.MOVE === this.editType) {
        payload.dx = this.editCtrlSpaces[0].x - prevEditCtrlSpace.x
        payload.dy = this.editCtrlSpaces[0].y - prevEditCtrlSpace.y
        payload.dz = this.editCtrlSpaces[0].z - prevEditCtrlSpace.z
        payload.autoUpdate = this.opeMode.autoUpdate
      } else if (EDIT_TYPE.RESIZE === this.editType) {
        let currentFacePosition = FaceUtil.getFacePosition(this.editCtrlSpaces[0], this.editFace)
        let prevFacePosition = FaceUtil.getFacePosition(prevEditCtrlSpace, this.editFace)
        let amount = currentFacePosition - prevFacePosition
        // リサイズ距離が0だったら処理終了
        if (amount === 0) return
        payload.resizeInfo = [{faceType: this.editFace, amount: amount}]
        payload.autoUpdate = this.opeMode.autoUpdate
      }

      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + (EDIT_TYPE.MOVE === this.editType ? '/move' : '/resize'), payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            // エラーメッセージ表示
            this.handleErrorMessage(response)
          } else {
            // 更新後データ設定
            this.setResponseData(response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間追加 */
    addSpace: function () {
      let addSpacePlanningType = this.draggedFileData.topSpaceModel.planningType
      let locateAddCtrlSpace = SpaceUtil.getLocateAddCtrlSpace(this.addCtrlSpace, this.addTargetSpace, this.globalSpaceMap, this.viewSet.main)
      // 送信データ
      let payload = {
        destSpaceJoincd: this.fileData.spaceJoincd, // 追加される空間の空間ジョインコード
        destSpaceId: this.addTargetSpace.id, // 追加されるセル空間の空間ID
        srcSpaceJoincd: this.draggedFileData.spaceJoincd, // 追加する空間の空間ジョインコード
        autoUpdate: this.opeMode.autoUpdate,
        viewType: this.currentView.code,
        faceType: this.editFace,
        px: Math.round(this.currentPointOnCanvas.x),
        py: Math.round(this.currentPointOnCanvas.y),
        x: locateAddCtrlSpace.x,
        y: locateAddCtrlSpace.y,
        z: locateAddCtrlSpace.z
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/add', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            // エラーメッセージ表示
            this.handleErrorMessage(response)
          } else {
            // 更新後データ設定
            this.setResponseData(response)
            // 追加した空間に合わせて選択モードを設定する
            switch (addSpacePlanningType) {
              case PLANNING_TYPE.UNIT:
              case PLANNING_TYPE.UNIT_SKELTON:
              case PLANNING_TYPE.UNIT_SHELF:
              case PLANNING_TYPE.UNIT_SURFACE:
              case PLANNING_TYPE.UNIT_FACE_OPTION:
              case PLANNING_TYPE.COMBINE:
              case PLANNING_TYPE.ACCESSORY:
                this.opeMode.selectMode = SELECT_MODE.CABINET.code
                break
              case PLANNING_TYPE.UNIT_DOOR:
              case PLANNING_TYPE.UNIT_DRAWER:
              case PLANNING_TYPE.UNIT_INFILL:
                this.opeMode.selectMode = SELECT_MODE.DOOR_DRAWER_INFILL.code
                break
            }
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間上書き */
    swapSpace: function () {
      let addSpacePlanningType = this.draggedFileData.topSpaceModel.planningType
      // 送信データ
      let payload = {
        destSpaceId: this.addTargetSpace.id, // 上書きされるセル空間の空間ID
        srcSpaceJoincd: this.draggedFileData.spaceJoincd // 上書きする空間の空間ジョインコード
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/swap', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            // エラーメッセージ表示
            this.handleErrorMessage(response)
          } else {
            // 更新後データ設定
            this.setResponseData(response)
            // 上書きした空間に合わせて選択モードを設定する
            switch (addSpacePlanningType) {
              case PLANNING_TYPE.UNIT:
              case PLANNING_TYPE.UNIT_SKELTON:
              case PLANNING_TYPE.UNIT_SHELF:
              case PLANNING_TYPE.UNIT_SURFACE:
              case PLANNING_TYPE.UNIT_FACE_OPTION:
              case PLANNING_TYPE.COMBINE:
              case PLANNING_TYPE.ACCESSORY:
                this.opeMode.selectMode = SELECT_MODE.CABINET.code
                break
              case PLANNING_TYPE.UNIT_DOOR:
              case PLANNING_TYPE.UNIT_DRAWER:
              case PLANNING_TYPE.UNIT_INFILL:
                this.opeMode.selectMode = SELECT_MODE.DOOR_DRAWER_INFILL.code
                break
            }
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間削除 */
    deleteSpace: function () {
      if (!this.editCtrlSpaces.length) {
        AppUtil.showModal({
          messages: ['削除対象を選択して下さい。']
        })
        return
      }
      // 送信データ
      let payload = {
        spaceJoincd: this.fileData.spaceJoincd, // 空間削除するファイルデータの空間ジョインコード
        autoUpdate: this.opeMode.autoUpdate,
        spaceIds: this.editCtrlSpaces.map(space => space.id) // 削除される空間の空間ID
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/delete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.setResponseData(response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間コピー */
    copySpace: function () {
      if (!this.fileData || !Object.keys(this.fileData).length) return

      if (this.isCombineEdit) {
        AppUtil.showModal({
          messages: ['コンバインを編集中は空間コピーが出来ません。']
        })
        return
      }
      if (this.editCtrlSpaces.filter(space =>
        [PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_DOOR]
          .includes(space.planningType)).length > 0) {
        AppUtil.showModal({
          messages: ['空間コピーが出来るのはスケルトンかコンバインかカウンターかパネルです。']
        })
        return
      }

      this.copiedSpaceIds = this.editCtrlSpaces.map(e => e.id)
      // 送信データ
      let payload = {
        spaceIds: this.copiedSpaceIds,
        isMoveCopy: false
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/copy', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間貼り付け */
    pasteSpace: function (withPosition = false, isMoveCopy = false, addTargetSpace = null) {
      // プランニング時以外は対象外
      if (this.isCombineEdit) {
        AppUtil.showModal({
          messages: ['コンバインを編集中は空間の貼り付けが出来ません。']
        })
        return
      }
      // ルームの子空間IDを前もって保持
      let prevTargetScapece = []
      if (this.isPlanning) {
        prevTargetScapece = this.fileData.topSpaceModel.childrenSpaceModel[0].childrenSpaceModel
      } else if (this.isSetPlanning) {
        prevTargetScapece = this.fileData.topSpaceModel.childrenSpaceModel
      }
      let prevChildrenIds = prevTargetScapece.map(space => space.id)
      // 送信データ
      let payload = {
        spaceIds: this.copiedSpaceIds,
        autoUpdate: this.opeMode.autoUpdate,
        isMoveCopy: isMoveCopy
      }

      // 貼り付け位置指定の場合
      if (!isMoveCopy) {
        if (withPosition) {
          // グループコントロール空間の更新
          this.updateGroupCtrlSpace()
          payload = Object.assign(payload, {
            x: this.groupCtrlSpace.x,
            y: this.groupCtrlSpace.y,
            z: this.groupCtrlSpace.z
          })
        }
      } else {
        // 追加先空間がない場合はカーソル位置から空間を取得
        if (addTargetSpace.id == null) {
          addTargetSpace = SpaceUtil.getEditTargetSpace(
            this.globalSpaceMap,
            VIEW_TYPE.FRONT,
            this.svgZoomRatio,
            this.currentPointOnCanvas,
            this.currentViewRotate,
            this.outOfSectionSpaceIds,
            [OBJECT_TYPE.UNIT.code, OBJECT_TYPE.COMBINE.code],
            this.selectablePlanningTypes
          )
        }
        // 対象が引き出しに重なっている場合
        if (addTargetSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_DRAWER.code) {
          let nextCells = SpaceUtil.getNextCellsOfDrawer(this.fileData, addTargetSpace, this.globalSpaceMap)
          let top = nextCells.top
          let bottom = nextCells.bottom
          // 近いセルに振替
          if (top !== null && bottom !== null) {
            let topDist = top !== null ? Math.abs(top.y - this.currentPointOnCanvas.y) : null
            let bottomDist = bottom !== null ? Math.abs(bottom.y + bottom.h - this.currentPointOnCanvas.y) : null
            addTargetSpace = topDist <= bottomDist ? top : bottom
          } else {
            addTargetSpace = top !== null ? top : bottom !== null ? bottom : addTargetSpace
          }
        }
        let locateAddCtrlSpace = SpaceUtil.getLocateAddCtrlSpace(this.editCtrlSpaces[0], addTargetSpace, this.globalSpaceMap, this.viewSet.main)
        payload = Object.assign(payload, {
          destSpaceId: addTargetSpace.id, // 追加先空間ID
          destSpaceJoincd: addTargetSpace.spaceJoincd, // コピー先空間ジョインコード
          spaceJoincd: this.fileData.spaceJoincd, // 追加先空間ジョインコード
          viewType: this.currentView.code,
          faceType: this.editFace,
          px: Math.round(this.currentPointOnCanvas.x),
          py: Math.round(this.currentPointOnCanvas.y),
          x: locateAddCtrlSpace.x,
          y: locateAddCtrlSpace.y,
          z: locateAddCtrlSpace.z
        })
      }

      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/paste', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else if (response.data.data) {
            this.setResponseData(response)
            // 編集対象空間は貼り付け空間
            if (isMoveCopy) {
              this.addEditCtrlSpace(this.fileData.lastAddedSpace.id, false, true)
            } else {
              let targetScapeces = []
              if (this.isPlanning) {
                targetScapeces = this.fileData.topSpaceModel.childrenSpaceModel[0].childrenSpaceModel
              } else if (this.isSetPlanning) {
                targetScapeces = this.fileData.topSpaceModel.childrenSpaceModel
              }
              let newEditCtrlSpaceIds = targetScapeces
                .map(space => space.id)
                .filter(id => !prevChildrenIds.includes(id))
              this.editCtrlSpaces = []
              newEditCtrlSpaceIds.forEach(id => this.addEditCtrlSpace(id, true, true))
            }
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 空間コピー&ペースト */
    copyAndPasteSpace: function (addTargetSpace) {
      let isMoveCopy = false
      // 移動コピー対象ユニット
      let isPlanningType = [PLANNING_TYPE.UNIT_SHELF, PLANNING_TYPE.UNIT_DRAWER, PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_INFILL]
      let targetPlanningType = this.editCtrlSpaces.filter(space => isPlanningType.includes(space.planningType)).length > 0

      if (!this.isCtrlKey && targetPlanningType) {
        // 棚、引き出し、扉は通常コピー対象外
        return
      } else if (this.isCtrlKey && targetPlanningType) {
        // Ctrlキー押下 + 対象ユニット + D&D => 移動コピー
        isMoveCopy = true
      }

      // コピーした後
      this.copiedSpaceIds = this.editCtrlSpaces.map(e => e.id)
      let payload = {
        spaceIds: this.copiedSpaceIds,
        isMoveCopy: isMoveCopy
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/copy', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
          // ペースト
          this.pasteSpace(true, isMoveCopy, addTargetSpace)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** コマンド実行 */
    undo: function () {
      this.sendCommand('UNDO')
    },
    redo: function () {
      this.sendCommand('REDO')
    },
    sendCommand: function (cmdType) {
      if (!this.fileData || !this.fileData.topSpaceModel) return
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.COMMAND, {
        cmdType: cmdType,
        isAutoUpdate: this.opeMode.autoUpdate
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        this.getEditingFileData()
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /** 吸着ルールマスタ取得 */
    getSnapRule: function () {
      axios.get(API_URL.PLANNING + '/snap')
        .then(response => {
          this.snapRule = response.data.data
        }).catch(error => {
          Api.handleError(error)
        })
    },
    addSectionPoint: function (axis, pos) {
      let param = {
        spaceJoincd: this.fileData.spaceJoincd,
        axis: axis,
        pos: pos
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/sectionPoint/add', param)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.data) {
            this.sectionPoints.push(response.data.data)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    updateSectionPoint: function (lineNo, pos) {
      let param = {
        spaceJoincd: this.fileData.spaceJoincd,
        lineNo: lineNo,
        pos: pos
      }
      axios.post(API_URL.PLANNING + '/sectionPoint/update', param)
        .then(response => {
          if (response.data.data) {
            this.sectionPoints = response.data.data
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    removeSectionPoint: function (lineNo) {
      let param = {
        spaceJoincd: this.fileData.spaceJoincd,
        lineNo: lineNo
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/sectionPoint/remove', param)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.data) {
            this.sectionPoints = response.data.data
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    // *****************************************************************
    // サイドナビタブ切替え
    // *****************************************************************
    /** メインタブコンテンツ表示切替え */
    onClickMainTab: function (tabIdx) {
      // コンテンツ制御
      let mainContentsList = document.querySelectorAll('.main_tab_contents')
      mainContentsList.forEach(contents => contents.classList.remove('show'))
      mainContentsList[tabIdx].classList.add('show')
      this.changeSpaceTreeFlg(tabIdx)

      AppUtil.addLocalStorage(STORAGE_KEY.PLANNING, {mainTabIdx: tabIdx})
    },
    /** 構成ツリー表示ステータスを更新 */
    changeSpaceTreeFlg: function (idx) {
      if (idx !== 1) return
      if (this.spaceTreeFlg === false) {
        this.$refs.spaceTreeRef.openDefault()
      }
      this.spaceTreeFlg = true
    },
    /** 構成ツリー表示ステータスを初期化 */
    clearSpaceTreeFlg: function () {
      this.spaceTreeFlg = false
    },
    /** タブスクロール */
    scrollTab: function (event, isLeft) {
      const scrollAmount = 100
      event.target.parentElement.scrollLeft += (isLeft ? -1 : 1) * scrollAmount
    },
    /** スクロールボタン設定※スクロール領域がある場合、スタイルクラスを設定 */
    setTabScroll: function () {
      this.$nextTick(function () {
        let tabRowList = Array.prototype.slice.call(document.getElementsByClassName('tab_row'))
        tabRowList.forEach(tabRow => {
          if (tabRow.clientWidth < tabRow.scrollWidth) {
            tabRow.classList.add('with_scroll')
          } else {
            tabRow.classList.remove('with_scroll')
          }
        })
      })
    },
    /** 可変領域の値をセットする */
    setVariableField: function () {
      // 可変領域である、ヘッダメニューとサイドタブの領域を取得する
      this.menuHeight = document.getElementById('header-menu').clientHeight
      this.contentHeight = document.getElementById('header-menu').clientHeight
      this.sideTabWidth = document.getElementById('side_tab_nav').clientWidth
    },
    /** シリーズデータを新規登録モーダルに渡す */
    setSelectSeries: function (obj) {
      this.series = obj
    },
    /** 新規モード選択モーダルを閉じる */
    closeSelectSpaceModal: function () {
      this.$refs.SelectSaveTypeModalRef.modalShown = false
    },
    /** 上書き・名前を付けて保存選択モーダルを閉じる */
    closeSelectUpdateInsertModal: function () {
      this.$refs.selectUpdateInsertModalRef.modalShown = false
    },
    /** 被せ設定モーダル表示 */
    showSetDoorWrapModal: function () {
      this.$refs.setDoorWrapModalRef.showModal()
    },
    /** ファイル一覧リスト呼び出し */
    getAllFileList: function () {
      this.$refs.selectUnit.getFileDataList()
    },
    /** 水平方向にリサイズ */
    resizeSpacesEven: function () {
      if (!this.editCtrlSpaces) {
        AppUtil.showModal({
          messages: ['リサイズする空間を選択してください。']
        })
        return
      }
      let spaceIds = this.editCtrlSpaces.map(space => space.id)
      if (spaceIds.length < 2) return
      let payload = {
        axisType: AXIS_TYPE.X,
        spaceIds: spaceIds // 整列される空間の空間ID
      }
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/resize-even', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.setResponseData(response)
            AppUtil.showModal({
              messages: ['リサイズしました。']
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** サイズ設定モーダル表示 */
    showSetSizeModal: function () {
      this.$refs.setSizeModalRef.showModal()
    },
    /** 移動設定モーダル表示 */
    showSetMovingModal: function () {
      this.$refs.setMovingModalRef.showModal()
    },
    /** カラー設定モーダル表示 */
    showSetColorModal: function () {
      if (!this.editCtrlSpaces.length > 0 && !this.focusedMenuSpace) return
      this.getOwnColorStyle()
    },
    /** パーツ選択モーダル表示 */
    showSetSelectPartsModal: function () {
      this.$refs.setSelectPartsRef.showModal()
    },
    /** 加工モーダル表示 */
    showFaceOptionModal: function () {
      this.$refs.setFaceOptionRef.showModal()
    },
    /** 加工ルールモーダル表示 */
    showPosRuleModal: function () {
      this.$refs.setPosRuleRef.showModal()
    },
    /** 選択中加工の変更 */
    changeFocusProcess: function (id) {
      this.focusedProcessId = id
    },
    /** 木目設定表示 */
    showElGrainModal: function () {
      this.isShowElGrain = true
      if (this.isFocusedParts) {
        this.$refs.setElGrainRef.showModal()
      } else if (this.isFocusedPartsParent) {
        this.$refs.setElGrainRef.showAllPartsModal()
      }
    },
    /** 素材空間設定表示 */
    showMaterialModal: function () {
      this.isShowMaterial = true
      this.$refs.setMaterialRef.showModal()
    },
    /** カウンター/サーフェス収まり設定表示 */
    showSurfaceLedgeModal: function () {
      this.isShowSurfaceLedge = true
      this.$refs.setSurfaceLedgeRef.showModal()
    },
    /** 指定パーツ位置モーダル表示 */
    showPartsFacerelationModal: function () {
      this.$refs.setPartsFacerelationRef.showModal()
    },
    /** 特注価格設定表示 */
    showCustomPriceModal: function () {
      this.$refs.setCustomPriceRef.showModal()
    },
    /** 任意コメント設定表示 */
    showCustomCommentModal: function () {
      this.$refs.setCustomCommentRef.showModal()
    },
    /** アップデート確認モーダル表示 */
    showUpdateByUmcodeModal: function (id) {
      let object = this.objectDataModelMap[this.focusedMenuSpace.id]
      let modalData = {
        messages: [object.umCode + ' を最新のデータに更新しますがよろしいですか？'],
        modalType: 'confirm',
        onOk: this.updateByUmcode,
        onCancel: this.closeTreeContextModal,
        callbackParams: {
          spaceId: this.focusedMenuSpace.id,
          umCode: null
        }
      }
      AppUtil.showModal(modalData)
    },
    updateByUmcode: function (id) {
      // 送信
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/update/space', id)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.setResponseData(response)
            AppUtil.showModal({
              messages: ['更新しました。']
            })
          }
          this.closeTreeContextModal()
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
          this.closeTreeContextModal()
        })
    },
    /** 左ペインメニューからの設定非表示 */
    closeTreeContextModal: function () {
      this.isShowTreeContextMenu = false
      this.clearFocusedParts()
    },
    /** ローディングモーダルの表示 */
    showLoadingModal: function () {
      this.$refs.loadingModalRef.showModal(true)
    },
    /** ローディングモーダル非表示 */
    closeLoadingModal: function () {
      this.$refs.loadingModalRef.showModal(false)
    },
    /** 新規納入先登録モーダル表示 */
    showNewBusinessModal: function () {
      this.$refs.businessModalRef.showNewModal()
    },
    /** 納入先編集モーダル表示 */
    showEditBusinessModal: function (data) {
      this.$refs.businessModalRef.showEditModal(data)
    },
    /** 納入先の取得 */
    getBusinessList: function () {
      this.$refs.fileModalRef.resetBusiness()
    },
    /** パーツフォーカスフラグの初期化 */
    clearFocusedParts: function () {
      if (!this.isShowTreeContextMenu) {
        this.focusedMenuSpace = null
      }
      this.isFocusedUnit = false
      this.isFocusedParts = false
      this.isFocusedPartsParent = false
      this.isFocusedSurface = false
      this.isFocusedMobileShelfParts = false
      this.isFocusedUmcodeSpace = false
      this.isFocusedOneRelatedToShelf = false
      this.focusedProcessId = null
    },
    /** 構成ツリーで編集対象空間を表示 */
    openTreeBySpaceId: function () {
      if (this.spaceTreeFlg === false) return
      let spaceIdList = []
      let editIds = this.editCtrlSpaces.map(s => { return s.id })
      if (editIds.length > 0) {
        this.editCtrlSpaces.forEach(space => {
          spaceIdList.push(space.id)
          this.addParentId(space, spaceIdList)
          this.$refs.spaceTreeRef.openBySpaceId(spaceIdList, editIds)
        })
      } else {
        this.$refs.spaceTreeRef.openBySpaceId([], [])
      }
    },
    /** 親空間のIDを取得 */
    addParentId: function (space, spaceList) {
      if (space.parentSpaceId === null || space.parentSpaceId === '') return
      spaceList.push(space.parentSpaceId)
      let parent = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(s => s.id === space.parentSpaceId)
      if (parent) {
        this.addParentId(parent, spaceList)
      }
    },
    /** セットプランへ追加 */
    addSetPlan: function () {
      if (!this.isCabinetMultiSelected) {
        AppUtil.showModal({
          messages: ['セットプランに追加する空間を2つ以上選択してください']
        })
        return
      }
      let spaceIds = this.editCtrlSpaces.map(space => space.id)
      if (spaceIds.length < 2) return
      this.$refs.fileModalRef.showCreateModal(this.fileData, OBJECT_TYPE.SETPLAN_FIX.code, this.fileData.spaceJoincd, spaceIds, AXIS_TYPE.UNDEFINED)
    },
    /** ルール付きセットプランへ追加 */
    addRuledSetPlan: function () {
      if (!this.isRuledSetTargetSelected) {
        AppUtil.showModal({
          messages: ['セットプランに追加する空間を2つ以上選択してください']
        })
        return
      }
      // 比率設定方向を判定
      if (this.editCtrlSpaces.length < 2) return
      let axiosType = AXIS_TYPE.UNDEFINED
      if (SpaceUtil.isRuledSetByWidth(this.editCtrlSpaces)) {
        axiosType = AXIS_TYPE.X
        this.editCtrlSpaces.sort((a, b) => a.x - b.x)
      } else if (SpaceUtil.isRuledSetByHeight(this.editCtrlSpaces)) {
        axiosType = AXIS_TYPE.Y
        this.editCtrlSpaces.sort((a, b) => b.y - a.y)
      } else if (SpaceUtil.isRuledSetByDepth(this.editCtrlSpaces)) {
        axiosType = AXIS_TYPE.Z
        this.editCtrlSpaces.sort((a, b) => b.z - a.z)
      }
      let spaceIds = this.editCtrlSpaces.map(space => space.id)
      this.$refs.fileModalRef.showCreateModal(this.fileData, OBJECT_TYPE.SETPLAN.code, this.fileData.spaceJoincd, spaceIds, axiosType)
    },
    /** コンバインへ追加 */
    addCombine: function () {
      if (!this.isOneSkeltonSelected) {
        AppUtil.showModal({
          messages: ['コンバインに追加する空間を1つ選択してください']
        })
        return
      }
      let spaceIds = this.editCtrlSpaces.map(space => space.id)
      if (spaceIds.length !== 1) return
      this.$refs.fileModalRef.showCreateModal(this.fileData, OBJECT_TYPE.COMBINE.code, this.fileData.spaceJoincd, spaceIds, AXIS_TYPE.UNDEFINED)
    },
    /** 空間を分解 */
    decomposeSpace: function (isCombine, isAllAtOnce = false) {
      this.$refs.loadingModalRef.showModal(true)
      let isValidDecomposeCom = isCombine && !this.isOneCombineSelected
      let isValidDecomposeSP = !isCombine && !this.isOneSetPlanSelected
      if (isValidDecomposeCom || isValidDecomposeSP) {
        let message = isValidDecomposeCom
          ? '分解するコンバインの空間を一つ選択してください'
          : '分解するセットプランの空間を一つ選択してください'
        AppUtil.showModal({
          messages: [message]
        })
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      let payload = {
        spaceJoincd: this.fileData.spaceJoincd,
        spaceId: this.editCtrlSpaces[0].id,
        isAllAtOnce
      }
      axios.post(API_URL.PLANNING + '/decompose-space', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.setResponseData(response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    onClickMenuToggle: function (dispState) {
      // 表示に合わせてCanvasサイズを変更
      if (dispState) {
        this.updateCanvasHeight(this.menuHeight)
      } else {
        this.updateCanvasHeight(-this.menuHeight)
      }
      // 表示のON/OFF
      this.isDispMenu = dispState
    },
    onClickContentToggle: function (dispState) {
      // 表示に合わせてCanvasサイズを変更
      if (dispState) {
        // 表示
        this.updateCanvasHeight(this.contentHeight)
      } else {
        // 非表示
        this.updateCanvasHeight(-this.contentHeight)
      }
      // 表示のON/OFF
      this.isDispContent = dispState
    },
    onClickSideTabToggle: function (dispState) {
      // 表示に合わせてCanvasサイズを変更
      if (dispState) {
        // 表示
        this.updateCanvasWidth(this.sideTabWidth)
      } else {
        // 非表示
        this.updateCanvasWidth(0)
      }
      // 表示のON/OFF
      this.isDispSideTab = dispState
    },
    updateCanvasHeight: function (size) {
      this.canvasHeight = this.canvasHeight + size
      // canvasの再描画
      this.$nextTick(function () {
        this.adjustViewBox()
      })
    },
    updateCanvasWidth: function (size) {
      this.canvasWidth = size
      // canvasの再描画
      this.$nextTick(function () {
        this.adjustViewBox()
      })
    },
    setOnSideTab: function (flag) {
      this.isOnSIdeTab = flag
    },
    getOwnColorStyle: function () {
      this.ownColorStyle = {}
      // 送信
      let targetId = this.focusedMenuSpace != null ? this.focusedMenuSpace.id : this.editCtrlSpaces[0].id
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.PLANNING + '/get-own-color-style/' + targetId)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.ownColorStyle = response.data.data
            this.$refs.setColorModalRef.showModal()
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 寸法のフォーマット */
    round: function (num) {
      return CalcUtil.round(num)
    },
    getImage: function (image) {
      return AppUtil.getDarosResource(image)
    }
  },
  /** props,computed利用可能。DOMへのアクセス不可 */
  created: function () {
    // 編集中ファイルデータ取得
    this.getEditingFileData()
    // 吸着マスタ取得
    this.getSnapRule()
  },
  /** created+DOMへのアクセス可 */
  mounted: function () {
    this.addPlanningEventListener()
    // リサイズは当コンポーネント生成時からずっと有効とし、他のコンポーネントから制御不可とする。
    window.addEventListener('resize', this.onResize)
    // 画面編集状態取得/反映
    this.loadPageCondition()
    // メインタブスクロール設定
    this.setTabScroll()
    // 可変領域のサイズを取得
    this.setVariableField()
    // SVGサイズ設定
    this.adjustViewBox()
  },
  beforeDestroy: function () {
    this.removePlanningEventListener()
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
<style src="../css/planning/planning.scss" lang="scss" scoped></style>
<style src="../css/planning/side_tab_nav.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#planning {
  background: #fff;
  height: 100%;
  min-height: 510px;
}
.planning-off {
  pointer-events: none;
}
#stalking-rect {
  position: fixed;
  z-index: 2;
  border: dashed 2px black;
  display: none;
  width: 50px;
  height: 50px;
  /* 追従図形のイベント透過 */
  pointer-events: none;
}
.debug {
  li {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Planning.vue